var Zc = Object.defineProperty, Gc = Object.defineProperties;
var Ic = Object.getOwnPropertyDescriptors;
var ii = Object.getOwnPropertySymbols;
var Gn = Object.prototype.hasOwnProperty, In = Object.prototype.propertyIsEnumerable;
var Ss = (s, e) => (e = Symbol[s]) ? e : Symbol.for("Symbol." + s), Sc = (s) => {
  throw TypeError(s);
};
var Vs = (s, e, t) => e in s ? Zc(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, S = (s, e) => {
  for (var t in e || (e = {}))
    Gn.call(e, t) && Vs(s, t, e[t]);
  if (ii)
    for (var t of ii(e))
      In.call(e, t) && Vs(s, t, e[t]);
  return s;
}, $ = (s, e) => Gc(s, Ic(e));
var pe = (s, e) => {
  var t = {};
  for (var i in s)
    Gn.call(s, i) && e.indexOf(i) < 0 && (t[i] = s[i]);
  if (s != null && ii)
    for (var i of ii(s))
      e.indexOf(i) < 0 && In.call(s, i) && (t[i] = s[i]);
  return t;
};
var x = (s, e, t) => Vs(s, typeof e != "symbol" ? e + "" : e, t);
var re = (s, e, t) => new Promise((i, r) => {
  var n = (l) => {
    try {
      a(t.next(l));
    } catch (c) {
      r(c);
    }
  }, o = (l) => {
    try {
      a(t.throw(l));
    } catch (c) {
      r(c);
    }
  }, a = (l) => l.done ? i(l.value) : Promise.resolve(l.value).then(n, o);
  a((t = t.apply(s, e)).next());
}), Vc = function(s, e) {
  this[0] = s, this[1] = e;
};
var Xs = (s) => {
  var e = s[Ss("asyncIterator")], t = !1, i, r = {};
  return e == null ? (e = s[Ss("iterator")](), i = (n) => r[n] = (o) => e[n](o)) : (e = e.call(s), i = (n) => r[n] = (o) => {
    if (t) {
      if (t = !1, n === "throw") throw o;
      return o;
    }
    return t = !0, {
      done: !1,
      value: new Vc(new Promise((a) => {
        var l = e[n](o);
        l instanceof Object || Sc("Object expected"), a(l);
      }), 1)
    };
  }), r[Ss("iterator")] = () => r, i("next"), "throw" in e ? i("throw") : r.throw = (n) => {
    throw n;
  }, "return" in e && i("return"), r;
};
import { Q as Xc, K as Wc, i as Sn, d as Rc, a as wc, p as Cc, b as qo, g as vc, c as xc, C as Lc, m as Yc, e as xe, S as Ye, s as Be, G as Ws, f as Vn, r as Xn, F as _e, h as kc, j as Nc, k as Rs, l as gt, n as Wn, M as We, o as $e, V as Tc, q as Ue, H as Rn, t as Jc, u as Uc, v as ws, L as Fc, w as Kc, x as wn, y as Hc, z as Mc } from "./index-DI9h0G2c.js";
import { A as Hy, B as My } from "./index-DI9h0G2c.js";
function zc(s, e) {
  for (var t = 0; t < e.length; t++) {
    const i = e[t];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const r in i)
        if (r !== "default" && !(r in s)) {
          const n = Object.getOwnPropertyDescriptor(i, r);
          n && Object.defineProperty(s, r, n.get ? n : {
            enumerable: !0,
            get: () => i[r]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }));
}
function Oc(s) {
  return `"${s.replace(Pc, Ec)}"`;
}
const Pc = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Ec(s) {
  return Bc[s.charCodeAt(0)];
}
const Bc = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Dc = Object.freeze({});
function jc(s, e, t = Xc) {
  const i = /* @__PURE__ */ new Map();
  for (const X of Object.values(Wc))
    i.set(X, Ac(e, X));
  let r, n = Array.isArray(s), o = [s], a = -1, l = [], c = s, u, d;
  const h = [], p = [];
  do {
    a++;
    const X = a === o.length, R = X && l.length !== 0;
    if (X) {
      if (u = p.length === 0 ? void 0 : h[h.length - 1], c = d, d = p.pop(), R)
        if (n) {
          c = c.slice();
          let W = 0;
          for (const [G, v] of l) {
            const k = G - W;
            v === null ? (c.splice(k, 1), W++) : c[k] = v;
          }
        } else {
          c = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(c)
          );
          for (const [W, G] of l)
            c[W] = G;
        }
      a = r.index, o = r.keys, l = r.edits, n = r.inArray, r = r.prev;
    } else if (d) {
      if (u = n ? a : o[a], c = d[u], c == null)
        continue;
      h.push(u);
    }
    let Z;
    if (!Array.isArray(c)) {
      var b, f;
      Sn(c) || Rc(!1, `Invalid AST Node: ${wc(c)}.`);
      const W = X ? (b = i.get(c.kind)) === null || b === void 0 ? void 0 : b.leave : (f = i.get(c.kind)) === null || f === void 0 ? void 0 : f.enter;
      if (Z = W == null ? void 0 : W.call(e, c, u, d, h, p), Z === Dc)
        break;
      if (Z === !1) {
        if (!X) {
          h.pop();
          continue;
        }
      } else if (Z !== void 0 && (l.push([u, Z]), !X))
        if (Sn(Z))
          c = Z;
        else {
          h.pop();
          continue;
        }
    }
    if (Z === void 0 && R && l.push([u, c]), X)
      h.pop();
    else {
      var m;
      r = {
        inArray: n,
        index: a,
        keys: o,
        edits: l,
        prev: r
      }, n = Array.isArray(c), o = n ? c : (m = t[c.kind]) !== null && m !== void 0 ? m : [], a = -1, l = [], d && p.push(d), d = c;
    }
  } while (r !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : s;
}
function Ac(s, e) {
  const t = s[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: s.enter,
    leave: s.leave
  };
}
function el(s) {
  return jc(s, _c);
}
const Qc = 80, _c = {
  Name: {
    leave: (s) => s.value
  },
  Variable: {
    leave: (s) => "$" + s.name
  },
  // Document
  Document: {
    leave: (s) => w(s.definitions, `

`)
  },
  OperationDefinition: {
    leave(s) {
      const e = F("(", w(s.variableDefinitions, ", "), ")"), t = w(
        [
          s.operation,
          w([s.name, e]),
          w(s.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + s.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: s, type: e, defaultValue: t, directives: i }) => s + ": " + e + F(" = ", t) + F(" ", w(i, " "))
  },
  SelectionSet: {
    leave: ({ selections: s }) => Ge(s)
  },
  Field: {
    leave({ alias: s, name: e, arguments: t, directives: i, selectionSet: r }) {
      const n = F("", s, ": ") + e;
      let o = n + F("(", w(t, ", "), ")");
      return o.length > Qc && (o = n + F(`(
`, wi(w(t, `
`)), `
)`)), w([o, w(i, " "), r], " ");
    }
  },
  Argument: {
    leave: ({ name: s, value: e }) => s + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: s, directives: e }) => "..." + s + F(" ", w(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: s, directives: e, selectionSet: t }) => w(
      [
        "...",
        F("on ", s),
        w(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: s, typeCondition: e, variableDefinitions: t, directives: i, selectionSet: r }) => (
      // or removed in the future.
      `fragment ${s}${F("(", w(t, ", "), ")")} on ${e} ${F("", w(i, " "), " ")}` + r
    )
  },
  // Value
  IntValue: {
    leave: ({ value: s }) => s
  },
  FloatValue: {
    leave: ({ value: s }) => s
  },
  StringValue: {
    leave: ({ value: s, block: e }) => e ? Cc(s) : Oc(s)
  },
  BooleanValue: {
    leave: ({ value: s }) => s ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: s }) => s
  },
  ListValue: {
    leave: ({ values: s }) => "[" + w(s, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: s }) => "{" + w(s, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: s, value: e }) => s + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: s, arguments: e }) => "@" + s + F("(", w(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: s }) => s
  },
  ListType: {
    leave: ({ type: s }) => "[" + s + "]"
  },
  NonNullType: {
    leave: ({ type: s }) => s + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: s, directives: e, operationTypes: t }) => F("", s, `
`) + w(["schema", w(e, " "), Ge(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: s, type: e }) => s + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: s, name: e, directives: t }) => F("", s, `
`) + w(["scalar", e, w(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: s, name: e, interfaces: t, directives: i, fields: r }) => F("", s, `
`) + w(
      [
        "type",
        e,
        F("implements ", w(t, " & ")),
        w(i, " "),
        Ge(r)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: s, name: e, arguments: t, type: i, directives: r }) => F("", s, `
`) + e + (Cn(t) ? F(`(
`, wi(w(t, `
`)), `
)`) : F("(", w(t, ", "), ")")) + ": " + i + F(" ", w(r, " "))
  },
  InputValueDefinition: {
    leave: ({ description: s, name: e, type: t, defaultValue: i, directives: r }) => F("", s, `
`) + w(
      [e + ": " + t, F("= ", i), w(r, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: s, name: e, interfaces: t, directives: i, fields: r }) => F("", s, `
`) + w(
      [
        "interface",
        e,
        F("implements ", w(t, " & ")),
        w(i, " "),
        Ge(r)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, types: i }) => F("", s, `
`) + w(
      ["union", e, w(t, " "), F("= ", w(i, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, values: i }) => F("", s, `
`) + w(["enum", e, w(t, " "), Ge(i)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: s, name: e, directives: t }) => F("", s, `
`) + w([e, w(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, fields: i }) => F("", s, `
`) + w(["input", e, w(t, " "), Ge(i)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: s, name: e, arguments: t, repeatable: i, locations: r }) => F("", s, `
`) + "directive @" + e + (Cn(t) ? F(`(
`, wi(w(t, `
`)), `
)`) : F("(", w(t, ", "), ")")) + (i ? " repeatable" : "") + " on " + w(r, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: s, operationTypes: e }) => w(
      ["extend schema", w(s, " "), Ge(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: s, directives: e }) => w(["extend scalar", s, w(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: s, interfaces: e, directives: t, fields: i }) => w(
      [
        "extend type",
        s,
        F("implements ", w(e, " & ")),
        w(t, " "),
        Ge(i)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: s, interfaces: e, directives: t, fields: i }) => w(
      [
        "extend interface",
        s,
        F("implements ", w(e, " & ")),
        w(t, " "),
        Ge(i)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: s, directives: e, types: t }) => w(
      [
        "extend union",
        s,
        w(e, " "),
        F("= ", w(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: s, directives: e, values: t }) => w(["extend enum", s, w(e, " "), Ge(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: s, directives: e, fields: t }) => w(["extend input", s, w(e, " "), Ge(t)], " ")
  }
};
function w(s, e = "") {
  var t;
  return (t = s == null ? void 0 : s.filter((i) => i).join(e)) !== null && t !== void 0 ? t : "";
}
function Ge(s) {
  return F(`{
`, wi(w(s, `
`)), `
}`);
}
function F(s, e, t = "") {
  return e != null && e !== "" ? s + e + t : "";
}
function wi(s) {
  return F("  ", s.replace(/\n/g, `
  `));
}
function Cn(s) {
  var e;
  return (e = s == null ? void 0 : s.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
const Fr = JSON, $c = (s) => s.toUpperCase(), qc = (s) => {
  const e = {};
  return s.forEach((t, i) => {
    e[i] = t;
  }), e;
}, eu = (s, e, t) => s.document ? s : {
  document: s,
  variables: e,
  requestHeaders: t,
  signal: void 0
}, tu = (s, e, t) => s.query ? s : {
  query: s,
  variables: e,
  requestHeaders: t,
  signal: void 0
}, iu = (s, e) => s.documents ? s : {
  documents: s,
  requestHeaders: e,
  signal: void 0
}, vn = (s) => {
  var i, r;
  let e;
  const t = s.definitions.filter((n) => n.kind === "OperationDefinition");
  return t.length === 1 && (e = (r = (i = t[0]) == null ? void 0 : i.name) == null ? void 0 : r.value), e;
}, Cs = (s) => {
  if (typeof s == "string") {
    let t;
    try {
      const i = qo(s);
      t = vn(i);
    } catch (i) {
    }
    return { query: s, operationName: t };
  }
  const e = vn(s);
  return { query: el(s), operationName: e };
};
var qs = { exports: {} };
(function(s, e) {
  var t = typeof self != "undefined" ? self : xc, i = function() {
    function n() {
      this.fetch = !1, this.DOMException = t.DOMException;
    }
    return n.prototype = t, new n();
  }();
  (function(n) {
    (function(o) {
      var a = {
        searchParams: "URLSearchParams" in n,
        iterable: "Symbol" in n && "iterator" in Symbol,
        blob: "FileReader" in n && "Blob" in n && function() {
          try {
            return new Blob(), !0;
          } catch (y) {
            return !1;
          }
        }(),
        formData: "FormData" in n,
        arrayBuffer: "ArrayBuffer" in n
      };
      function l(y) {
        return y && DataView.prototype.isPrototypeOf(y);
      }
      if (a.arrayBuffer)
        var c = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], u = ArrayBuffer.isView || function(y) {
          return y && c.indexOf(Object.prototype.toString.call(y)) > -1;
        };
      function d(y) {
        if (typeof y != "string" && (y = String(y)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(y))
          throw new TypeError("Invalid character in header field name");
        return y.toLowerCase();
      }
      function h(y) {
        return typeof y != "string" && (y = String(y)), y;
      }
      function p(y) {
        var g = {
          next: function() {
            var Y = y.shift();
            return { done: Y === void 0, value: Y };
          }
        };
        return a.iterable && (g[Symbol.iterator] = function() {
          return g;
        }), g;
      }
      function b(y) {
        this.map = {}, y instanceof b ? y.forEach(function(g, Y) {
          this.append(Y, g);
        }, this) : Array.isArray(y) ? y.forEach(function(g) {
          this.append(g[0], g[1]);
        }, this) : y && Object.getOwnPropertyNames(y).forEach(function(g) {
          this.append(g, y[g]);
        }, this);
      }
      b.prototype.append = function(y, g) {
        y = d(y), g = h(g);
        var Y = this.map[y];
        this.map[y] = Y ? Y + ", " + g : g;
      }, b.prototype.delete = function(y) {
        delete this.map[d(y)];
      }, b.prototype.get = function(y) {
        return y = d(y), this.has(y) ? this.map[y] : null;
      }, b.prototype.has = function(y) {
        return this.map.hasOwnProperty(d(y));
      }, b.prototype.set = function(y, g) {
        this.map[d(y)] = h(g);
      }, b.prototype.forEach = function(y, g) {
        for (var Y in this.map)
          this.map.hasOwnProperty(Y) && y.call(g, this.map[Y], Y, this);
      }, b.prototype.keys = function() {
        var y = [];
        return this.forEach(function(g, Y) {
          y.push(Y);
        }), p(y);
      }, b.prototype.values = function() {
        var y = [];
        return this.forEach(function(g) {
          y.push(g);
        }), p(y);
      }, b.prototype.entries = function() {
        var y = [];
        return this.forEach(function(g, Y) {
          y.push([Y, g]);
        }), p(y);
      }, a.iterable && (b.prototype[Symbol.iterator] = b.prototype.entries);
      function f(y) {
        if (y.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        y.bodyUsed = !0;
      }
      function m(y) {
        return new Promise(function(g, Y) {
          y.onload = function() {
            g(y.result);
          }, y.onerror = function() {
            Y(y.error);
          };
        });
      }
      function X(y) {
        var g = new FileReader(), Y = m(g);
        return g.readAsArrayBuffer(y), Y;
      }
      function R(y) {
        var g = new FileReader(), Y = m(g);
        return g.readAsText(y), Y;
      }
      function Z(y) {
        for (var g = new Uint8Array(y), Y = new Array(g.length), Q = 0; Q < g.length; Q++)
          Y[Q] = String.fromCharCode(g[Q]);
        return Y.join("");
      }
      function W(y) {
        if (y.slice)
          return y.slice(0);
        var g = new Uint8Array(y.byteLength);
        return g.set(new Uint8Array(y)), g.buffer;
      }
      function G() {
        return this.bodyUsed = !1, this._initBody = function(y) {
          this._bodyInit = y, y ? typeof y == "string" ? this._bodyText = y : a.blob && Blob.prototype.isPrototypeOf(y) ? this._bodyBlob = y : a.formData && FormData.prototype.isPrototypeOf(y) ? this._bodyFormData = y : a.searchParams && URLSearchParams.prototype.isPrototypeOf(y) ? this._bodyText = y.toString() : a.arrayBuffer && a.blob && l(y) ? (this._bodyArrayBuffer = W(y.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(y) || u(y)) ? this._bodyArrayBuffer = W(y) : this._bodyText = y = Object.prototype.toString.call(y) : this._bodyText = "", this.headers.get("content-type") || (typeof y == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : a.searchParams && URLSearchParams.prototype.isPrototypeOf(y) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, a.blob && (this.blob = function() {
          var y = f(this);
          if (y)
            return y;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? f(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(X);
        }), this.text = function() {
          var y = f(this);
          if (y)
            return y;
          if (this._bodyBlob)
            return R(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(Z(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, a.formData && (this.formData = function() {
          return this.text().then(V);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var v = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function k(y) {
        var g = y.toUpperCase();
        return v.indexOf(g) > -1 ? g : y;
      }
      function L(y, g) {
        g = g || {};
        var Y = g.body;
        if (y instanceof L) {
          if (y.bodyUsed)
            throw new TypeError("Already read");
          this.url = y.url, this.credentials = y.credentials, g.headers || (this.headers = new b(y.headers)), this.method = y.method, this.mode = y.mode, this.signal = y.signal, !Y && y._bodyInit != null && (Y = y._bodyInit, y.bodyUsed = !0);
        } else
          this.url = String(y);
        if (this.credentials = g.credentials || this.credentials || "same-origin", (g.headers || !this.headers) && (this.headers = new b(g.headers)), this.method = k(g.method || this.method || "GET"), this.mode = g.mode || this.mode || null, this.signal = g.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && Y)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(Y);
      }
      L.prototype.clone = function() {
        return new L(this, { body: this._bodyInit });
      };
      function V(y) {
        var g = new FormData();
        return y.trim().split("&").forEach(function(Y) {
          if (Y) {
            var Q = Y.split("="), O = Q.shift().replace(/\+/g, " "), U = Q.join("=").replace(/\+/g, " ");
            g.append(decodeURIComponent(O), decodeURIComponent(U));
          }
        }), g;
      }
      function C(y) {
        var g = new b(), Y = y.replace(/\r?\n[\t ]+/g, " ");
        return Y.split(/\r?\n/).forEach(function(Q) {
          var O = Q.split(":"), U = O.shift().trim();
          if (U) {
            var j = O.join(":").trim();
            g.append(U, j);
          }
        }), g;
      }
      G.call(L.prototype);
      function N(y, g) {
        g || (g = {}), this.type = "default", this.status = g.status === void 0 ? 200 : g.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in g ? g.statusText : "OK", this.headers = new b(g.headers), this.url = g.url || "", this._initBody(y);
      }
      G.call(N.prototype), N.prototype.clone = function() {
        return new N(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new b(this.headers),
          url: this.url
        });
      }, N.error = function() {
        var y = new N(null, { status: 0, statusText: "" });
        return y.type = "error", y;
      };
      var D = [301, 302, 303, 307, 308];
      N.redirect = function(y, g) {
        if (D.indexOf(g) === -1)
          throw new RangeError("Invalid status code");
        return new N(null, { status: g, headers: { location: y } });
      }, o.DOMException = n.DOMException;
      try {
        new o.DOMException();
      } catch (y) {
        o.DOMException = function(g, Y) {
          this.message = g, this.name = Y;
          var Q = Error(g);
          this.stack = Q.stack;
        }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
      }
      function q(y, g) {
        return new Promise(function(Y, Q) {
          var O = new L(y, g);
          if (O.signal && O.signal.aborted)
            return Q(new o.DOMException("Aborted", "AbortError"));
          var U = new XMLHttpRequest();
          function j() {
            U.abort();
          }
          U.onload = function() {
            var ee = {
              status: U.status,
              statusText: U.statusText,
              headers: C(U.getAllResponseHeaders() || "")
            };
            ee.url = "responseURL" in U ? U.responseURL : ee.headers.get("X-Request-URL");
            var ge = "response" in U ? U.response : U.responseText;
            Y(new N(ge, ee));
          }, U.onerror = function() {
            Q(new TypeError("Network request failed"));
          }, U.ontimeout = function() {
            Q(new TypeError("Network request failed"));
          }, U.onabort = function() {
            Q(new o.DOMException("Aborted", "AbortError"));
          }, U.open(O.method, O.url, !0), O.credentials === "include" ? U.withCredentials = !0 : O.credentials === "omit" && (U.withCredentials = !1), "responseType" in U && a.blob && (U.responseType = "blob"), O.headers.forEach(function(ee, ge) {
            U.setRequestHeader(ge, ee);
          }), O.signal && (O.signal.addEventListener("abort", j), U.onreadystatechange = function() {
            U.readyState === 4 && O.signal.removeEventListener("abort", j);
          }), U.send(typeof O._bodyInit == "undefined" ? null : O._bodyInit);
        });
      }
      return q.polyfill = !0, n.fetch || (n.fetch = q, n.Headers = b, n.Request = L, n.Response = N), o.Headers = b, o.Request = L, o.Response = N, o.fetch = q, Object.defineProperty(o, "__esModule", { value: !0 }), o;
    })({});
  })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
  var r = i;
  e = r.fetch, e.default = r.fetch, e.fetch = r.fetch, e.Headers = r.Headers, e.Request = r.Request, e.Response = r.Response, s.exports = e;
})(qs, qs.exports);
var Ji = qs.exports;
const Ci = /* @__PURE__ */ vc(Ji), su = /* @__PURE__ */ zc({
  __proto__: null,
  default: Ci
}, [Ji]), qe = (s) => {
  let e = {};
  return s && (typeof Headers != "undefined" && s instanceof Headers || su && Ji.Headers && s instanceof Ji.Headers ? e = qc(s) : Array.isArray(s) ? s.forEach(([t, i]) => {
    t && i !== void 0 && (e[t] = i);
  }) : e = s), e;
}, xn = (s) => s.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), ru = (s) => {
  if (!Array.isArray(s.query)) {
    const i = s, r = [`query=${encodeURIComponent(xn(i.query))}`];
    return s.variables && r.push(`variables=${encodeURIComponent(i.jsonSerializer.stringify(i.variables))}`), i.operationName && r.push(`operationName=${encodeURIComponent(i.operationName)}`), r.join("&");
  }
  if (typeof s.variables != "undefined" && !Array.isArray(s.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const e = s, t = s.query.reduce((i, r, n) => (i.push({
    query: xn(r),
    variables: e.variables ? e.jsonSerializer.stringify(e.variables[n]) : void 0
  }), i), []);
  return `query=${encodeURIComponent(e.jsonSerializer.stringify(t))}`;
}, nu = (s) => (e) => re(void 0, null, function* () {
  var f;
  const { url: t, query: i, variables: r, operationName: n, fetch: o, fetchOptions: a, middleware: l } = e, c = S({}, e.headers);
  let u = "", d;
  s === "POST" ? (d = lu(i, r, n, a.jsonSerializer), typeof d == "string" && (c["Content-Type"] = "application/json")) : u = ru({
    query: i,
    variables: r,
    operationName: n,
    jsonSerializer: (f = a.jsonSerializer) != null ? f : Fr
  });
  const h = S({
    method: s,
    headers: c,
    body: d
  }, a);
  let p = t, b = h;
  if (l) {
    const m = yield Promise.resolve(l($(S({}, h), { url: t, operationName: n, variables: r }))), { url: R } = m, Z = pe(m, ["url"]);
    p = R, b = Z;
  }
  return u && (p = `${p}?${u}`), yield o(p, b);
});
class ou {
  constructor(e, t = {}) {
    this.url = e, this.requestConfig = t, this.rawRequest = (...i) => re(this, null, function* () {
      const [r, n, o] = i, a = tu(r, n, o), m = this.requestConfig, { headers: l, fetch: c = Ci, method: u = "POST", requestMiddleware: d, responseMiddleware: h } = m, p = pe(m, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: b } = this;
      a.signal !== void 0 && (p.signal = a.signal);
      const { operationName: f } = Cs(a.query);
      return vs({
        url: b,
        query: a.query,
        variables: a.variables,
        headers: S(S({}, qe(xs(l))), qe(a.requestHeaders)),
        operationName: f,
        fetch: c,
        method: u,
        fetchOptions: p,
        middleware: d
      }).then((X) => (h && h(X), X)).catch((X) => {
        throw h && h(X), X;
      });
    });
  }
  request(e, ...t) {
    return re(this, null, function* () {
      const [i, r] = t, n = eu(e, i, r), f = this.requestConfig, { headers: o, fetch: a = Ci, method: l = "POST", requestMiddleware: c, responseMiddleware: u } = f, d = pe(f, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: h } = this;
      n.signal !== void 0 && (d.signal = n.signal);
      const { query: p, operationName: b } = Cs(n.document);
      return vs({
        url: h,
        query: p,
        variables: n.variables,
        headers: S(S({}, qe(xs(o))), qe(n.requestHeaders)),
        operationName: b,
        fetch: a,
        method: l,
        fetchOptions: d,
        middleware: c
      }).then((m) => (u && u(m), m.data)).catch((m) => {
        throw u && u(m), m;
      });
    });
  }
  // prettier-ignore
  batchRequests(e, t) {
    var c;
    const i = iu(e, t), l = this.requestConfig, { headers: r } = l, n = pe(l, ["headers"]);
    i.signal !== void 0 && (n.signal = i.signal);
    const o = i.documents.map(({ document: u }) => Cs(u).query), a = i.documents.map(({ variables: u }) => u);
    return vs({
      url: this.url,
      query: o,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: S(S({}, qe(xs(r))), qe(i.requestHeaders)),
      operationName: void 0,
      fetch: (c = this.requestConfig.fetch) != null ? c : Ci,
      method: this.requestConfig.method || "POST",
      fetchOptions: n,
      middleware: this.requestConfig.requestMiddleware
    }).then((u) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u.data)).catch((u) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u;
    });
  }
  setHeaders(e) {
    return this.requestConfig.headers = e, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(e, t) {
    const { headers: i } = this.requestConfig;
    return i ? i[e] = t : this.requestConfig.headers = { [e]: t }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(e) {
    return this.url = e, this;
  }
}
const vs = (s) => re(void 0, null, function* () {
  var u, d;
  const { query: e, variables: t, fetchOptions: i } = s, r = nu($c((u = s.method) != null ? u : "post")), n = Array.isArray(s.query), o = yield r(s), a = yield au(o, (d = i.jsonSerializer) != null ? d : Fr), l = Array.isArray(a) ? !a.some(({ data: p }) => !p) : !!a.data, c = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || i.errorPolicy === "all" || i.errorPolicy === "ignore";
  if (o.ok && c && l) {
    const h = (Array.isArray(a), a), { errors: p } = h, b = pe(h, ["errors"]), f = i.errorPolicy === "ignore" ? b : a;
    return $(S({}, n ? { data: f } : f), {
      headers: o.headers,
      status: o.status
    });
  } else {
    const p = typeof a == "string" ? {
      error: a
    } : a;
    throw new Lc(
      // @ts-expect-error TODO
      $(S({}, p), { status: o.status, headers: o.headers }),
      { query: e, variables: t }
    );
  }
}), lu = (s, e, t, i) => {
  const r = i != null ? i : Fr;
  if (!Array.isArray(s))
    return r.stringify({ query: s, variables: e, operationName: t });
  if (typeof e != "undefined" && !Array.isArray(e))
    throw new Error("Cannot create request body with given variable type, array expected");
  const n = s.reduce((o, a, l) => (o.push({ query: a, variables: e ? e[l] : void 0 }), o), []);
  return r.stringify(n);
}, au = (s, e) => re(void 0, null, function* () {
  let t;
  return s.headers.forEach((i, r) => {
    r.toLowerCase() === "content-type" && (t = i);
  }), t && (t.toLowerCase().startsWith("application/json") || t.toLowerCase().startsWith("application/graphql+json") || t.toLowerCase().startsWith("application/graphql-response+json")) ? e.parse(yield s.text()) : s.text();
}), xs = (s) => typeof s == "function" ? s() : s, cu = {
  key: "_sid"
}, uu = "rrweb/sequential-id@1", du = (s) => {
  const e = cu;
  let t = 0;
  return {
    name: uu,
    eventProcessor(i) {
      return Object.assign(i, {
        [e.key]: ++t
      }), i;
    },
    options: e
  };
};
var hu = Object.defineProperty, pu = (s, e, t) => e in s ? hu(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, I = (s, e, t) => pu(s, typeof e != "symbol" ? e + "" : e, t), Ln, mu = Object.defineProperty, fu = (s, e, t) => e in s ? mu(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, Yn = (s, e, t) => fu(s, typeof e != "symbol" ? e + "" : e, t), ne = /* @__PURE__ */ ((s) => (s[s.Document = 0] = "Document", s[s.DocumentType = 1] = "DocumentType", s[s.Element = 2] = "Element", s[s.Text = 3] = "Text", s[s.CDATA = 4] = "CDATA", s[s.Comment = 5] = "Comment", s))(ne || {});
const kn = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, Nn = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, si = {}, bu = () => !!globalThis.Zone;
function Kr(s) {
  if (si[s])
    return si[s];
  const e = globalThis[s], t = e.prototype, i = s in kn ? kn[s] : void 0, r = !!(i && // @ts-expect-error 2345
  i.every(
    (a) => {
      var l, c;
      return !!((c = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && c.toString().includes("[native code]"));
    }
  )), n = s in Nn ? Nn[s] : void 0, o = !!(n && n.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (r && o && !bu())
    return si[s] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const c = l[s].prototype;
    return document.body.removeChild(a), c ? si[s] = c : t;
  } catch (a) {
    return t;
  }
}
const Ls = {};
function Me(s, e, t) {
  var i;
  const r = `${s}.${String(t)}`;
  if (Ls[r])
    return Ls[r].call(
      e
    );
  const n = Kr(s), o = (i = Object.getOwnPropertyDescriptor(
    n,
    t
  )) == null ? void 0 : i.get;
  return o ? (Ls[r] = o, o.call(e)) : e[t];
}
const Ys = {};
function tl(s, e, t) {
  const i = `${s}.${String(t)}`;
  if (Ys[i])
    return Ys[i].bind(
      e
    );
  const n = Kr(s)[t];
  return typeof n != "function" ? e[t] : (Ys[i] = n, n.bind(e));
}
function yu(s) {
  return Me("Node", s, "childNodes");
}
function gu(s) {
  return Me("Node", s, "parentNode");
}
function Zu(s) {
  return Me("Node", s, "parentElement");
}
function Gu(s) {
  return Me("Node", s, "textContent");
}
function Iu(s, e) {
  return tl("Node", s, "contains")(e);
}
function Su(s) {
  return tl("Node", s, "getRootNode")();
}
function Vu(s) {
  return !s || !("host" in s) ? null : Me("ShadowRoot", s, "host");
}
function Xu(s) {
  return s.styleSheets;
}
function Wu(s) {
  return !s || !("shadowRoot" in s) ? null : Me("Element", s, "shadowRoot");
}
function Ru(s, e) {
  return Me("Element", s, "querySelector")(e);
}
function wu(s, e) {
  return Me("Element", s, "querySelectorAll")(e);
}
function Cu() {
  return Kr("MutationObserver").constructor;
}
function vu(s, e, t) {
  try {
    if (!(e in s))
      return () => {
      };
    const i = s[e], r = t(i);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), s[e] = r, () => {
      s[e] = i;
    };
  } catch (i) {
    return () => {
    };
  }
}
const oe = {
  childNodes: yu,
  parentNode: gu,
  parentElement: Zu,
  textContent: Gu,
  contains: Iu,
  getRootNode: Su,
  host: Vu,
  styleSheets: Xu,
  shadowRoot: Wu,
  querySelector: Ru,
  querySelectorAll: wu,
  mutationObserver: Cu,
  patch: vu
};
function il(s) {
  return s.nodeType === s.ELEMENT_NODE;
}
function xt(s) {
  const e = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    s && "host" in s && "mode" in s && oe.host(s) || null
  );
  return !!(e && "shadowRoot" in e && oe.shadowRoot(e) === s);
}
function Lt(s) {
  return Object.prototype.toString.call(s) === "[object ShadowRoot]";
}
function xu(s) {
  return s.includes(" background-clip: text;") && !s.includes(" -webkit-background-clip: text;") && (s = s.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), s;
}
function Lu(s) {
  const { cssText: e } = s;
  if (e.split('"').length < 3) return e;
  const t = ["@import", `url(${JSON.stringify(s.href)})`];
  return s.layerName === "" ? t.push("layer") : s.layerName && t.push(`layer(${s.layerName})`), s.supportsText && t.push(`supports(${s.supportsText})`), s.media.length && t.push(s.media.mediaText), t.join(" ") + ";";
}
function er(s) {
  try {
    const e = s.rules || s.cssRules;
    if (!e)
      return null;
    let t = s.href;
    !t && s.ownerNode && s.ownerNode.ownerDocument && (t = s.ownerNode.ownerDocument.location.href);
    const i = Array.from(
      e,
      (r) => sl(r, t)
    ).join("");
    return xu(i);
  } catch (e) {
    return null;
  }
}
function sl(s, e) {
  if (ku(s)) {
    let t;
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      er(s.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      Lu(s);
    } catch (i) {
      t = s.cssText;
    }
    return s.styleSheet.href ? Ki(t, s.styleSheet.href) : t;
  } else {
    let t = s.cssText;
    return Nu(s) && s.selectorText.includes(":") && (t = Yu(t)), e ? Ki(t, e) : t;
  }
}
function Yu(s) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return s.replace(e, "$1\\$2");
}
function ku(s) {
  return "styleSheet" in s;
}
function Nu(s) {
  return "selectorText" in s;
}
class rl {
  constructor() {
    Yn(this, "idNodeMap", /* @__PURE__ */ new Map()), Yn(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(e) {
    var t;
    if (!e) return -1;
    const i = (t = this.getMeta(e)) == null ? void 0 : t.id;
    return i != null ? i : -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(e) {
    const t = this.getId(e);
    this.idNodeMap.delete(t), e.childNodes && e.childNodes.forEach(
      (i) => this.removeNodeFromMap(i)
    );
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, t) {
    const i = t.id;
    this.idNodeMap.set(i, e), this.nodeMetaMap.set(e, t);
  }
  replace(e, t) {
    const i = this.getNode(e);
    if (i) {
      const r = this.nodeMetaMap.get(i);
      r && this.nodeMetaMap.set(t, r);
    }
    this.idNodeMap.set(e, t);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Tu() {
  return new rl();
}
function Ui({
  element: s,
  maskInputOptions: e,
  tagName: t,
  type: i,
  value: r,
  overwriteRecord: n,
  maskInputFn: o
}) {
  let a = r || "";
  return ll({
    maskInputOptions: e,
    tagName: t,
    type: i,
    overwriteRecord: n
  }) && (o ? a = o(a, s) : a = "*".repeat(a.length)), a;
}
function at(s) {
  return s.toLowerCase();
}
const Tn = "__rrweb_original__";
function Ju(s) {
  const e = s.getContext("2d");
  if (!e) return !0;
  const t = 50;
  for (let i = 0; i < s.width; i += t)
    for (let r = 0; r < s.height; r += t) {
      const n = e.getImageData, o = Tn in n ? n[Tn] : n;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          e,
          i,
          r,
          Math.min(t, s.width - i),
          Math.min(t, s.height - r)
        ).data.buffer
      ).some((l) => l !== 0)) return !1;
    }
  return !0;
}
function Fi(s) {
  const e = s.type;
  return s.hasAttribute("data-rr-is-password") ? "password" : e ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    at(e)
  ) : null;
}
function nl(s, e) {
  var n;
  let t;
  try {
    t = new URL(s, window.location.href);
  } catch (o) {
    return null;
  }
  const i = /\.([0-9a-z]+)(?:$)/i, r = t.pathname.match(i);
  return (n = r == null ? void 0 : r[1]) != null ? n : null;
}
function Uu(s) {
  let e = "";
  return s.indexOf("//") > -1 ? e = s.split("/").slice(0, 3).join("/") : e = s.split("/")[0], e = e.split("?")[0], e;
}
const Fu = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Ku = /^(?:[a-z+]+:)?\/\//i, Hu = /^www\..*/i, Mu = /^(data:)([^,]*),(.*)/i;
function Ki(s, e) {
  return (s || "").replace(
    Fu,
    (t, i, r, n, o, a) => {
      const l = r || o || a, c = i || n || "";
      if (!l)
        return t;
      if (Ku.test(l) || Hu.test(l))
        return `url(${c}${l}${c})`;
      if (Mu.test(l))
        return `url(${c}${l}${c})`;
      if (l[0] === "/")
        return `url(${c}${Uu(e) + l}${c})`;
      const u = e.split("/"), d = l.split("/");
      u.pop();
      for (const h of d)
        h !== "." && (h === ".." ? u.pop() : u.push(h));
      return `url(${c}${u.join("/")}${c})`;
    }
  );
}
function ri(s, e = !1) {
  return e ? s.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "") : s.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function zu(s, e, t = !1) {
  const i = Array.from(e.childNodes), r = [];
  let n = 0;
  if (i.length > 1 && s && typeof s == "string") {
    let o = ri(s, t);
    const a = o.length / s.length;
    for (let l = 1; l < i.length; l++)
      if (i[l].textContent && typeof i[l].textContent == "string") {
        const c = ri(
          i[l].textContent,
          t
        ), u = 100;
        let d = 3;
        for (; d < c.length && // keep consuming css identifiers (to get a decent chunk more quickly)
        (c[d].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
        c.indexOf(c.substring(0, d), 1) !== -1); d++)
          ;
        for (; d < c.length; d++) {
          let h = c.substring(0, d), p = o.split(h), b = -1;
          if (p.length === 2)
            b = p[0].length;
          else if (p.length > 2 && p[0] === "" && i[l - 1].textContent !== "")
            b = o.indexOf(h, 1);
          else if (p.length === 1) {
            if (h = h.substring(
              0,
              h.length - 1
            ), p = o.split(h), p.length <= 1)
              return r.push(s), r;
            d = u + 1;
          } else d === c.length - 1 && (b = o.indexOf(h));
          if (p.length >= 2 && d > u) {
            const f = i[l - 1].textContent;
            if (f && typeof f == "string") {
              const m = ri(f).length;
              b = o.indexOf(h, m);
            }
            b === -1 && (b = p[0].length);
          }
          if (b !== -1) {
            let f = Math.floor(b / a);
            for (; f > 0 && f < s.length; ) {
              if (n += 1, n > 50 * i.length)
                return r.push(s), r;
              const m = ri(
                s.substring(0, f),
                t
              );
              if (m.length === b) {
                r.push(s.substring(0, f)), s = s.substring(f), o = o.substring(b);
                break;
              } else m.length < b ? f += Math.max(
                1,
                Math.floor((b - m.length) / a)
              ) : f -= Math.max(
                1,
                Math.floor((m.length - b) * a)
              );
            }
            break;
          }
        }
      }
  }
  return r.push(s), r;
}
function Ou(s, e) {
  return zu(s, e).join("/* rr_split */");
}
function Hr(s) {
  return s = s.replace(/[^ -~]+/g, ""), s = (s == null ? void 0 : s.split(" ").map((e) => Math.random().toString(20).substring(2, e.length)).join(" ")) || "", s;
}
function tr(s) {
  return s === "img" || s === "video" || s === "audio" || s === "source";
}
const Pu = new RegExp(
  /[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*/
), Eu = new RegExp(/[0-9]{9,16}/), Bu = new RegExp(/[0-9]{3}-?[0-9]{2}-?[0-9]{4}/), Du = new RegExp(
  /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/
), ju = new RegExp(/[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}/), Au = new RegExp(
  /[0-9]{1,5}.?[0-9]{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/
), Qu = new RegExp(/(?:[0-9]{1,3}.){3}[0-9]{1,3}/), _u = [
  Pu,
  Eu,
  Bu,
  Du,
  ju,
  Au,
  Qu
];
function ol(s) {
  return s ? _u.some((e) => e.test(s)) : !1;
}
const ll = ({
  maskInputOptions: s,
  tagName: e,
  type: t,
  overwriteRecord: i
}) => {
  const r = t && t.toLowerCase();
  return i !== "true" && (!!s[e.toLowerCase()] || !!(r && s[r]));
};
let $u = 1;
const qu = new RegExp("[^a-z0-9-_:]"), Tt = -2;
function al() {
  return $u++;
}
function ed(s) {
  if (s instanceof HTMLFormElement)
    return "form";
  const e = at(s.tagName);
  return qu.test(e) ? "div" : e;
}
let et, Jn;
const td = /^[^ \t\n\r\u000c]+/, id = /^[, \t\n\r\u000c]+/;
function sd(s, e) {
  if (e.trim() === "")
    return e;
  let t = 0;
  function i(n) {
    let o;
    const a = n.exec(e.substring(t));
    return a ? (o = a[0], t += o.length, o) : "";
  }
  const r = [];
  for (; i(id), !(t >= e.length); ) {
    let n = i(td);
    if (n.slice(-1) === ",")
      n = rt(s, n.substring(0, n.length - 1)), r.push(n);
    else {
      let o = "";
      n = rt(s, n);
      let a = !1;
      for (; ; ) {
        const l = e.charAt(t);
        if (l === "") {
          r.push((n + o).trim());
          break;
        } else if (a)
          l === ")" && (a = !1);
        else if (l === ",") {
          t += 1, r.push((n + o).trim());
          break;
        } else l === "(" && (a = !0);
        o += l, t += 1;
      }
    }
  }
  return r.join(", ");
}
const Un = /* @__PURE__ */ new WeakMap();
function rt(s, e) {
  return !e || e.trim() === "" ? e : Mr(s, e);
}
function rd(s) {
  return !!(s.tagName === "svg" || s.ownerSVGElement);
}
function Mr(s, e) {
  let t = Un.get(s);
  if (t || (t = s.createElement("a"), Un.set(s, t)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return t.setAttribute("href", e), t.href;
}
function cl(s, e, t, i) {
  return i && (t === "src" || t === "href" && !(e === "use" && i[0] === "#") || t === "xlink:href" && i[0] !== "#" || t === "background" && (e === "table" || e === "td" || e === "th") ? rt(s, i) : t === "srcset" ? sd(s, i) : t === "style" ? Ki(i, Mr(s)) : e === "object" && t === "data" ? rt(s, i) : i);
}
function ul(s, e, t) {
  return (s === "video" || s === "audio") && e === "autoplay";
}
function Fn(s, e, t) {
  try {
    if (typeof e == "string") {
      if (s.classList.contains(e))
        return !0;
    } else
      for (let i = s.classList.length; i--; ) {
        const r = s.classList[i];
        if (e.test(r))
          return !0;
      }
    if (t)
      return s.matches(t);
  } catch (i) {
  }
  return !1;
}
function Hi(s, e, t) {
  if (!s) return !1;
  if (s.nodeType !== s.ELEMENT_NODE)
    return t ? Hi(oe.parentNode(s), e, t) : !1;
  for (let i = s.classList.length; i--; ) {
    const r = s.classList[i];
    if (e.test(r))
      return !0;
  }
  return t ? Hi(oe.parentNode(s), e, t) : !1;
}
function dl(s, e, t, i) {
  let r;
  if (il(s)) {
    if (r = s, !oe.childNodes(r).length)
      return !1;
  } else {
    if (oe.parentElement(s) === null)
      return !1;
    r = oe.parentElement(s);
  }
  try {
    if (typeof e == "string") {
      if (i) {
        if (r.closest(`.${e}`)) return !0;
      } else if (r.classList.contains(e)) return !0;
    } else if (Hi(r, e, i)) return !0;
    if (t) {
      if (i) {
        if (r.closest(t)) return !0;
      } else if (r.matches(t)) return !0;
    }
  } catch (n) {
  }
  return !1;
}
function nd(s, e, t) {
  const i = s.contentWindow;
  if (!i)
    return;
  let r = !1, n;
  try {
    n = i.document.readyState;
  } catch (a) {
    return;
  }
  if (n !== "complete") {
    const a = setTimeout(() => {
      r || (e(), r = !0);
    }, t);
    s.addEventListener("load", () => {
      clearTimeout(a), r = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (i.location.href !== o || s.src === o || s.src === "")
    return setTimeout(e, 0), s.addEventListener("load", e);
  s.addEventListener("load", e);
}
function od(s, e, t) {
  let i = !1, r;
  try {
    r = s.sheet;
  } catch (o) {
    return;
  }
  if (r) return;
  const n = setTimeout(() => {
    i || (e(), i = !0);
  }, t);
  s.addEventListener("load", () => {
    clearTimeout(n), i = !0, e();
  });
}
function ld(s, e) {
  const {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    needsMask: o,
    inlineStylesheet: a,
    maskInputOptions: l = {},
    maskTextClass: c,
    maskTextFn: u,
    maskInputFn: d,
    dataURLOptions: h = {},
    inlineImages: p,
    inlineVideos: b,
    recordCanvas: f,
    keepIframeSrcFn: m,
    newlyAddedElement: X = !1,
    cssCaptured: R = !1,
    privacySetting: Z
  } = e, W = ad(t, i);
  switch (s.nodeType) {
    case s.DOCUMENT_NODE:
      return s.compatMode !== "CSS1Compat" ? {
        type: ne.Document,
        childNodes: [],
        compatMode: s.compatMode
        // probably "BackCompat"
      } : {
        type: ne.Document,
        childNodes: []
      };
    case s.DOCUMENT_TYPE_NODE:
      return {
        type: ne.DocumentType,
        name: s.name,
        publicId: s.publicId,
        systemId: s.systemId,
        rootId: W
      };
    case s.ELEMENT_NODE:
      return ud(s, {
        doc: t,
        blockClass: r,
        blockSelector: n,
        inlineStylesheet: a,
        maskInputOptions: l,
        maskInputFn: d,
        maskTextClass: c,
        dataURLOptions: h,
        inlineImages: p,
        inlineVideos: b,
        recordCanvas: f,
        keepIframeSrcFn: m,
        newlyAddedElement: X,
        privacySetting: Z,
        rootId: W
      });
    case s.TEXT_NODE:
      return cd(s, {
        doc: t,
        needsMask: o,
        maskTextFn: u,
        privacySetting: Z,
        rootId: W,
        cssCaptured: R
      });
    case s.CDATA_SECTION_NODE:
      return {
        type: ne.CDATA,
        textContent: "",
        rootId: W
      };
    case s.COMMENT_NODE:
      return {
        type: ne.Comment,
        textContent: oe.textContent(s) || "",
        rootId: W
      };
    default:
      return !1;
  }
}
function ad(s, e) {
  if (!e.hasNode(s)) return;
  const t = e.getId(s);
  return t === 1 ? void 0 : t;
}
function cd(s, e) {
  var t;
  const { needsMask: i, maskTextFn: r, privacySetting: n, rootId: o, cssCaptured: a } = e, l = oe.parentNode(s), c = l && l.tagName;
  let u = "";
  const d = c === "STYLE" ? !0 : void 0, h = c === "SCRIPT" ? !0 : void 0;
  h ? u = "SCRIPT_PLACEHOLDER" : a || (u = oe.textContent(s), d && u && (u = Ki(u, Mr(e.doc)))), !d && !h && u && i && (u = r ? r(u, oe.parentElement(s)) : u.replace(/[\S]/g, "*"));
  const p = n === "strict", b = (t = s.parentElement) == null ? void 0 : t.getAttribute("data-hl-record"), f = n === "default" && ol(u);
  return (p || f) && !b && c && !(/* @__PURE__ */ new Set([
    "HEAD",
    "TITLE",
    "STYLE",
    "SCRIPT",
    "HTML",
    "BODY",
    "NOSCRIPT"
  ])).has(c) && u && (u = Hr(u)), {
    type: ne.Text,
    textContent: u || "",
    rootId: o
  };
}
function ud(s, e) {
  const {
    doc: t,
    blockClass: i,
    blockSelector: r,
    inlineStylesheet: n,
    maskInputOptions: o = {},
    maskInputFn: a,
    maskTextClass: l,
    dataURLOptions: c = {},
    inlineImages: u,
    inlineVideos: d,
    recordCanvas: h,
    keepIframeSrcFn: p,
    newlyAddedElement: b = !1,
    privacySetting: f,
    rootId: m
  } = e;
  let X = Fn(s, i, r);
  const R = Fn(s, l, null), Z = f === "strict";
  let W = ed(s), G = {};
  const v = s.attributes.length;
  for (let V = 0; V < v; V++) {
    const C = s.attributes[V];
    ul(W, C.name) || (G[C.name] = cl(
      t,
      W,
      at(C.name),
      C.value
    ));
  }
  if (W === "link" && n) {
    const V = Array.from(t.styleSheets).find((N) => N.href === s.href);
    let C = null;
    V && (C = er(V)), C && (delete G.rel, delete G.href, G._cssText = C);
  }
  if (W === "style" && s.sheet) {
    let V = er(
      s.sheet
    );
    V && (s.childNodes.length > 1 && (V = Ou(V, s)), G._cssText = V);
  }
  if (W === "input" || W === "textarea" || W === "select") {
    const V = s.value, C = s.checked;
    G.type !== "radio" && G.type !== "checkbox" && G.type !== "submit" && G.type !== "button" && V ? G.value = Ui({
      element: s,
      type: Fi(s),
      tagName: W,
      value: V,
      overwriteRecord: s.getAttribute("data-hl-record"),
      maskInputOptions: o,
      maskInputFn: a
    }) : C && (G.checked = C);
  }
  if (W === "option" && (s.selected && !o.select ? G.selected = !0 : delete G.selected), W === "dialog" && s.open && (G.rr_open_mode = s.matches("dialog:modal") ? "modal" : "non-modal"), W === "canvas" && h) {
    if (s.__context === "2d")
      Ju(s);
    else if (!("__context" in s)) {
      const V = s.toDataURL(
        c.type,
        c.quality
      ), C = t.createElement("canvas");
      C.width = s.width, C.height = s.height;
      const N = C.toDataURL(
        c.type,
        c.quality
      );
      V !== N && (G.rr_dataURL = V);
    }
  }
  if (W === "img" && u && !X && !R && !Z) {
    et || (et = t.createElement("canvas"), Jn = et.getContext("2d"));
    const V = s, C = V.currentSrc || V.getAttribute("src") || "<unknown-src>", N = V.crossOrigin, D = () => {
      V.removeEventListener("load", D);
      try {
        et.width = V.naturalWidth, et.height = V.naturalHeight, Jn.drawImage(V, 0, 0), G.rr_dataURL = et.toDataURL(
          c.type,
          c.quality
        );
      } catch (q) {
        if (V.crossOrigin !== "anonymous") {
          V.crossOrigin = "anonymous", V.complete && V.naturalWidth !== 0 ? D() : V.addEventListener("load", D);
          return;
        } else
          console.warn(
            `Cannot inline img src=${C}! Error: ${q}`
          );
      }
      V.crossOrigin === "anonymous" && (N ? G.crossOrigin = N : V.removeAttribute("crossorigin"));
    };
    V.complete && V.naturalWidth !== 0 ? D() : V.addEventListener("load", D);
  }
  if (W === "audio" || W === "video") {
    const V = G;
    V.rr_mediaState = s.paused ? "paused" : "played", V.rr_mediaCurrentTime = s.currentTime, V.rr_mediaPlaybackRate = s.playbackRate, V.rr_mediaMuted = s.muted, V.rr_mediaLoop = s.loop, V.rr_mediaVolume = s.volume;
  }
  if (b || (s.scrollLeft && (G.rr_scrollLeft = s.scrollLeft), s.scrollTop && (G.rr_scrollTop = s.scrollTop)), X || R || Z && tr(W)) {
    const { width: V, height: C } = s.getBoundingClientRect();
    G = {
      class: G.class,
      rr_width: `${V}px`,
      rr_height: `${C}px`
    };
  }
  Z && tr(W) && (X = !0), W === "iframe" && !p(G.src) && (s.contentDocument || (G.rr_src = G.src), delete G.src);
  let k;
  try {
    customElements.get(W) && (k = !0);
  } catch (V) {
  }
  const L = (V) => {
    const { width: C, height: N } = V.getBoundingClientRect();
    G = {
      width: C,
      height: N,
      rr_width: `${C}px`,
      rr_height: `${N}px`,
      rr_inlined_video: !0,
      class: G.class,
      style: G.style
    }, W = "canvas";
    const D = t.createElement("canvas");
    D.width = s.width, D.height = s.height, G.rr_dataURL = D.toDataURL(
      c.type,
      c.quality
    );
  };
  if (W === "video") {
    const V = s;
    u && (V.src === "" || V.src.indexOf("blob:") !== -1) && L(V), d && V.src !== "" && V.src.indexOf("blob:") === -1 && L(V);
  }
  return {
    type: ne.Element,
    tagName: W,
    attributes: G,
    childNodes: [],
    isSVG: rd(s) || void 0,
    needBlock: X,
    needMask: R,
    rootId: m,
    isCustom: k
  };
}
function _(s) {
  return s == null ? "" : s.toLowerCase();
}
function dd(s, e) {
  if (e.comment && s.type === ne.Comment)
    return !0;
  if (s.type === ne.Element) {
    if (e.script && // script tag
    (s.tagName === "script" || // (module)preload link
    s.tagName === "link" && (s.attributes.rel === "preload" && s.attributes.as === "script" || s.attributes.rel === "modulepreload") || // prefetch link
    s.tagName === "link" && s.attributes.rel === "prefetch" && typeof s.attributes.href == "string" && nl(s.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (s.tagName === "link" && s.attributes.rel === "shortcut icon" || s.tagName === "meta" && (_(s.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || _(s.attributes.name) === "application-name" || _(s.attributes.rel) === "icon" || _(s.attributes.rel) === "apple-touch-icon" || _(s.attributes.rel) === "shortcut icon")))
      return !0;
    if (s.tagName === "meta") {
      if (e.headMetaDescKeywords && _(s.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (_(s.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      _(s.attributes.name).match(/^(og|twitter):/) || _(s.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (_(s.attributes.name) === "robots" || _(s.attributes.name) === "googlebot" || _(s.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && s.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (_(s.attributes.name) === "author" || _(s.attributes.name) === "generator" || _(s.attributes.name) === "framework" || _(s.attributes.name) === "publisher" || _(s.attributes.name) === "progid" || _(s.attributes.property).match(/^article:/) || _(s.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (_(s.attributes.name) === "google-site-verification" || _(s.attributes.name) === "yandex-verification" || _(s.attributes.name) === "csrf-token" || _(s.attributes.name) === "p:domain_verify" || _(s.attributes.name) === "verify-v1" || _(s.attributes.name) === "verification" || _(s.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function nt(s, e) {
  const {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    maskTextClass: o,
    maskTextSelector: a,
    skipChild: l = !1,
    inlineStylesheet: c = !0,
    maskInputOptions: u = {},
    maskTextFn: d,
    maskInputFn: h,
    slimDOMOptions: p,
    dataURLOptions: b = {},
    inlineImages: f = !1,
    inlineVideos: m = !1,
    recordCanvas: X = !1,
    onSerialize: R,
    onIframeLoad: Z,
    iframeLoadTimeout: W = 5e3,
    onStylesheetLoad: G,
    stylesheetLoadTimeout: v = 5e3,
    keepIframeSrcFn: k = () => !1,
    newlyAddedElement: L = !1,
    cssCaptured: V = !1,
    privacySetting: C
  } = e;
  let { needsMask: N } = e, { preserveWhiteSpace: D = !0 } = e;
  N || (N = dl(
    s,
    o,
    a,
    N === void 0
  ));
  const q = ld(s, {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    needsMask: N,
    inlineStylesheet: c,
    maskInputOptions: u,
    maskTextClass: o,
    maskTextFn: d,
    maskInputFn: h,
    dataURLOptions: b,
    inlineImages: f,
    inlineVideos: m,
    recordCanvas: X,
    keepIframeSrcFn: k,
    newlyAddedElement: L,
    cssCaptured: V,
    privacySetting: C
  });
  if (!q)
    return console.warn(s, "not serialized"), null;
  let y;
  i.hasNode(s) ? y = i.getId(s) : dd(q, p) || !D && q.type === ne.Text && !q.textContent.replace(/^\s+|\s+$/gm, "").length ? y = Tt : y = al();
  const g = Object.assign(q, { id: y });
  if (i.add(s, g), y === Tt)
    return null;
  R && R(s);
  let Y = !l, Q = C, O = C === "strict";
  if (g.type === ne.Element) {
    if (Y = Y && !g.needBlock, O || (O = !!g.needBlock || !!g.needMask), Q = O ? "strict" : Q, O && tr(g.tagName)) {
      const ee = s.cloneNode();
      ee.src = "", i.add(ee, g);
    }
    delete g.needBlock, delete g.needMask;
    const j = oe.shadowRoot(s);
    j && Lt(j) && (g.isShadowHost = !0);
  }
  if ((g.type === ne.Document || g.type === ne.Element) && Y) {
    p.headWhitespace && g.type === ne.Element && g.tagName === "head" && (D = !1);
    const j = {
      doc: t,
      mirror: i,
      blockClass: r,
      blockSelector: n,
      needsMask: N,
      maskTextClass: o,
      maskTextSelector: a,
      skipChild: l,
      inlineStylesheet: c,
      maskInputOptions: u,
      maskTextFn: d,
      maskInputFn: h,
      slimDOMOptions: p,
      dataURLOptions: b,
      inlineImages: f,
      inlineVideos: m,
      recordCanvas: X,
      preserveWhiteSpace: D,
      onSerialize: R,
      onIframeLoad: Z,
      iframeLoadTimeout: W,
      onStylesheetLoad: G,
      stylesheetLoadTimeout: v,
      keepIframeSrcFn: k,
      cssCaptured: !1,
      privacySetting: Q
    };
    if (!(g.type === ne.Element && g.tagName === "textarea" && g.attributes.value !== void 0)) {
      g.type === ne.Element && g.attributes._cssText !== void 0 && typeof g.attributes._cssText == "string" && (j.cssCaptured = !0);
      for (const ge of Array.from(oe.childNodes(s))) {
        const Je = nt(ge, j);
        Je && g.childNodes.push(Je);
      }
    }
    let ee = null;
    if (il(s) && (ee = oe.shadowRoot(s)))
      for (const ge of Array.from(oe.childNodes(ee))) {
        const Je = nt(ge, j);
        Je && (Lt(ee) && (Je.isShadow = !0), g.childNodes.push(Je));
      }
  }
  const U = oe.parentNode(s);
  return U && xt(U) && Lt(U) && (g.isShadow = !0), g.type === ne.Element && g.tagName === "iframe" && nd(
    s,
    () => {
      const j = s.contentDocument;
      if (j && Z) {
        const ee = nt(j, {
          doc: j,
          mirror: i,
          blockClass: r,
          blockSelector: n,
          needsMask: N,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: c,
          maskInputOptions: u,
          maskTextFn: d,
          maskInputFn: h,
          slimDOMOptions: p,
          dataURLOptions: b,
          inlineImages: f,
          inlineVideos: m,
          recordCanvas: X,
          preserveWhiteSpace: D,
          onSerialize: R,
          onIframeLoad: Z,
          iframeLoadTimeout: W,
          onStylesheetLoad: G,
          stylesheetLoadTimeout: v,
          keepIframeSrcFn: k,
          privacySetting: C
        });
        ee && Z(
          s,
          ee
        );
      }
    },
    W
  ), g.type === ne.Element && g.tagName === "link" && typeof g.attributes.rel == "string" && (g.attributes.rel === "stylesheet" || g.attributes.rel === "preload" && typeof g.attributes.href == "string" && nl(g.attributes.href) === "css") && od(
    s,
    () => {
      if (G) {
        const j = nt(s, {
          doc: t,
          mirror: i,
          blockClass: r,
          blockSelector: n,
          needsMask: N,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: c,
          maskInputOptions: u,
          maskTextFn: d,
          maskInputFn: h,
          slimDOMOptions: p,
          dataURLOptions: b,
          inlineImages: f,
          inlineVideos: m,
          recordCanvas: X,
          preserveWhiteSpace: D,
          onSerialize: R,
          onIframeLoad: Z,
          iframeLoadTimeout: W,
          onStylesheetLoad: G,
          stylesheetLoadTimeout: v,
          keepIframeSrcFn: k,
          privacySetting: C
        });
        j && G(
          s,
          j
        );
      }
    },
    v
  ), g;
}
function hd(s, e) {
  const {
    mirror: t = new rl(),
    blockClass: i = "highlight-block",
    blockSelector: r = null,
    maskTextClass: n = "highlight-mask",
    maskTextSelector: o = null,
    inlineStylesheet: a = !0,
    inlineImages: l = !1,
    inlineVideos: c = !1,
    recordCanvas: u = !1,
    maskAllInputs: d = !1,
    maskTextFn: h,
    maskInputFn: p,
    slimDOM: b = !1,
    dataURLOptions: f,
    preserveWhiteSpace: m,
    onSerialize: X,
    onIframeLoad: R,
    iframeLoadTimeout: Z,
    onStylesheetLoad: W,
    stylesheetLoadTimeout: G,
    keepIframeSrcFn: v = () => !1,
    privacySetting: k = "default"
  } = e || {};
  return nt(s, {
    doc: s,
    mirror: t,
    blockClass: i,
    blockSelector: r,
    maskTextClass: n,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: a,
    maskInputOptions: d === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : d === !1 ? {
      password: !0
    } : d,
    maskTextFn: h,
    maskInputFn: p,
    slimDOMOptions: b || b === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: b === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : b || {},
    dataURLOptions: f,
    inlineImages: l,
    inlineVideos: c,
    recordCanvas: u,
    preserveWhiteSpace: m,
    onSerialize: X,
    onIframeLoad: R,
    iframeLoadTimeout: Z,
    onStylesheetLoad: W,
    stylesheetLoadTimeout: G,
    keepIframeSrcFn: v,
    newlyAddedElement: !1,
    privacySetting: k
  });
}
function pd(s) {
  if (s.__esModule) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(s, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[i];
      }
    });
  }), t;
}
var zr = { exports: {} }, T = String, hl = function() {
  return { isColorSupported: !1, reset: T, bold: T, dim: T, italic: T, underline: T, inverse: T, hidden: T, strikethrough: T, black: T, red: T, green: T, yellow: T, blue: T, magenta: T, cyan: T, white: T, gray: T, bgBlack: T, bgRed: T, bgGreen: T, bgYellow: T, bgBlue: T, bgMagenta: T, bgCyan: T, bgWhite: T, blackBright: T, redBright: T, greenBright: T, yellowBright: T, blueBright: T, magentaBright: T, cyanBright: T, whiteBright: T, bgBlackBright: T, bgRedBright: T, bgGreenBright: T, bgYellowBright: T, bgBlueBright: T, bgMagentaBright: T, bgCyanBright: T, bgWhiteBright: T };
};
zr.exports = hl();
zr.exports.createColors = hl;
var md = zr.exports;
const fd = {}, bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fd
}, Symbol.toStringTag, { value: "Module" })), Se = /* @__PURE__ */ pd(bd);
let Kn = md, Hn = Se, ir = class pl extends Error {
  constructor(e, t, i, r, n, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), r && (this.source = r), o && (this.plugin = o), typeof t != "undefined" && typeof i != "undefined" && (typeof t == "number" ? (this.line = t, this.column = i) : (this.line = t.line, this.column = t.column, this.endLine = i.line, this.endColumn = i.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, pl);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = Kn.isColorSupported);
    let i = (u) => u, r = (u) => u, n = (u) => u;
    if (e) {
      let { bold: u, gray: d, red: h } = Kn.createColors(!0);
      r = (p) => u(h(p)), i = (p) => d(p), Hn && (n = (p) => Hn(p));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), c = String(l).length;
    return o.slice(a, l).map((u, d) => {
      let h = a + 1 + d, p = " " + (" " + h).slice(-c) + " | ";
      if (h === this.line) {
        if (u.length > 160) {
          let f = 20, m = Math.max(0, this.column - f), X = Math.max(
            this.column + f,
            this.endColumn + f
          ), R = u.slice(m, X), Z = i(p.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, f - 1)).replace(/[^\t]/g, " ");
          return r(">") + i(p) + n(R) + `
 ` + Z + r("^");
        }
        let b = i(p.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return r(">") + i(p) + n(u) + `
 ` + b + r("^");
      }
      return " " + i(p) + n(u);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var Or = ir;
ir.default = ir;
const Mn = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function yd(s) {
  return s[0].toUpperCase() + s.slice(1);
}
let sr = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let i = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? i += e.raws.afterName : r && (i += " "), e.nodes)
      this.block(e, i + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(i + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let i;
    e.type === "decl" ? i = this.raw(e, null, "beforeDecl") : e.type === "comment" ? i = this.raw(e, null, "beforeComment") : t === "before" ? i = this.raw(e, null, "beforeRule") : i = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (i.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) i += o;
    }
    return i;
  }
  block(e, t) {
    let i = this.raw(e, "between", "beforeOpen");
    this.builder(t + i + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let i = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || i);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), i = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + i + "*/", e);
  }
  decl(e, t) {
    let i = this.raw(e, "between", "colon"), r = e.prop + i + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, i) {
    let r;
    if (i || (i = t), t && (r = e.raws[t], typeof r != "undefined"))
      return r;
    let n = e.parent;
    if (i === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return Mn[i];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[i] != "undefined")
      return o.rawCache[i];
    if (i === "before" || i === "after")
      return this.beforeAfter(e, i);
    {
      let a = "raw" + yd(i);
      this[a] ? r = this[a](o, e) : o.walk((l) => {
        if (r = l.raws[t], typeof r != "undefined") return !1;
      });
    }
    return typeof r == "undefined" && (r = Mn[i]), o.rawCache[i] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
        return t = i.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let i;
    return e.walkComments((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeDecl(e, t) {
    let i;
    return e.walkDecls((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((i) => {
      if (i.type !== "decl" && (t = i.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && (i.parent !== e || e.first !== i) && typeof i.raws.before != "undefined")
        return t = i.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((i) => {
      if (typeof i.raws.between != "undefined")
        return t = i.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length === 0 && (t = i.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((i) => {
      let r = i.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof i.raws.before != "undefined") {
        let n = i.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length && i.last.type === "decl" && (t = i.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let i = e[t], r = e.raws[t];
    return r && r.value === i ? r.raw : i;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var ml = sr;
sr.default = sr;
let gd = ml;
function rr(s, e) {
  new gd(e).stringify(s);
}
var ss = rr;
rr.default = rr;
var Bt = {};
Bt.isClean = Symbol("isClean");
Bt.my = Symbol("my");
let Zd = Or, Gd = ml, Id = ss, { isClean: Zt, my: Sd } = Bt;
function nr(s, e) {
  let t = new s.constructor();
  for (let i in s) {
    if (!Object.prototype.hasOwnProperty.call(s, i) || i === "proxyCache") continue;
    let r = s[i], n = typeof r;
    i === "parent" && n === "object" ? e && (t[i] = e) : i === "source" ? t[i] = r : Array.isArray(r) ? t[i] = r.map((o) => nr(o, t)) : (n === "object" && r !== null && (r = nr(r)), t[i] = r);
  }
  return t;
}
function Gt(s, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, i = 1, r = 0;
  for (let n = 0; n < s.length; n++) {
    if (i === e.line && t === e.column) {
      r = n;
      break;
    }
    s[n] === `
` ? (t = 1, i += 1) : t += 1;
  }
  return r;
}
let or = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Zt] = !1, this[Sd] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let i of e[t])
          typeof i.clone == "function" ? this.append(i.clone()) : this.append(i);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = nr(this);
    for (let i in e)
      t[i] = e[i];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: i, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: i.column, line: i.line },
        t
      );
    }
    return new Zd(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Zt] = !0;
  }
  markDirty() {
    if (this[Zt]) {
      this[Zt] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Zt] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = i.slice(
        Gt(i, this.source.start),
        Gt(i, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, i = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = Gt(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, i += 1) : t += 1;
    return { column: t, line: i };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, i = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = r.slice(
        Gt(r, this.source.start),
        Gt(r, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), i = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? i = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? i = this.positionInside(e.endIndex) : e.index && (i = this.positionInside(e.index + 1));
    return (i.line < t.line || i.line === t.line && i.column <= t.column) && (i = { column: t.column + 1, line: t.line }), { end: i, start: t };
  }
  raw(e, t) {
    return new Gd().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, i = !1;
      for (let r of e)
        r === this ? i = !0 : i ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      i || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let i = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        i[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        i[o] = a.toJSON(null, t);
      else if (o === "source") {
        let l = t.get(a.input);
        l == null && (l = n, t.set(a.input, n), n++), i[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        i[o] = a;
    }
    return r && (i.inputs = [...t.keys()].map((o) => o.toJSON())), i;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = Id) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (i) => {
      t += i;
    }), t;
  }
  warn(e, t, i) {
    let r = { node: this };
    for (let n in i) r[n] = i[n];
    return e.warn(t, r);
  }
};
var rs = or;
or.default = or;
let Vd = rs, lr = class extends Vd {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var ns = lr;
lr.default = lr;
let Xd = rs, ar = class extends Xd {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = $(S({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var os = ar;
ar.default = ar;
let fl = ns, bl = os, Wd = rs, { isClean: yl, my: gl } = Bt, Pr, Zl, Gl, Er;
function Il(s) {
  return s.map((e) => (e.nodes && (e.nodes = Il(e.nodes)), delete e.source, e));
}
function Sl(s) {
  if (s[yl] = !1, s.proxyOf.nodes)
    for (let e of s.proxyOf.nodes)
      Sl(e);
}
let Ne = class Vl extends Wd {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let i = this.normalize(t, this.last);
      for (let r of i) this.proxyOf.nodes.push(r);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), i, r;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (i = this.indexes[t], r = e(this.proxyOf.nodes[i], i), r !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], r;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...i) => e[t](
          ...i.map((r) => typeof r == "function" ? (n, o) => r(n.toProxy(), o) : r)
        ) : t === "every" || t === "some" ? (i) => e[t](
          (r, ...n) => i(r.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((i) => i.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let i = this.index(e), r = this.normalize(t, this.proxyOf.nodes[i]).reverse();
    i = this.index(e);
    for (let o of r) this.proxyOf.nodes.splice(i + 1, 0, o);
    let n;
    for (let o in this.indexes)
      n = this.indexes[o], i < n && (this.indexes[o] = n + r.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let i = this.index(e), r = i === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[i],
      r
    ).reverse();
    i = this.index(e);
    for (let a of n) this.proxyOf.nodes.splice(i, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], i <= o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Il(Zl(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new bl(e)];
    } else if (e.selector || e.selectors)
      e = [new Er(e)];
    else if (e.name)
      e = [new Pr(e)];
    else if (e.text)
      e = [new fl(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((r) => (r[gl] || Vl.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[yl] && Sl(r), r.raws || (r.raws = {}), typeof r.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (r.raws.before = t.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let i = this.normalize(t, this.first, "prepend").reverse();
      for (let r of i) this.proxyOf.nodes.unshift(r);
      for (let r in this.indexes)
        this.indexes[r] = this.indexes[r] + i.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let i in this.indexes)
      t = this.indexes[i], t >= e && (this.indexes[i] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, i) {
    return i || (i = t, t = {}), this.walkDecls((r) => {
      t.props && !t.props.includes(r.prop) || t.fast && !r.value.includes(t.fast) || (r.value = r.value.replace(e, i));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, i) => {
      let r;
      try {
        r = e(t, i);
      } catch (n) {
        throw t.addToError(n);
      }
      return r !== !1 && t.walk && (r = t.walk(e)), r;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "atrule" && e.test(i.name))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "atrule" && i.name === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "atrule")
        return t(i, r);
    }));
  }
  walkComments(e) {
    return this.walk((t, i) => {
      if (t.type === "comment")
        return e(t, i);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "decl" && e.test(i.prop))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "decl" && i.prop === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "decl")
        return t(i, r);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "rule" && e.test(i.selector))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "rule" && i.selector === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "rule")
        return t(i, r);
    }));
  }
};
Ne.registerParse = (s) => {
  Zl = s;
};
Ne.registerRule = (s) => {
  Er = s;
};
Ne.registerAtRule = (s) => {
  Pr = s;
};
Ne.registerRoot = (s) => {
  Gl = s;
};
var De = Ne;
Ne.default = Ne;
Ne.rebuild = (s) => {
  s.type === "atrule" ? Object.setPrototypeOf(s, Pr.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, Er.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, bl.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, fl.prototype) : s.type === "root" && Object.setPrototypeOf(s, Gl.prototype), s[gl] = !0, s.nodes && s.nodes.forEach((e) => {
    Ne.rebuild(e);
  });
};
let Xl = De, Mi = class extends Xl {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Br = Mi;
Mi.default = Mi;
Xl.registerAtRule(Mi);
let Rd = De, Wl, Rl, Jt = class extends Rd {
  constructor(e) {
    super(S({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Wl(new Rl(), this, e).stringify();
  }
};
Jt.registerLazyResult = (s) => {
  Wl = s;
};
Jt.registerProcessor = (s) => {
  Rl = s;
};
var Dr = Jt;
Jt.default = Jt;
let wd = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Cd = (s = 21) => {
  let e = "", t = s | 0;
  for (; t--; )
    e += wd[Math.random() * 64 | 0];
  return e;
};
var vd = { nanoid: Cd };
let { existsSync: xd, readFileSync: Ld } = Se, { dirname: ks, join: Yd } = Se, { SourceMapConsumer: zn, SourceMapGenerator: On } = Se;
function kd(s) {
  return Buffer ? Buffer.from(s, "base64").toString() : window.atob(s);
}
let cr = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let i = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, i);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = ks(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new zn(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, i = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(i);
    if (a)
      return kd(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let i = e.lastIndexOf(t.pop()), r = e.indexOf("*/", i);
    i > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(i, r)));
  }
  loadFile(e) {
    if (this.root = ks(e), xd(e))
      return this.mapFile = e, Ld(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let i = t(e);
        if (i) {
          let r = this.loadFile(i);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + i.toString()
            );
          return r;
        }
      } else {
        if (t instanceof zn)
          return On.fromSourceMap(t).toString();
        if (t instanceof On)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let i = this.annotation;
        return e && (i = Yd(ks(e), i)), this.loadFile(i);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var wl = cr;
cr.default = cr;
let { nanoid: Nd } = vd, { isAbsolute: ur, resolve: dr } = Se, { SourceMapConsumer: Td, SourceMapGenerator: Jd } = Se, { fileURLToPath: Pn, pathToFileURL: ni } = Se, En = Or, Ud = wl, Ns = Se, Ts = Symbol("fromOffsetCache"), Fd = !!(Td && Jd), Bn = !!(dr && ur), zi = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!Bn || /^\w+:\/\//.test(t.from) || ur(t.from) ? this.file = t.from : this.file = dr(t.from)), Bn && Fd) {
      let i = new Ud(this.css, t);
      if (i.text) {
        this.map = i;
        let r = i.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + Nd(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, i, r = {}) {
    let n, o, a;
    if (t && typeof t == "object") {
      let c = t, u = i;
      if (typeof c.offset == "number") {
        let d = this.fromOffset(c.offset);
        t = d.line, i = d.col;
      } else
        t = c.line, i = c.column;
      if (typeof u.offset == "number") {
        let d = this.fromOffset(u.offset);
        o = d.line, n = d.col;
      } else
        o = u.line, n = u.column;
    } else if (!i) {
      let c = this.fromOffset(t);
      t = c.line, i = c.col;
    }
    let l = this.origin(t, i, o, n);
    return l ? a = new En(
      e,
      l.endLine === void 0 ? l.line : { column: l.column, line: l.line },
      l.endLine === void 0 ? l.column : { column: l.endColumn, line: l.endLine },
      l.source,
      l.file,
      r.plugin
    ) : a = new En(
      e,
      o === void 0 ? t : { column: i, line: t },
      o === void 0 ? i : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), a.input = { column: i, endColumn: n, endLine: o, line: t, source: this.css }, this.file && (ni && (a.input.url = ni(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, i;
    if (this[Ts])
      i = this[Ts];
    else {
      let n = this.css.split(`
`);
      i = new Array(n.length);
      let o = 0;
      for (let a = 0, l = n.length; a < l; a++)
        i[a] = o, o += n[a].length + 1;
      this[Ts] = i;
    }
    t = i[i.length - 1];
    let r = 0;
    if (e >= t)
      r = i.length - 1;
    else {
      let n = i.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < i[o])
          n = o - 1;
        else if (e >= i[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - i[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : dr(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, i, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof i == "number" && (a = n.originalPositionFor({ column: r, line: i }));
    let l;
    ur(o.source) ? l = ni(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || ni(this.map.mapFile)
    );
    let c = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (Pn)
        c.file = Pn(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let u = n.sourceContentFor(o.source);
    return u && (c.source = u), c;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = S({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var ls = zi;
zi.default = zi;
Ns && Ns.registerInput && Ns.registerInput(zi);
let Cl = De, vl, xl, ct = class extends Cl {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, i) {
    let r = super.normalize(e);
    if (t) {
      if (i === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let i = this.index(e);
    return !t && i === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[i].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new vl(new xl(), this, e).stringify();
  }
};
ct.registerLazyResult = (s) => {
  vl = s;
};
ct.registerProcessor = (s) => {
  xl = s;
};
var Dt = ct;
ct.default = ct;
Cl.registerRoot(ct);
let Ut = {
  comma(s) {
    return Ut.split(s, [","], !0);
  },
  space(s) {
    let e = [" ", `
`, "	"];
    return Ut.split(s, e);
  },
  split(s, e, t) {
    let i = [], r = "", n = !1, o = 0, a = !1, l = "", c = !1;
    for (let u of s)
      c ? c = !1 : u === "\\" ? c = !0 : a ? u === l && (a = !1) : u === '"' || u === "'" ? (a = !0, l = u) : u === "(" ? o += 1 : u === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(u) && (n = !0), n ? (r !== "" && i.push(r.trim()), r = "", n = !1) : r += u;
    return (t || r !== "") && i.push(r.trim()), i;
  }
};
var Ll = Ut;
Ut.default = Ut;
let Yl = De, Kd = Ll, Oi = class extends Yl {
  get selectors() {
    return Kd.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, i = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(i);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var jr = Oi;
Oi.default = Oi;
Yl.registerRule(Oi);
let Hd = Br, Md = ns, zd = os, Od = ls, Pd = wl, Ed = Dt, Bd = jr;
function Ft(s, e) {
  if (Array.isArray(s)) return s.map((o) => Ft(o));
  let r = s, { inputs: t } = r, i = pe(r, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = $(S({}, o), { __proto__: Od.prototype });
      a.map && (a.map = $(S({}, a.map), {
        __proto__: Pd.prototype
      })), e.push(a);
    }
  }
  if (i.nodes && (i.nodes = s.nodes.map((o) => Ft(o, e))), i.source) {
    let n = i.source, { inputId: o } = n, a = pe(n, ["inputId"]);
    i.source = a, o != null && (i.source.input = e[o]);
  }
  if (i.type === "root")
    return new Ed(i);
  if (i.type === "decl")
    return new zd(i);
  if (i.type === "rule")
    return new Bd(i);
  if (i.type === "comment")
    return new Md(i);
  if (i.type === "atrule")
    return new Hd(i);
  throw new Error("Unknown node type: " + s.type);
}
var Dd = Ft;
Ft.default = Ft;
let { dirname: vi, relative: kl, resolve: Nl, sep: Tl } = Se, { SourceMapConsumer: Jl, SourceMapGenerator: xi } = Se, { pathToFileURL: Dn } = Se, jd = ls, Ad = !!(Jl && xi), Qd = !!(vi && Nl && kl && Tl), _d = class {
  constructor(e, t, i, r) {
    this.stringify = e, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), i = e.root || vi(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new Jl(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(i)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Qd && Ad && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = xi.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new xi({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new xi({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, i = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, l, c) => {
      if (this.css += a, l && c !== "end" && (r.generated.line = e, r.generated.column = t - 1, l.source && l.source.start ? (r.source = this.sourcePath(l), r.original.line = l.source.start.line, r.original.column = l.source.start.column - 1, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, l && c !== "start") {
        let u = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== u.last || u.raws.semicolon) && (l.source && l.source.end ? (r.source = this.sourcePath(l), r.original.line = l.source.end.line, r.original.column = l.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let i = this.opts.to ? vi(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (i = vi(Nl(i, this.mapOpts.annotation)));
    let r = kl(i, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new jd(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let i = t.source.input.from;
          if (i && !e[i]) {
            e[i] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(i) : this.toUrl(this.path(i));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (Dn) {
      let i = Dn(e).toString();
      return this.memoizedFileURLs.set(e, i), i;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    Tl === "\\" && (e = e.replace(/\\/g, "/"));
    let i = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, i), i;
  }
};
var Ul = _d;
const Js = 39, jn = 34, oi = 92, An = 47, li = 10, It = 32, ai = 12, ci = 9, ui = 13, $d = 91, qd = 93, eh = 40, th = 41, ih = 123, sh = 125, rh = 59, nh = 42, oh = 58, lh = 64, di = /[\t\n\f\r "#'()/;[\\\]{}]/g, hi = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, ah = /.[\r\n"'(/\\]/, Qn = /[\da-f]/i;
var ch = function(e, t = {}) {
  let i = e.css.valueOf(), r = t.ignoreErrors, n, o, a, l, c, u, d, h, p, b, f = i.length, m = 0, X = [], R = [];
  function Z() {
    return m;
  }
  function W(L) {
    throw e.error("Unclosed " + L, m);
  }
  function G() {
    return R.length === 0 && m >= f;
  }
  function v(L) {
    if (R.length) return R.pop();
    if (m >= f) return;
    let V = L ? L.ignoreUnclosed : !1;
    switch (n = i.charCodeAt(m), n) {
      case li:
      case It:
      case ci:
      case ui:
      case ai: {
        l = m;
        do
          l += 1, n = i.charCodeAt(l);
        while (n === It || n === li || n === ci || n === ui || n === ai);
        u = ["space", i.slice(m, l)], m = l - 1;
        break;
      }
      case $d:
      case qd:
      case ih:
      case sh:
      case oh:
      case rh:
      case th: {
        let C = String.fromCharCode(n);
        u = [C, C, m];
        break;
      }
      case eh: {
        if (b = X.length ? X.pop()[1] : "", p = i.charCodeAt(m + 1), b === "url" && p !== Js && p !== jn && p !== It && p !== li && p !== ci && p !== ai && p !== ui) {
          l = m;
          do {
            if (d = !1, l = i.indexOf(")", l + 1), l === -1)
              if (r || V) {
                l = m;
                break;
              } else
                W("bracket");
            for (h = l; i.charCodeAt(h - 1) === oi; )
              h -= 1, d = !d;
          } while (d);
          u = ["brackets", i.slice(m, l + 1), m, l], m = l;
        } else
          l = i.indexOf(")", m + 1), o = i.slice(m, l + 1), l === -1 || ah.test(o) ? u = ["(", "(", m] : (u = ["brackets", o, m, l], m = l);
        break;
      }
      case Js:
      case jn: {
        c = n === Js ? "'" : '"', l = m;
        do {
          if (d = !1, l = i.indexOf(c, l + 1), l === -1)
            if (r || V) {
              l = m + 1;
              break;
            } else
              W("string");
          for (h = l; i.charCodeAt(h - 1) === oi; )
            h -= 1, d = !d;
        } while (d);
        u = ["string", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      case lh: {
        di.lastIndex = m + 1, di.test(i), di.lastIndex === 0 ? l = i.length - 1 : l = di.lastIndex - 2, u = ["at-word", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      case oi: {
        for (l = m, a = !0; i.charCodeAt(l + 1) === oi; )
          l += 1, a = !a;
        if (n = i.charCodeAt(l + 1), a && n !== An && n !== It && n !== li && n !== ci && n !== ui && n !== ai && (l += 1, Qn.test(i.charAt(l)))) {
          for (; Qn.test(i.charAt(l + 1)); )
            l += 1;
          i.charCodeAt(l + 1) === It && (l += 1);
        }
        u = ["word", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      default: {
        n === An && i.charCodeAt(m + 1) === nh ? (l = i.indexOf("*/", m + 2) + 1, l === 0 && (r || V ? l = i.length : W("comment")), u = ["comment", i.slice(m, l + 1), m, l], m = l) : (hi.lastIndex = m + 1, hi.test(i), hi.lastIndex === 0 ? l = i.length - 1 : l = hi.lastIndex - 2, u = ["word", i.slice(m, l + 1), m, l], X.push(u), m = l);
        break;
      }
    }
    return m++, u;
  }
  function k(L) {
    R.push(L);
  }
  return {
    back: k,
    endOfFile: G,
    nextToken: v,
    position: Z
  };
};
let uh = Br, dh = ns, hh = os, ph = Dt, _n = jr, mh = ch;
const $n = {
  empty: !0,
  space: !0
};
function fh(s) {
  for (let e = s.length - 1; e >= 0; e--) {
    let t = s[e], i = t[3] || t[2];
    if (i) return i;
  }
}
let bh = class {
  constructor(e) {
    this.input = e, this.root = new ph(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new uh();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let i, r, n, o = !1, a = !1, l = [], c = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), i = e[0], i === "(" || i === "[" ? c.push(i === "(" ? ")" : "]") : i === "{" && c.length > 0 ? c.push("}") : i === c[c.length - 1] && c.pop(), c.length === 0)
        if (i === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (i === "{") {
          a = !0;
          break;
        } else if (i === "}") {
          if (l.length > 0) {
            for (n = l.length - 1, r = l[n]; r && r[0] === "space"; )
              r = l[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let i = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (i += 1, i === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, i, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!i)
          this.doubleColon(r);
        else {
          if (i[0] === "word" && i[1] === "progid")
            continue;
          return o;
        }
      i = r;
    }
    return !1;
  }
  comment(e) {
    let t = new dh();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let i = e[1].slice(2, -2);
    if (/^\s*$/.test(i))
      t.text = "", t.raws.left = i, t.raws.right = "";
    else {
      let r = i.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = mh(this.input);
  }
  decl(e, t) {
    let i = new hh();
    this.init(i, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), i.source.end = this.getPosition(
      r[3] || r[2] || fh(e)
    ), i.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), i.raws.before += e.shift()[1];
    for (i.source.start = this.getPosition(e[0][2]), i.prop = ""; e.length; ) {
      let c = e[0][0];
      if (c === ":" || c === "space" || c === "comment")
        break;
      i.prop += e.shift()[1];
    }
    i.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        i.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), i.raws.between += n[1];
    (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let c = e.length - 1; c >= 0; c--) {
      if (n = e[c], n[1].toLowerCase() === "!important") {
        i.important = !0;
        let u = this.stringFrom(e, c);
        u = this.spacesFromEnd(e) + u, u !== " !important" && (i.raws.important = u);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let u = e.slice(0), d = "";
        for (let h = c; h > 0; h--) {
          let p = u[h][0];
          if (d.trim().startsWith("!") && p !== "space")
            break;
          d = u.pop()[1] + d;
        }
        d.trim().startsWith("!") && (i.important = !0, i.raws.important = d, e = u);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((c) => c[0] !== "space" && c[0] !== "comment") && (i.raws.between += o.map((c) => c[1]).join(""), o = []), this.raw(i, "value", o.concat(e), t), i.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new _n();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, i = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), l = [], c = e;
    for (; c; ) {
      if (i = c[0], l.push(c), i === "(" || i === "[")
        n || (n = c), o.push(i === "(" ? ")" : "]");
      else if (a && r && i === "{")
        n || (n = c), o.push("}");
      else if (o.length === 0)
        if (i === ";")
          if (r) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (i === "{") {
          this.rule(l);
          return;
        } else if (i === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else i === ":" && (r = !0);
      else i === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      c = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; l.length && (c = l[l.length - 1][0], !(c !== "space" && c !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, i, r) {
    let n, o, a = i.length, l = "", c = !0, u, d;
    for (let h = 0; h < a; h += 1)
      n = i[h], o = n[0], o === "space" && h === a - 1 && !r ? c = !1 : o === "comment" ? (d = i[h - 1] ? i[h - 1][0] : "empty", u = i[h + 1] ? i[h + 1][0] : "empty", !$n[d] && !$n[u] ? l.slice(-1) === "," ? c = !1 : l += n[1] : c = !1) : l += n[1];
    if (!c) {
      let h = i.reduce((p, b) => p + b[1], "");
      e.raws[t] = { raw: h, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new _n();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      i = e.pop()[1] + i;
    return i;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, i = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      i += e.shift()[1];
    return i;
  }
  spacesFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      i = e.pop()[1] + i;
    return i;
  }
  stringFrom(e, t) {
    let i = "";
    for (let r = t; r < e.length; r++)
      i += e[r][1];
    return e.splice(t, e.length - t), i;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var yh = bh;
let gh = De, Zh = ls, Gh = yh;
function Pi(s, e) {
  let t = new Zh(s, e), i = new Gh(t);
  try {
    i.parse();
  } catch (r) {
    throw r;
  }
  return i.root;
}
var Ar = Pi;
Pi.default = Pi;
gh.registerParse(Pi);
let hr = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (let i in t) this[i] = t[i];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Fl = hr;
hr.default = hr;
let Ih = Fl, pr = class {
  get content() {
    return this.css;
  }
  constructor(e, t, i) {
    this.processor = e, this.messages = [], this.root = t, this.opts = i, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let i = new Ih(e, t);
    return this.messages.push(i), i;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var Qr = pr;
pr.default = pr;
let Sh = De, Vh = Dr, Xh = Ul, Wh = Ar, qn = Qr, Rh = Dt, wh = ss, { isClean: Re, my: Ch } = Bt;
const vh = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, xh = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Lh = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, ut = 0;
function St(s) {
  return typeof s == "object" && typeof s.then == "function";
}
function Kl(s) {
  let e = !1, t = vh[s.type];
  return s.type === "decl" ? e = s.prop.toLowerCase() : s.type === "atrule" && (e = s.name.toLowerCase()), e && s.append ? [
    t,
    t + "-" + e,
    ut,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : s.append ? [t, ut, t + "Exit"] : [t, t + "Exit"];
}
function eo(s) {
  let e;
  return s.type === "document" ? e = ["Document", ut, "DocumentExit"] : s.type === "root" ? e = ["Root", ut, "RootExit"] : e = Kl(s), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: s,
    visitorIndex: 0,
    visitors: []
  };
}
function mr(s) {
  return s[Re] = !1, s.nodes && s.nodes.forEach((e) => mr(e)), s;
}
let fr = {}, dt = class Hl {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, i) {
    this.stringified = !1, this.processed = !1;
    let r;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      r = mr(t);
    else if (t instanceof Hl || t instanceof qn)
      r = mr(t.root), t.map && (typeof i.map == "undefined" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      let n = Wh;
      i.syntax && (n = i.syntax.parse), i.parser && (n = i.parser), n.parse && (n = n.parse);
      try {
        r = n(t, i);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      r && !r[Ch] && Sh.rebuild(r);
    }
    this.result = new qn(e, r, i), this.helpers = $(S({}, fr), { postcss: fr, result: this.result }), this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? S(S({}, n), n.prepare(this.result)) : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let i = this.result.lastPlugin;
    try {
      t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin && (e.plugin = i.postcssPlugin, e.setMessage());
    } catch (r) {
      console && console.error && console.error(r);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, i, r) => {
      this.listeners[i] || (this.listeners[i] = []), this.listeners[i].push([t, r]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let i in t) {
          if (!xh[i] && /^[A-Z]/.test(i))
            throw new Error(
              `Unknown event ${i} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Lh[i])
            if (typeof t[i] == "object")
              for (let r in t[i])
                r === "*" ? e(t, i, t[i][r]) : e(
                  t,
                  i + "-" + r.toLowerCase(),
                  t[i][r]
                );
            else typeof t[i] == "function" && e(t, i, t[i]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return re(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], i = this.runOnRoot(t);
        if (St(i))
          try {
            yield i;
          } catch (r) {
            throw this.handleError(r);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[Re]; ) {
          e[Re] = !0;
          let t = [eo(e)];
          for (; t.length > 0; ) {
            let i = this.visitTick(t);
            if (St(i))
              try {
                yield i;
              } catch (r) {
                let n = t[t.length - 1].node;
                throw this.handleError(r, n);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, i] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let r = e.nodes.map(
                  (n) => i(n, this.helpers)
                );
                yield Promise.all(r);
              } else
                yield i(e, this.helpers);
            } catch (r) {
              throw this.handleError(r);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (i) => e.Once(i, this.helpers)
          );
          return St(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = wh;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let r = new Xh(t, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (St(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Re]; )
        e[Re] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [i, r] of e) {
      this.result.lastPlugin = i;
      let n;
      try {
        n = r(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (St(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: i, visitors: r } = t;
    if (i.type !== "root" && i.type !== "document" && !i.parent) {
      e.pop();
      return;
    }
    if (r.length > 0 && t.visitorIndex < r.length) {
      let [o, a] = r[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === r.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(i.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, i);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = i.nodes[i.indexes[o]]; )
        if (i.indexes[o] += 1, !a[Re]) {
          a[Re] = !0, e.push(eo(a));
          return;
        }
      t.iterator = 0, delete i.indexes[o];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let o = n[t.eventIndex];
      if (t.eventIndex += 1, o === ut) {
        i.nodes && i.nodes.length && (i[Re] = !0, t.iterator = i.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Re] = !0;
    let t = Kl(e);
    for (let i of t)
      if (i === ut)
        e.nodes && e.each((r) => {
          r[Re] || this.walkSync(r);
        });
      else {
        let r = this.listeners[i];
        if (r && this.visitSync(r, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
dt.registerPostcss = (s) => {
  fr = s;
};
var Ml = dt;
dt.default = dt;
Rh.registerLazyResult(dt);
Vh.registerLazyResult(dt);
let Yh = Ul, kh = Ar;
const Nh = Qr;
let Th = ss, br = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = kh;
    try {
      e = t(this._css, this._opts);
    } catch (i) {
      this.error = i;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = i, this._map = void 0;
    let r, n = Th;
    this.result = new Nh(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new Yh(n, r, this._opts, t);
    if (a.isMap()) {
      let [l, c] = a.generate();
      l && (this.result.css = l), c && (this.result.map = c);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Jh = br;
br.default = br;
let Uh = Dr, Fh = Ml, Kh = Jh, Hh = Dt, Kt = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let i of e)
      if (i.postcss === !0 ? i = i() : i.postcss && (i = i.postcss), typeof i == "object" && Array.isArray(i.plugins))
        t = t.concat(i.plugins);
      else if (typeof i == "object" && i.postcssPlugin)
        t.push(i);
      else if (typeof i == "function")
        t.push(i);
      else if (!(typeof i == "object" && (i.parse || i.stringify))) throw new Error(i + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Kh(this, e, t) : new Fh(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var Mh = Kt;
Kt.default = Kt;
Hh.registerProcessor(Kt);
Uh.registerProcessor(Kt);
let zl = Br, Ol = ns, zh = De, Oh = Or, Pl = os, El = Dr, Ph = Dd, Eh = ls, Bh = Ml, Dh = Ll, jh = rs, Ah = Ar, _r = Mh, Qh = Qr, Bl = Dt, Dl = jr, _h = ss, $h = Fl;
function E(...s) {
  return s.length === 1 && Array.isArray(s[0]) && (s = s[0]), new _r(s);
}
E.plugin = function(e, t) {
  let i = !1;
  function r(...o) {
    console && console.warn && !i && (i = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new _r().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, l) {
    return E([r(l)]).process(o, a);
  }, r;
};
E.stringify = _h;
E.parse = Ah;
E.fromJSON = Ph;
E.list = Dh;
E.comment = (s) => new Ol(s);
E.atRule = (s) => new zl(s);
E.decl = (s) => new Pl(s);
E.rule = (s) => new Dl(s);
E.root = (s) => new Bl(s);
E.document = (s) => new El(s);
E.CssSyntaxError = Oh;
E.Declaration = Pl;
E.Container = zh;
E.Processor = _r;
E.Document = El;
E.Comment = Ol;
E.Warning = $h;
E.AtRule = zl;
E.Result = Qh;
E.Input = Eh;
E.Rule = Dl;
E.Root = Bl;
E.Node = jh;
Bh.registerPostcss(E);
E.default = E;
var qh = Object.defineProperty, ep = (s, e, t) => e in s ? qh(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, me = (s, e, t) => ep(s, typeof e != "symbol" ? e + "" : e, t);
function tp(s) {
  if (s.__esModule) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(s, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[i];
      }
    });
  }), t;
}
var $r = { exports: {} }, J = String, jl = function() {
  return { isColorSupported: !1, reset: J, bold: J, dim: J, italic: J, underline: J, inverse: J, hidden: J, strikethrough: J, black: J, red: J, green: J, yellow: J, blue: J, magenta: J, cyan: J, white: J, gray: J, bgBlack: J, bgRed: J, bgGreen: J, bgYellow: J, bgBlue: J, bgMagenta: J, bgCyan: J, bgWhite: J, blackBright: J, redBright: J, greenBright: J, yellowBright: J, blueBright: J, magentaBright: J, cyanBright: J, whiteBright: J, bgBlackBright: J, bgRedBright: J, bgGreenBright: J, bgYellowBright: J, bgBlueBright: J, bgMagentaBright: J, bgCyanBright: J, bgWhiteBright: J };
};
$r.exports = jl();
$r.exports.createColors = jl;
var ip = $r.exports;
const sp = {}, rp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sp
}, Symbol.toStringTag, { value: "Module" })), Ve = /* @__PURE__ */ tp(rp);
let to = ip, io = Ve, yr = class Al extends Error {
  constructor(e, t, i, r, n, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), r && (this.source = r), o && (this.plugin = o), typeof t != "undefined" && typeof i != "undefined" && (typeof t == "number" ? (this.line = t, this.column = i) : (this.line = t.line, this.column = t.column, this.endLine = i.line, this.endColumn = i.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Al);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = to.isColorSupported);
    let i = (u) => u, r = (u) => u, n = (u) => u;
    if (e) {
      let { bold: u, gray: d, red: h } = to.createColors(!0);
      r = (p) => u(h(p)), i = (p) => d(p), io && (n = (p) => io(p));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), c = String(l).length;
    return o.slice(a, l).map((u, d) => {
      let h = a + 1 + d, p = " " + (" " + h).slice(-c) + " | ";
      if (h === this.line) {
        if (u.length > 160) {
          let f = 20, m = Math.max(0, this.column - f), X = Math.max(
            this.column + f,
            this.endColumn + f
          ), R = u.slice(m, X), Z = i(p.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, f - 1)).replace(/[^\t]/g, " ");
          return r(">") + i(p) + n(R) + `
 ` + Z + r("^");
        }
        let b = i(p.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return r(">") + i(p) + n(u) + `
 ` + b + r("^");
      }
      return " " + i(p) + n(u);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var qr = yr;
yr.default = yr;
const so = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function np(s) {
  return s[0].toUpperCase() + s.slice(1);
}
let gr = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let i = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? i += e.raws.afterName : r && (i += " "), e.nodes)
      this.block(e, i + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(i + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let i;
    e.type === "decl" ? i = this.raw(e, null, "beforeDecl") : e.type === "comment" ? i = this.raw(e, null, "beforeComment") : t === "before" ? i = this.raw(e, null, "beforeRule") : i = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (i.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) i += o;
    }
    return i;
  }
  block(e, t) {
    let i = this.raw(e, "between", "beforeOpen");
    this.builder(t + i + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let i = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || i);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), i = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + i + "*/", e);
  }
  decl(e, t) {
    let i = this.raw(e, "between", "colon"), r = e.prop + i + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, i) {
    let r;
    if (i || (i = t), t && (r = e.raws[t], typeof r != "undefined"))
      return r;
    let n = e.parent;
    if (i === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return so[i];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[i] != "undefined")
      return o.rawCache[i];
    if (i === "before" || i === "after")
      return this.beforeAfter(e, i);
    {
      let a = "raw" + np(i);
      this[a] ? r = this[a](o, e) : o.walk((l) => {
        if (r = l.raws[t], typeof r != "undefined") return !1;
      });
    }
    return typeof r == "undefined" && (r = so[i]), o.rawCache[i] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
        return t = i.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let i;
    return e.walkComments((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeDecl(e, t) {
    let i;
    return e.walkDecls((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((i) => {
      if (i.type !== "decl" && (t = i.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && (i.parent !== e || e.first !== i) && typeof i.raws.before != "undefined")
        return t = i.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((i) => {
      if (typeof i.raws.between != "undefined")
        return t = i.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length === 0 && (t = i.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((i) => {
      let r = i.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof i.raws.before != "undefined") {
        let n = i.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length && i.last.type === "decl" && (t = i.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let i = e[t], r = e.raws[t];
    return r && r.value === i ? r.raw : i;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Ql = gr;
gr.default = gr;
let op = Ql;
function Zr(s, e) {
  new op(e).stringify(s);
}
var as = Zr;
Zr.default = Zr;
var jt = {};
jt.isClean = Symbol("isClean");
jt.my = Symbol("my");
let lp = qr, ap = Ql, cp = as, { isClean: Vt, my: up } = jt;
function Gr(s, e) {
  let t = new s.constructor();
  for (let i in s) {
    if (!Object.prototype.hasOwnProperty.call(s, i) || i === "proxyCache") continue;
    let r = s[i], n = typeof r;
    i === "parent" && n === "object" ? e && (t[i] = e) : i === "source" ? t[i] = r : Array.isArray(r) ? t[i] = r.map((o) => Gr(o, t)) : (n === "object" && r !== null && (r = Gr(r)), t[i] = r);
  }
  return t;
}
function Xt(s, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, i = 1, r = 0;
  for (let n = 0; n < s.length; n++) {
    if (i === e.line && t === e.column) {
      r = n;
      break;
    }
    s[n] === `
` ? (t = 1, i += 1) : t += 1;
  }
  return r;
}
let Ir = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Vt] = !1, this[up] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let i of e[t])
          typeof i.clone == "function" ? this.append(i.clone()) : this.append(i);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Gr(this);
    for (let i in e)
      t[i] = e[i];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: i, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: i.column, line: i.line },
        t
      );
    }
    return new lp(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Vt] = !0;
  }
  markDirty() {
    if (this[Vt]) {
      this[Vt] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Vt] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = i.slice(
        Xt(i, this.source.start),
        Xt(i, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, i = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = Xt(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, i += 1) : t += 1;
    return { column: t, line: i };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, i = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = r.slice(
        Xt(r, this.source.start),
        Xt(r, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), i = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? i = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? i = this.positionInside(e.endIndex) : e.index && (i = this.positionInside(e.index + 1));
    return (i.line < t.line || i.line === t.line && i.column <= t.column) && (i = { column: t.column + 1, line: t.line }), { end: i, start: t };
  }
  raw(e, t) {
    return new ap().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, i = !1;
      for (let r of e)
        r === this ? i = !0 : i ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      i || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let i = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        i[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        i[o] = a.toJSON(null, t);
      else if (o === "source") {
        let l = t.get(a.input);
        l == null && (l = n, t.set(a.input, n), n++), i[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        i[o] = a;
    }
    return r && (i.inputs = [...t.keys()].map((o) => o.toJSON())), i;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = cp) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (i) => {
      t += i;
    }), t;
  }
  warn(e, t, i) {
    let r = { node: this };
    for (let n in i) r[n] = i[n];
    return e.warn(t, r);
  }
};
var cs = Ir;
Ir.default = Ir;
let dp = cs, Sr = class extends dp {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var us = Sr;
Sr.default = Sr;
let hp = cs, Vr = class extends hp {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = $(S({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var ds = Vr;
Vr.default = Vr;
let _l = us, $l = ds, pp = cs, { isClean: ql, my: ea } = jt, en, ta, ia, tn;
function sa(s) {
  return s.map((e) => (e.nodes && (e.nodes = sa(e.nodes)), delete e.source, e));
}
function ra(s) {
  if (s[ql] = !1, s.proxyOf.nodes)
    for (let e of s.proxyOf.nodes)
      ra(e);
}
let Te = class na extends pp {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let i = this.normalize(t, this.last);
      for (let r of i) this.proxyOf.nodes.push(r);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), i, r;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (i = this.indexes[t], r = e(this.proxyOf.nodes[i], i), r !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], r;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...i) => e[t](
          ...i.map((r) => typeof r == "function" ? (n, o) => r(n.toProxy(), o) : r)
        ) : t === "every" || t === "some" ? (i) => e[t](
          (r, ...n) => i(r.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((i) => i.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let i = this.index(e), r = this.normalize(t, this.proxyOf.nodes[i]).reverse();
    i = this.index(e);
    for (let o of r) this.proxyOf.nodes.splice(i + 1, 0, o);
    let n;
    for (let o in this.indexes)
      n = this.indexes[o], i < n && (this.indexes[o] = n + r.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let i = this.index(e), r = i === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[i],
      r
    ).reverse();
    i = this.index(e);
    for (let a of n) this.proxyOf.nodes.splice(i, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], i <= o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = sa(ta(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new $l(e)];
    } else if (e.selector || e.selectors)
      e = [new tn(e)];
    else if (e.name)
      e = [new en(e)];
    else if (e.text)
      e = [new _l(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((r) => (r[ea] || na.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[ql] && ra(r), r.raws || (r.raws = {}), typeof r.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (r.raws.before = t.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let i = this.normalize(t, this.first, "prepend").reverse();
      for (let r of i) this.proxyOf.nodes.unshift(r);
      for (let r in this.indexes)
        this.indexes[r] = this.indexes[r] + i.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let i in this.indexes)
      t = this.indexes[i], t >= e && (this.indexes[i] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, i) {
    return i || (i = t, t = {}), this.walkDecls((r) => {
      t.props && !t.props.includes(r.prop) || t.fast && !r.value.includes(t.fast) || (r.value = r.value.replace(e, i));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, i) => {
      let r;
      try {
        r = e(t, i);
      } catch (n) {
        throw t.addToError(n);
      }
      return r !== !1 && t.walk && (r = t.walk(e)), r;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "atrule" && e.test(i.name))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "atrule" && i.name === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "atrule")
        return t(i, r);
    }));
  }
  walkComments(e) {
    return this.walk((t, i) => {
      if (t.type === "comment")
        return e(t, i);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "decl" && e.test(i.prop))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "decl" && i.prop === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "decl")
        return t(i, r);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "rule" && e.test(i.selector))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "rule" && i.selector === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "rule")
        return t(i, r);
    }));
  }
};
Te.registerParse = (s) => {
  ta = s;
};
Te.registerRule = (s) => {
  tn = s;
};
Te.registerAtRule = (s) => {
  en = s;
};
Te.registerRoot = (s) => {
  ia = s;
};
var je = Te;
Te.default = Te;
Te.rebuild = (s) => {
  s.type === "atrule" ? Object.setPrototypeOf(s, en.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, tn.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, $l.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, _l.prototype) : s.type === "root" && Object.setPrototypeOf(s, ia.prototype), s[ea] = !0, s.nodes && s.nodes.forEach((e) => {
    Te.rebuild(e);
  });
};
let oa = je, Ei = class extends oa {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var sn = Ei;
Ei.default = Ei;
oa.registerAtRule(Ei);
let mp = je, la, aa, Ht = class extends mp {
  constructor(e) {
    super(S({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new la(new aa(), this, e).stringify();
  }
};
Ht.registerLazyResult = (s) => {
  la = s;
};
Ht.registerProcessor = (s) => {
  aa = s;
};
var rn = Ht;
Ht.default = Ht;
let fp = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", bp = (s = 21) => {
  let e = "", t = s | 0;
  for (; t--; )
    e += fp[Math.random() * 64 | 0];
  return e;
};
var yp = { nanoid: bp };
let { existsSync: gp, readFileSync: Zp } = Ve, { dirname: Us, join: Gp } = Ve, { SourceMapConsumer: ro, SourceMapGenerator: no } = Ve;
function Ip(s) {
  return Buffer ? Buffer.from(s, "base64").toString() : window.atob(s);
}
let Xr = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let i = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, i);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Us(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new ro(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, i = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(i);
    if (a)
      return Ip(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let i = e.lastIndexOf(t.pop()), r = e.indexOf("*/", i);
    i > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(i, r)));
  }
  loadFile(e) {
    if (this.root = Us(e), gp(e))
      return this.mapFile = e, Zp(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let i = t(e);
        if (i) {
          let r = this.loadFile(i);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + i.toString()
            );
          return r;
        }
      } else {
        if (t instanceof ro)
          return no.fromSourceMap(t).toString();
        if (t instanceof no)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let i = this.annotation;
        return e && (i = Gp(Us(e), i)), this.loadFile(i);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var ca = Xr;
Xr.default = Xr;
let { nanoid: Sp } = yp, { isAbsolute: Wr, resolve: Rr } = Ve, { SourceMapConsumer: Vp, SourceMapGenerator: Xp } = Ve, { fileURLToPath: oo, pathToFileURL: pi } = Ve, lo = qr, Wp = ca, Fs = Ve, Ks = Symbol("fromOffsetCache"), Rp = !!(Vp && Xp), ao = !!(Rr && Wr), Bi = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!ao || /^\w+:\/\//.test(t.from) || Wr(t.from) ? this.file = t.from : this.file = Rr(t.from)), ao && Rp) {
      let i = new Wp(this.css, t);
      if (i.text) {
        this.map = i;
        let r = i.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + Sp(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, i, r = {}) {
    let n, o, a;
    if (t && typeof t == "object") {
      let c = t, u = i;
      if (typeof c.offset == "number") {
        let d = this.fromOffset(c.offset);
        t = d.line, i = d.col;
      } else
        t = c.line, i = c.column;
      if (typeof u.offset == "number") {
        let d = this.fromOffset(u.offset);
        o = d.line, n = d.col;
      } else
        o = u.line, n = u.column;
    } else if (!i) {
      let c = this.fromOffset(t);
      t = c.line, i = c.col;
    }
    let l = this.origin(t, i, o, n);
    return l ? a = new lo(
      e,
      l.endLine === void 0 ? l.line : { column: l.column, line: l.line },
      l.endLine === void 0 ? l.column : { column: l.endColumn, line: l.endLine },
      l.source,
      l.file,
      r.plugin
    ) : a = new lo(
      e,
      o === void 0 ? t : { column: i, line: t },
      o === void 0 ? i : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), a.input = { column: i, endColumn: n, endLine: o, line: t, source: this.css }, this.file && (pi && (a.input.url = pi(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, i;
    if (this[Ks])
      i = this[Ks];
    else {
      let n = this.css.split(`
`);
      i = new Array(n.length);
      let o = 0;
      for (let a = 0, l = n.length; a < l; a++)
        i[a] = o, o += n[a].length + 1;
      this[Ks] = i;
    }
    t = i[i.length - 1];
    let r = 0;
    if (e >= t)
      r = i.length - 1;
    else {
      let n = i.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < i[o])
          n = o - 1;
        else if (e >= i[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - i[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : Rr(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, i, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof i == "number" && (a = n.originalPositionFor({ column: r, line: i }));
    let l;
    Wr(o.source) ? l = pi(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || pi(this.map.mapFile)
    );
    let c = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (oo)
        c.file = oo(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let u = n.sourceContentFor(o.source);
    return u && (c.source = u), c;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = S({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var hs = Bi;
Bi.default = Bi;
Fs && Fs.registerInput && Fs.registerInput(Bi);
let ua = je, da, ha, ht = class extends ua {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, i) {
    let r = super.normalize(e);
    if (t) {
      if (i === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let i = this.index(e);
    return !t && i === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[i].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new da(new ha(), this, e).stringify();
  }
};
ht.registerLazyResult = (s) => {
  da = s;
};
ht.registerProcessor = (s) => {
  ha = s;
};
var At = ht;
ht.default = ht;
ua.registerRoot(ht);
let Mt = {
  comma(s) {
    return Mt.split(s, [","], !0);
  },
  space(s) {
    let e = [" ", `
`, "	"];
    return Mt.split(s, e);
  },
  split(s, e, t) {
    let i = [], r = "", n = !1, o = 0, a = !1, l = "", c = !1;
    for (let u of s)
      c ? c = !1 : u === "\\" ? c = !0 : a ? u === l && (a = !1) : u === '"' || u === "'" ? (a = !0, l = u) : u === "(" ? o += 1 : u === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(u) && (n = !0), n ? (r !== "" && i.push(r.trim()), r = "", n = !1) : r += u;
    return (t || r !== "") && i.push(r.trim()), i;
  }
};
var pa = Mt;
Mt.default = Mt;
let ma = je, wp = pa, Di = class extends ma {
  get selectors() {
    return wp.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, i = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(i);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var nn = Di;
Di.default = Di;
ma.registerRule(Di);
let Cp = sn, vp = us, xp = ds, Lp = hs, Yp = ca, kp = At, Np = nn;
function zt(s, e) {
  if (Array.isArray(s)) return s.map((o) => zt(o));
  let r = s, { inputs: t } = r, i = pe(r, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = $(S({}, o), { __proto__: Lp.prototype });
      a.map && (a.map = $(S({}, a.map), {
        __proto__: Yp.prototype
      })), e.push(a);
    }
  }
  if (i.nodes && (i.nodes = s.nodes.map((o) => zt(o, e))), i.source) {
    let n = i.source, { inputId: o } = n, a = pe(n, ["inputId"]);
    i.source = a, o != null && (i.source.input = e[o]);
  }
  if (i.type === "root")
    return new kp(i);
  if (i.type === "decl")
    return new xp(i);
  if (i.type === "rule")
    return new Np(i);
  if (i.type === "comment")
    return new vp(i);
  if (i.type === "atrule")
    return new Cp(i);
  throw new Error("Unknown node type: " + s.type);
}
var Tp = zt;
zt.default = zt;
let { dirname: Li, relative: fa, resolve: ba, sep: ya } = Ve, { SourceMapConsumer: ga, SourceMapGenerator: Yi } = Ve, { pathToFileURL: co } = Ve, Jp = hs, Up = !!(ga && Yi), Fp = !!(Li && ba && fa && ya), Kp = class {
  constructor(e, t, i, r) {
    this.stringify = e, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), i = e.root || Li(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new ga(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(i)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Fp && Up && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Yi.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Yi({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Yi({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, i = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, l, c) => {
      if (this.css += a, l && c !== "end" && (r.generated.line = e, r.generated.column = t - 1, l.source && l.source.start ? (r.source = this.sourcePath(l), r.original.line = l.source.start.line, r.original.column = l.source.start.column - 1, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, l && c !== "start") {
        let u = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== u.last || u.raws.semicolon) && (l.source && l.source.end ? (r.source = this.sourcePath(l), r.original.line = l.source.end.line, r.original.column = l.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let i = this.opts.to ? Li(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (i = Li(ba(i, this.mapOpts.annotation)));
    let r = fa(i, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new Jp(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let i = t.source.input.from;
          if (i && !e[i]) {
            e[i] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(i) : this.toUrl(this.path(i));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (co) {
      let i = co(e).toString();
      return this.memoizedFileURLs.set(e, i), i;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    ya === "\\" && (e = e.replace(/\\/g, "/"));
    let i = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, i), i;
  }
};
var Za = Kp;
const Hs = 39, uo = 34, mi = 92, ho = 47, fi = 10, Wt = 32, bi = 12, yi = 9, gi = 13, Hp = 91, Mp = 93, zp = 40, Op = 41, Pp = 123, Ep = 125, Bp = 59, Dp = 42, jp = 58, Ap = 64, Zi = /[\t\n\f\r "#'()/;[\\\]{}]/g, Gi = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Qp = /.[\r\n"'(/\\]/, po = /[\da-f]/i;
var _p = function(e, t = {}) {
  let i = e.css.valueOf(), r = t.ignoreErrors, n, o, a, l, c, u, d, h, p, b, f = i.length, m = 0, X = [], R = [];
  function Z() {
    return m;
  }
  function W(L) {
    throw e.error("Unclosed " + L, m);
  }
  function G() {
    return R.length === 0 && m >= f;
  }
  function v(L) {
    if (R.length) return R.pop();
    if (m >= f) return;
    let V = L ? L.ignoreUnclosed : !1;
    switch (n = i.charCodeAt(m), n) {
      case fi:
      case Wt:
      case yi:
      case gi:
      case bi: {
        l = m;
        do
          l += 1, n = i.charCodeAt(l);
        while (n === Wt || n === fi || n === yi || n === gi || n === bi);
        u = ["space", i.slice(m, l)], m = l - 1;
        break;
      }
      case Hp:
      case Mp:
      case Pp:
      case Ep:
      case jp:
      case Bp:
      case Op: {
        let C = String.fromCharCode(n);
        u = [C, C, m];
        break;
      }
      case zp: {
        if (b = X.length ? X.pop()[1] : "", p = i.charCodeAt(m + 1), b === "url" && p !== Hs && p !== uo && p !== Wt && p !== fi && p !== yi && p !== bi && p !== gi) {
          l = m;
          do {
            if (d = !1, l = i.indexOf(")", l + 1), l === -1)
              if (r || V) {
                l = m;
                break;
              } else
                W("bracket");
            for (h = l; i.charCodeAt(h - 1) === mi; )
              h -= 1, d = !d;
          } while (d);
          u = ["brackets", i.slice(m, l + 1), m, l], m = l;
        } else
          l = i.indexOf(")", m + 1), o = i.slice(m, l + 1), l === -1 || Qp.test(o) ? u = ["(", "(", m] : (u = ["brackets", o, m, l], m = l);
        break;
      }
      case Hs:
      case uo: {
        c = n === Hs ? "'" : '"', l = m;
        do {
          if (d = !1, l = i.indexOf(c, l + 1), l === -1)
            if (r || V) {
              l = m + 1;
              break;
            } else
              W("string");
          for (h = l; i.charCodeAt(h - 1) === mi; )
            h -= 1, d = !d;
        } while (d);
        u = ["string", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      case Ap: {
        Zi.lastIndex = m + 1, Zi.test(i), Zi.lastIndex === 0 ? l = i.length - 1 : l = Zi.lastIndex - 2, u = ["at-word", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      case mi: {
        for (l = m, a = !0; i.charCodeAt(l + 1) === mi; )
          l += 1, a = !a;
        if (n = i.charCodeAt(l + 1), a && n !== ho && n !== Wt && n !== fi && n !== yi && n !== gi && n !== bi && (l += 1, po.test(i.charAt(l)))) {
          for (; po.test(i.charAt(l + 1)); )
            l += 1;
          i.charCodeAt(l + 1) === Wt && (l += 1);
        }
        u = ["word", i.slice(m, l + 1), m, l], m = l;
        break;
      }
      default: {
        n === ho && i.charCodeAt(m + 1) === Dp ? (l = i.indexOf("*/", m + 2) + 1, l === 0 && (r || V ? l = i.length : W("comment")), u = ["comment", i.slice(m, l + 1), m, l], m = l) : (Gi.lastIndex = m + 1, Gi.test(i), Gi.lastIndex === 0 ? l = i.length - 1 : l = Gi.lastIndex - 2, u = ["word", i.slice(m, l + 1), m, l], X.push(u), m = l);
        break;
      }
    }
    return m++, u;
  }
  function k(L) {
    R.push(L);
  }
  return {
    back: k,
    endOfFile: G,
    nextToken: v,
    position: Z
  };
};
let $p = sn, qp = us, em = ds, tm = At, mo = nn, im = _p;
const fo = {
  empty: !0,
  space: !0
};
function sm(s) {
  for (let e = s.length - 1; e >= 0; e--) {
    let t = s[e], i = t[3] || t[2];
    if (i) return i;
  }
}
let rm = class {
  constructor(e) {
    this.input = e, this.root = new tm(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new $p();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let i, r, n, o = !1, a = !1, l = [], c = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), i = e[0], i === "(" || i === "[" ? c.push(i === "(" ? ")" : "]") : i === "{" && c.length > 0 ? c.push("}") : i === c[c.length - 1] && c.pop(), c.length === 0)
        if (i === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (i === "{") {
          a = !0;
          break;
        } else if (i === "}") {
          if (l.length > 0) {
            for (n = l.length - 1, r = l[n]; r && r[0] === "space"; )
              r = l[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let i = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (i += 1, i === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, i, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!i)
          this.doubleColon(r);
        else {
          if (i[0] === "word" && i[1] === "progid")
            continue;
          return o;
        }
      i = r;
    }
    return !1;
  }
  comment(e) {
    let t = new qp();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let i = e[1].slice(2, -2);
    if (/^\s*$/.test(i))
      t.text = "", t.raws.left = i, t.raws.right = "";
    else {
      let r = i.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = im(this.input);
  }
  decl(e, t) {
    let i = new em();
    this.init(i, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), i.source.end = this.getPosition(
      r[3] || r[2] || sm(e)
    ), i.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), i.raws.before += e.shift()[1];
    for (i.source.start = this.getPosition(e[0][2]), i.prop = ""; e.length; ) {
      let c = e[0][0];
      if (c === ":" || c === "space" || c === "comment")
        break;
      i.prop += e.shift()[1];
    }
    i.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        i.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), i.raws.between += n[1];
    (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let c = e.length - 1; c >= 0; c--) {
      if (n = e[c], n[1].toLowerCase() === "!important") {
        i.important = !0;
        let u = this.stringFrom(e, c);
        u = this.spacesFromEnd(e) + u, u !== " !important" && (i.raws.important = u);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let u = e.slice(0), d = "";
        for (let h = c; h > 0; h--) {
          let p = u[h][0];
          if (d.trim().startsWith("!") && p !== "space")
            break;
          d = u.pop()[1] + d;
        }
        d.trim().startsWith("!") && (i.important = !0, i.raws.important = d, e = u);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((c) => c[0] !== "space" && c[0] !== "comment") && (i.raws.between += o.map((c) => c[1]).join(""), o = []), this.raw(i, "value", o.concat(e), t), i.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new mo();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, i = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), l = [], c = e;
    for (; c; ) {
      if (i = c[0], l.push(c), i === "(" || i === "[")
        n || (n = c), o.push(i === "(" ? ")" : "]");
      else if (a && r && i === "{")
        n || (n = c), o.push("}");
      else if (o.length === 0)
        if (i === ";")
          if (r) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (i === "{") {
          this.rule(l);
          return;
        } else if (i === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else i === ":" && (r = !0);
      else i === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      c = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; l.length && (c = l[l.length - 1][0], !(c !== "space" && c !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, i, r) {
    let n, o, a = i.length, l = "", c = !0, u, d;
    for (let h = 0; h < a; h += 1)
      n = i[h], o = n[0], o === "space" && h === a - 1 && !r ? c = !1 : o === "comment" ? (d = i[h - 1] ? i[h - 1][0] : "empty", u = i[h + 1] ? i[h + 1][0] : "empty", !fo[d] && !fo[u] ? l.slice(-1) === "," ? c = !1 : l += n[1] : c = !1) : l += n[1];
    if (!c) {
      let h = i.reduce((p, b) => p + b[1], "");
      e.raws[t] = { raw: h, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new mo();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      i = e.pop()[1] + i;
    return i;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, i = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      i += e.shift()[1];
    return i;
  }
  spacesFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      i = e.pop()[1] + i;
    return i;
  }
  stringFrom(e, t) {
    let i = "";
    for (let r = t; r < e.length; r++)
      i += e[r][1];
    return e.splice(t, e.length - t), i;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var nm = rm;
let om = je, lm = hs, am = nm;
function ji(s, e) {
  let t = new lm(s, e), i = new am(t);
  try {
    i.parse();
  } catch (r) {
    throw r;
  }
  return i.root;
}
var on = ji;
ji.default = ji;
om.registerParse(ji);
let wr = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (let i in t) this[i] = t[i];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Ga = wr;
wr.default = wr;
let cm = Ga, Cr = class {
  get content() {
    return this.css;
  }
  constructor(e, t, i) {
    this.processor = e, this.messages = [], this.root = t, this.opts = i, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let i = new cm(e, t);
    return this.messages.push(i), i;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var ln = Cr;
Cr.default = Cr;
let um = je, dm = rn, hm = Za, pm = on, bo = ln, mm = At, fm = as, { isClean: we, my: bm } = jt;
const ym = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, gm = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Zm = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, pt = 0;
function Rt(s) {
  return typeof s == "object" && typeof s.then == "function";
}
function Ia(s) {
  let e = !1, t = ym[s.type];
  return s.type === "decl" ? e = s.prop.toLowerCase() : s.type === "atrule" && (e = s.name.toLowerCase()), e && s.append ? [
    t,
    t + "-" + e,
    pt,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : s.append ? [t, pt, t + "Exit"] : [t, t + "Exit"];
}
function yo(s) {
  let e;
  return s.type === "document" ? e = ["Document", pt, "DocumentExit"] : s.type === "root" ? e = ["Root", pt, "RootExit"] : e = Ia(s), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: s,
    visitorIndex: 0,
    visitors: []
  };
}
function vr(s) {
  return s[we] = !1, s.nodes && s.nodes.forEach((e) => vr(e)), s;
}
let xr = {}, mt = class Sa {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, i) {
    this.stringified = !1, this.processed = !1;
    let r;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      r = vr(t);
    else if (t instanceof Sa || t instanceof bo)
      r = vr(t.root), t.map && (typeof i.map == "undefined" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      let n = pm;
      i.syntax && (n = i.syntax.parse), i.parser && (n = i.parser), n.parse && (n = n.parse);
      try {
        r = n(t, i);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      r && !r[bm] && um.rebuild(r);
    }
    this.result = new bo(e, r, i), this.helpers = $(S({}, xr), { postcss: xr, result: this.result }), this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? S(S({}, n), n.prepare(this.result)) : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let i = this.result.lastPlugin;
    try {
      t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin && (e.plugin = i.postcssPlugin, e.setMessage());
    } catch (r) {
      console && console.error && console.error(r);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, i, r) => {
      this.listeners[i] || (this.listeners[i] = []), this.listeners[i].push([t, r]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let i in t) {
          if (!gm[i] && /^[A-Z]/.test(i))
            throw new Error(
              `Unknown event ${i} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Zm[i])
            if (typeof t[i] == "object")
              for (let r in t[i])
                r === "*" ? e(t, i, t[i][r]) : e(
                  t,
                  i + "-" + r.toLowerCase(),
                  t[i][r]
                );
            else typeof t[i] == "function" && e(t, i, t[i]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return re(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], i = this.runOnRoot(t);
        if (Rt(i))
          try {
            yield i;
          } catch (r) {
            throw this.handleError(r);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[we]; ) {
          e[we] = !0;
          let t = [yo(e)];
          for (; t.length > 0; ) {
            let i = this.visitTick(t);
            if (Rt(i))
              try {
                yield i;
              } catch (r) {
                let n = t[t.length - 1].node;
                throw this.handleError(r, n);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, i] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let r = e.nodes.map(
                  (n) => i(n, this.helpers)
                );
                yield Promise.all(r);
              } else
                yield i(e, this.helpers);
            } catch (r) {
              throw this.handleError(r);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (i) => e.Once(i, this.helpers)
          );
          return Rt(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = fm;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let r = new hm(t, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Rt(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[we]; )
        e[we] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [i, r] of e) {
      this.result.lastPlugin = i;
      let n;
      try {
        n = r(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Rt(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: i, visitors: r } = t;
    if (i.type !== "root" && i.type !== "document" && !i.parent) {
      e.pop();
      return;
    }
    if (r.length > 0 && t.visitorIndex < r.length) {
      let [o, a] = r[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === r.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(i.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, i);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = i.nodes[i.indexes[o]]; )
        if (i.indexes[o] += 1, !a[we]) {
          a[we] = !0, e.push(yo(a));
          return;
        }
      t.iterator = 0, delete i.indexes[o];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let o = n[t.eventIndex];
      if (t.eventIndex += 1, o === pt) {
        i.nodes && i.nodes.length && (i[we] = !0, t.iterator = i.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[we] = !0;
    let t = Ia(e);
    for (let i of t)
      if (i === pt)
        e.nodes && e.each((r) => {
          r[we] || this.walkSync(r);
        });
      else {
        let r = this.listeners[i];
        if (r && this.visitSync(r, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
mt.registerPostcss = (s) => {
  xr = s;
};
var Va = mt;
mt.default = mt;
mm.registerLazyResult(mt);
dm.registerLazyResult(mt);
let Gm = Za, Im = on;
const Sm = ln;
let Vm = as, Lr = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = Im;
    try {
      e = t(this._css, this._opts);
    } catch (i) {
      this.error = i;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = i, this._map = void 0;
    let r, n = Vm;
    this.result = new Sm(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new Gm(n, r, this._opts, t);
    if (a.isMap()) {
      let [l, c] = a.generate();
      l && (this.result.css = l), c && (this.result.map = c);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Xm = Lr;
Lr.default = Lr;
let Wm = rn, Rm = Va, wm = Xm, Cm = At, Ot = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let i of e)
      if (i.postcss === !0 ? i = i() : i.postcss && (i = i.postcss), typeof i == "object" && Array.isArray(i.plugins))
        t = t.concat(i.plugins);
      else if (typeof i == "object" && i.postcssPlugin)
        t.push(i);
      else if (typeof i == "function")
        t.push(i);
      else if (!(typeof i == "object" && (i.parse || i.stringify))) throw new Error(i + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new wm(this, e, t) : new Rm(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var vm = Ot;
Ot.default = Ot;
Cm.registerProcessor(Ot);
Wm.registerProcessor(Ot);
let Xa = sn, Wa = us, xm = je, Lm = qr, Ra = ds, wa = rn, Ym = Tp, km = hs, Nm = Va, Tm = pa, Jm = cs, Um = on, an = vm, Fm = ln, Ca = At, va = nn, Km = as, Hm = Ga;
function B(...s) {
  return s.length === 1 && Array.isArray(s[0]) && (s = s[0]), new an(s);
}
B.plugin = function(e, t) {
  let i = !1;
  function r(...o) {
    console && console.warn && !i && (i = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new an().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, l) {
    return B([r(l)]).process(o, a);
  }, r;
};
B.stringify = Km;
B.parse = Um;
B.fromJSON = Ym;
B.list = Tm;
B.comment = (s) => new Wa(s);
B.atRule = (s) => new Xa(s);
B.decl = (s) => new Ra(s);
B.rule = (s) => new va(s);
B.root = (s) => new Ca(s);
B.document = (s) => new wa(s);
B.CssSyntaxError = Lm;
B.Declaration = Ra;
B.Container = xm;
B.Processor = an;
B.Document = wa;
B.Comment = Wa;
B.Warning = Hm;
B.AtRule = Xa;
B.Result = Fm;
B.Input = km;
B.Rule = va;
B.Root = Ca;
B.Node = Jm;
Nm.registerPostcss(B);
B.default = B;
class cn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...e) {
    me(this, "parentElement", null), me(this, "parentNode", null), me(this, "ownerDocument"), me(this, "firstChild", null), me(this, "lastChild", null), me(this, "previousSibling", null), me(this, "nextSibling", null), me(this, "ELEMENT_NODE", 1), me(this, "TEXT_NODE", 3), me(this, "nodeType"), me(this, "nodeName"), me(this, "RRNodeType");
  }
  get childNodes() {
    const e = [];
    let t = this.firstChild;
    for (; t; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  contains(e) {
    if (e instanceof cn) {
      if (e.ownerDocument !== this.ownerDocument) return !1;
      if (e === this) return !0;
    } else return !1;
    for (; e.parentNode; ) {
      if (e.parentNode === this) return !0;
      e = e.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(e, t) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
const go = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, Zo = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, Ii = {}, Mm = () => !!globalThis.Zone;
function un(s) {
  if (Ii[s])
    return Ii[s];
  const e = globalThis[s], t = e.prototype, i = s in go ? go[s] : void 0, r = !!(i && // @ts-expect-error 2345
  i.every(
    (a) => {
      var l, c;
      return !!((c = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && c.toString().includes("[native code]"));
    }
  )), n = s in Zo ? Zo[s] : void 0, o = !!(n && n.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (r && o && !Mm())
    return Ii[s] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const c = l[s].prototype;
    return document.body.removeChild(a), c ? Ii[s] = c : t;
  } catch (a) {
    return t;
  }
}
const Ms = {};
function ze(s, e, t) {
  var i;
  const r = `${s}.${String(t)}`;
  if (Ms[r])
    return Ms[r].call(
      e
    );
  const n = un(s), o = (i = Object.getOwnPropertyDescriptor(
    n,
    t
  )) == null ? void 0 : i.get;
  return o ? (Ms[r] = o, o.call(e)) : e[t];
}
const zs = {};
function xa(s, e, t) {
  const i = `${s}.${String(t)}`;
  if (zs[i])
    return zs[i].bind(
      e
    );
  const n = un(s)[t];
  return typeof n != "function" ? e[t] : (zs[i] = n, n.bind(e));
}
function zm(s) {
  return ze("Node", s, "childNodes");
}
function Om(s) {
  return ze("Node", s, "parentNode");
}
function Pm(s) {
  return ze("Node", s, "parentElement");
}
function Em(s) {
  return ze("Node", s, "textContent");
}
function Bm(s, e) {
  return xa("Node", s, "contains")(e);
}
function Dm(s) {
  return xa("Node", s, "getRootNode")();
}
function jm(s) {
  return !s || !("host" in s) ? null : ze("ShadowRoot", s, "host");
}
function Am(s) {
  return s.styleSheets;
}
function Qm(s) {
  return !s || !("shadowRoot" in s) ? null : ze("Element", s, "shadowRoot");
}
function _m(s, e) {
  return ze("Element", s, "querySelector")(e);
}
function $m(s, e) {
  return ze("Element", s, "querySelectorAll")(e);
}
function La() {
  return un("MutationObserver").constructor;
}
function Ae(s, e, t) {
  try {
    if (!(e in s))
      return () => {
      };
    const i = s[e], r = t(i);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), s[e] = r, () => {
      s[e] = i;
    };
  } catch (i) {
    return () => {
    };
  }
}
const K = {
  childNodes: zm,
  parentNode: Om,
  parentElement: Pm,
  textContent: Em,
  contains: Bm,
  getRootNode: Dm,
  host: jm,
  styleSheets: Am,
  shadowRoot: Qm,
  querySelector: _m,
  querySelectorAll: $m,
  mutationObserver: La,
  patch: Ae
};
function ue(s, e, t = document) {
  const i = { capture: !0 };
  return t.addEventListener(s, e, i), () => t.removeEventListener(s, e, i);
}
const it = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Go = {
  map: {},
  getId() {
    return console.error(it), -1;
  },
  getNode() {
    return console.error(it), null;
  },
  removeNodeFromMap() {
    console.error(it);
  },
  has() {
    return console.error(it), !1;
  },
  reset() {
    console.error(it);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (Go = new Proxy(Go, {
  get(s, e, t) {
    return e === "map" && console.error(it), Reflect.get(s, e, t);
  }
}));
function Pt(s, e, t = {}) {
  let i = null, r = 0;
  return function(...n) {
    const o = Date.now();
    !r && t.leading === !1 && (r = o);
    const a = e - (o - r), l = this;
    a <= 0 || a > e ? (i && (clearTimeout(i), i = null), r = o, s.apply(l, n)) : !i && t.trailing !== !1 && (i = setTimeout(() => {
      r = t.leading === !1 ? 0 : Date.now(), i = null, s.apply(l, n);
    }, a));
  };
}
function ps(s, e, t, i, r = window) {
  const n = r.Object.getOwnPropertyDescriptor(s, e);
  return r.Object.defineProperty(
    s,
    e,
    i ? t : {
      set(o) {
        setTimeout(() => {
          t.set.call(this, o);
        }, 0), n && n.set && n.set.call(this, o);
      }
    }
  ), () => ps(s, e, n || {}, !0);
}
let Ai = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (Ai = () => (/* @__PURE__ */ new Date()).getTime());
function Ya(s) {
  var e, t, i, r;
  const n = s.document;
  return {
    left: n.scrollingElement ? n.scrollingElement.scrollLeft : s.pageXOffset !== void 0 ? s.pageXOffset : n.documentElement.scrollLeft || (n == null ? void 0 : n.body) && ((e = K.parentElement(n.body)) == null ? void 0 : e.scrollLeft) || ((t = n == null ? void 0 : n.body) == null ? void 0 : t.scrollLeft) || 0,
    top: n.scrollingElement ? n.scrollingElement.scrollTop : s.pageYOffset !== void 0 ? s.pageYOffset : (n == null ? void 0 : n.documentElement.scrollTop) || (n == null ? void 0 : n.body) && ((i = K.parentElement(n.body)) == null ? void 0 : i.scrollTop) || ((r = n == null ? void 0 : n.body) == null ? void 0 : r.scrollTop) || 0
  };
}
function ka() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Na() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Ta(s) {
  return s ? s.nodeType === s.ELEMENT_NODE ? s : K.parentElement(s) : null;
}
const qm = (s) => {
  try {
    if (s instanceof HTMLElement)
      return s.tagName === "CANVAS";
  } catch (e) {
    return !1;
  }
  return !1;
};
function le(s, e, t, i) {
  if (!s)
    return !1;
  const r = Ta(s);
  if (!r)
    return !1;
  try {
    if (typeof e == "string") {
      if (r.classList.contains(e) || i && r.closest("." + e) !== null) return !0;
    } else if (Hi(r, e, i)) return !0;
  } catch (n) {
  }
  return !!(t && (r.matches(t) || i && r.closest(t) !== null));
}
function ef(s, e) {
  return e.getId(s) !== -1;
}
function Os(s, e, t) {
  return s.tagName === "TITLE" && t.headTitleMutations ? !0 : e.getId(s) === Tt;
}
function Ja(s, e) {
  if (xt(s))
    return !1;
  const t = e.getId(s);
  if (!e.has(t))
    return !0;
  const i = K.parentNode(s);
  return i && i.nodeType === s.DOCUMENT_NODE ? !1 : i ? Ja(i, e) : !0;
}
function Yr(s) {
  return !!s.changedTouches;
}
function tf(s = window) {
  "NodeList" in s && !s.NodeList.prototype.forEach && (s.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in s && !s.DOMTokenList.prototype.forEach && (s.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function Ua(s, e) {
  return !!(s.nodeName === "IFRAME" && e.getMeta(s));
}
function Fa(s, e) {
  return !!(s.nodeName === "LINK" && s.nodeType === s.ELEMENT_NODE && s.getAttribute && s.getAttribute("rel") === "stylesheet" && e.getMeta(s));
}
function kr(s) {
  return s ? s instanceof cn && "shadowRoot" in s ? !!s.shadowRoot : !!K.shadowRoot(s) : !1;
}
class sf {
  constructor() {
    I(this, "id", 1), I(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), I(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(e) {
    var t;
    return (t = this.styleIDMap.get(e)) != null ? t : -1;
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(e, t) {
    if (this.has(e)) return this.getId(e);
    let i;
    return t === void 0 ? i = this.id++ : i = t, this.styleIDMap.set(e, i), this.idStyleMap.set(i, e), i;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function Ka(s) {
  var e;
  let t = null;
  return "getRootNode" in s && ((e = K.getRootNode(s)) == null ? void 0 : e.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && K.host(K.getRootNode(s)) && (t = K.host(K.getRootNode(s))), t;
}
function rf(s) {
  let e = s, t;
  for (; t = Ka(e); )
    e = t;
  return e;
}
function nf(s) {
  const e = s.ownerDocument;
  if (!e) return !1;
  const t = rf(s);
  return K.contains(e, t);
}
function Ha(s) {
  const e = s.ownerDocument;
  return e ? K.contains(e, s) || nf(s) : !1;
}
var z = /* @__PURE__ */ ((s) => (s[s.DomContentLoaded = 0] = "DomContentLoaded", s[s.Load = 1] = "Load", s[s.FullSnapshot = 2] = "FullSnapshot", s[s.IncrementalSnapshot = 3] = "IncrementalSnapshot", s[s.Meta = 4] = "Meta", s[s.Custom = 5] = "Custom", s[s.Plugin = 6] = "Plugin", s))(z || {}), H = /* @__PURE__ */ ((s) => (s[s.Mutation = 0] = "Mutation", s[s.MouseMove = 1] = "MouseMove", s[s.MouseInteraction = 2] = "MouseInteraction", s[s.Scroll = 3] = "Scroll", s[s.ViewportResize = 4] = "ViewportResize", s[s.Input = 5] = "Input", s[s.TouchMove = 6] = "TouchMove", s[s.MediaInteraction = 7] = "MediaInteraction", s[s.StyleSheetRule = 8] = "StyleSheetRule", s[s.CanvasMutation = 9] = "CanvasMutation", s[s.Font = 10] = "Font", s[s.Log = 11] = "Log", s[s.Drag = 12] = "Drag", s[s.StyleDeclaration = 13] = "StyleDeclaration", s[s.Selection = 14] = "Selection", s[s.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", s[s.CustomElement = 16] = "CustomElement", s))(H || {}), de = /* @__PURE__ */ ((s) => (s[s.MouseUp = 0] = "MouseUp", s[s.MouseDown = 1] = "MouseDown", s[s.Click = 2] = "Click", s[s.ContextMenu = 3] = "ContextMenu", s[s.DblClick = 4] = "DblClick", s[s.Focus = 5] = "Focus", s[s.Blur = 6] = "Blur", s[s.TouchStart = 7] = "TouchStart", s[s.TouchMove_Departed = 8] = "TouchMove_Departed", s[s.TouchEnd = 9] = "TouchEnd", s[s.TouchCancel = 10] = "TouchCancel", s))(de || {}), Fe = /* @__PURE__ */ ((s) => (s[s.Mouse = 0] = "Mouse", s[s.Pen = 1] = "Pen", s[s.Touch = 2] = "Touch", s))(Fe || {}), ft = /* @__PURE__ */ ((s) => (s[s["2D"] = 0] = "2D", s[s.WebGL = 1] = "WebGL", s[s.WebGL2 = 2] = "WebGL2", s))(ft || {}), st = /* @__PURE__ */ ((s) => (s[s.Play = 0] = "Play", s[s.Pause = 1] = "Pause", s[s.Seeked = 2] = "Seeked", s[s.VolumeChange = 3] = "VolumeChange", s[s.RateChange = 4] = "RateChange", s))(st || {}), Ma = /* @__PURE__ */ ((s) => (s[s.Document = 0] = "Document", s[s.DocumentType = 1] = "DocumentType", s[s.Element = 2] = "Element", s[s.Text = 3] = "Text", s[s.CDATA = 4] = "CDATA", s[s.Comment = 5] = "Comment", s))(Ma || {});
function Io(s) {
  return "__ln" in s;
}
class of {
  constructor() {
    I(this, "length", 0), I(this, "head", null), I(this, "tail", null);
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let t = this.head;
    for (let i = 0; i < e; i++)
      t = (t == null ? void 0 : t.next) || null;
    return t;
  }
  addNode(e) {
    const t = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = t, e.previousSibling && Io(e.previousSibling)) {
      const i = e.previousSibling.__ln.next;
      t.next = i, t.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = t, i && (i.previous = t);
    } else if (e.nextSibling && Io(e.nextSibling) && e.nextSibling.__ln.previous) {
      const i = e.nextSibling.__ln.previous;
      t.previous = i, t.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = t, i && (i.next = t);
    } else
      this.head && (this.head.previous = t), t.next = this.head, this.head = t;
    t.next === null && (this.tail = t), this.length++;
  }
  removeNode(e) {
    const t = e.__ln;
    this.head && (t.previous ? (t.previous.next = t.next, t.next ? t.next.previous = t.previous : this.tail = t.previous) : (this.head = t.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
}
const So = (s, e) => `${s}@${e}`;
class lf {
  constructor() {
    I(this, "frozen", !1), I(this, "locked", !1), I(this, "texts", []), I(this, "attributes", []), I(this, "attributeMap", /* @__PURE__ */ new WeakMap()), I(this, "removes", []), I(this, "mapRemoves", []), I(this, "movedMap", {}), I(this, "addedSet", /* @__PURE__ */ new Set()), I(this, "movedSet", /* @__PURE__ */ new Set()), I(this, "droppedSet", /* @__PURE__ */ new Set()), I(this, "removesSubTreeCache", /* @__PURE__ */ new Set()), I(this, "mutationCb"), I(this, "blockClass"), I(this, "blockSelector"), I(this, "maskTextClass"), I(this, "maskTextSelector"), I(this, "inlineStylesheet"), I(this, "maskInputOptions"), I(this, "maskTextFn"), I(this, "maskInputFn"), I(this, "keepIframeSrcFn"), I(this, "recordCanvas"), I(this, "inlineImages"), I(this, "inlineVideos"), I(this, "privacySetting"), I(this, "slimDOMOptions"), I(this, "dataURLOptions"), I(this, "doc"), I(this, "mirror"), I(this, "iframeManager"), I(this, "stylesheetManager"), I(this, "shadowDomManager"), I(this, "canvasManager"), I(this, "processedNodeManager"), I(this, "unattachedDoc"), I(this, "processMutations", (e) => {
      e.forEach(this.processMutation), this.emit();
    }), I(this, "emit", () => {
      if (this.frozen || this.locked)
        return;
      const e = [], t = /* @__PURE__ */ new Set(), i = new of(), r = (l) => {
        let c = l, u = Tt;
        for (; u === Tt; )
          c = c && c.nextSibling, u = c && this.mirror.getId(c);
        return u;
      }, n = (l) => {
        const c = K.parentNode(l);
        if (!c || !Ha(l))
          return;
        let u = !1;
        if (l.nodeType === Node.TEXT_NODE) {
          const b = c.tagName;
          if (b === "TEXTAREA")
            return;
          b === "STYLE" && this.addedSet.has(c) && (u = !0);
        }
        const d = xt(c) ? this.mirror.getId(Ka(l)) : this.mirror.getId(c), h = r(l);
        if (d === -1 || h === -1)
          return i.addNode(l);
        const p = nt(l, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          privacySetting: this.privacySetting,
          onSerialize: (b) => {
            Ua(b, this.mirror) && this.iframeManager.addIframe(b), Fa(b, this.mirror) && this.stylesheetManager.trackLinkElement(
              b
            ), kr(l) && this.shadowDomManager.addShadowRoot(K.shadowRoot(l), this.doc);
          },
          onIframeLoad: (b, f) => {
            this.iframeManager.attachIframe(b, f), this.shadowDomManager.observeAttachShadow(b);
          },
          onStylesheetLoad: (b, f) => {
            this.stylesheetManager.attachLinkElement(b, f);
          },
          cssCaptured: u
        });
        p && (e.push({
          parentId: d,
          nextId: h,
          node: p
        }), t.add(p.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const l of this.movedSet)
        Vo(this.removesSubTreeCache, l) && !this.movedSet.has(K.parentNode(l)) || n(l);
      for (const l of this.addedSet)
        !Xo(this.droppedSet, l) && !Vo(this.removesSubTreeCache, l) || Xo(this.movedSet, l) ? n(l) : this.droppedSet.add(l);
      let o = null;
      for (; i.length; ) {
        let l = null;
        if (o) {
          const c = this.mirror.getId(K.parentNode(o.value)), u = r(o.value);
          c !== -1 && u !== -1 && (l = o);
        }
        if (!l) {
          let c = i.tail;
          for (; c; ) {
            const u = c;
            if (c = c.previous, u) {
              const d = this.mirror.getId(K.parentNode(u.value));
              if (r(u.value) === -1) continue;
              if (d !== -1) {
                l = u;
                break;
              } else {
                const p = u.value, b = K.parentNode(p);
                if (b && b.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const f = K.host(b);
                  if (this.mirror.getId(f) !== -1) {
                    l = u;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!l) {
          for (; i.head; )
            i.removeNode(i.head.value);
          break;
        }
        o = l.previous, i.removeNode(l.value), n(l.value);
      }
      const a = {
        texts: this.texts.map((l) => {
          var c, u;
          const d = l.node, h = K.parentNode(d);
          h && h.tagName === "TEXTAREA" && this.genTextAreaValueMutation(h);
          let p = l.value;
          const b = this.privacySetting === "strict", f = this.privacySetting === "default" && ol(p), m = (u = (c = l.node) == null ? void 0 : c.parentElement) == null ? void 0 : u.getAttribute("data-hl-record");
          return (b || f) && !m && p && (p = Hr(p)), {
            id: this.mirror.getId(d),
            value: p
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        attributes: this.attributes.map((l) => {
          const { attributes: c } = l;
          if (typeof c.style == "string") {
            const u = JSON.stringify(l.styleDiff), d = JSON.stringify(l._unchangedStyles);
            u.length < c.style.length && (u + d).split("var(").length === c.style.split("var(").length && (c.style = l.styleDiff);
          }
          return {
            id: this.mirror.getId(l.node),
            attributes: c
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        removes: this.removes,
        adds: e
      };
      !a.texts.length && !a.attributes.length && !a.removes.length && !a.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.removesSubTreeCache = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(a));
    }), I(this, "genTextAreaValueMutation", (e) => {
      let t = this.attributeMap.get(e);
      t || (t = {
        node: e,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(t), this.attributeMap.set(e, t));
      const i = Array.from(
        K.childNodes(e),
        (r) => K.textContent(r) || ""
      ).join("");
      t.attributes.value = Ui({
        overwriteRecord: null,
        element: e,
        maskInputOptions: this.maskInputOptions,
        tagName: e.tagName,
        type: Fi(e),
        value: i,
        maskInputFn: this.maskInputFn
      });
    }), I(this, "processMutation", (e) => {
      if (!Os(e.target, this.mirror, this.slimDOMOptions))
        switch (e.type) {
          case "characterData": {
            const t = K.textContent(e.target);
            !le(e.target, this.blockClass, this.blockSelector, !1) && t !== e.oldValue && this.texts.push({
              value: dl(
                e.target,
                this.maskTextClass,
                this.maskTextSelector,
                !0
                // checkAncestors
              ) && t ? this.maskTextFn ? this.maskTextFn(t, Ta(e.target)) : t.replace(/[\S]/g, "*") : t,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const t = e.target;
            let i = e.attributeName, r = e.target.getAttribute(i);
            if (i === "value") {
              const o = Fi(t);
              r = Ui({
                element: t,
                maskInputOptions: this.maskInputOptions,
                tagName: t.tagName,
                type: o,
                value: r,
                overwriteRecord: t.getAttribute("data-hl-record"),
                maskInputFn: this.maskInputFn
              });
            }
            if (le(e.target, this.blockClass, this.blockSelector, !1) || r === e.oldValue)
              return;
            let n = this.attributeMap.get(e.target);
            if (t.tagName === "IFRAME" && i === "src" && !this.keepIframeSrcFn(r))
              if (!t.contentDocument)
                i = "rr_src";
              else
                return;
            if (n || (n = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(n), this.attributeMap.set(e.target, n)), i === "type" && t.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && t.setAttribute("data-rr-is-password", "true"), !ul(t.tagName, i)) {
              if (e.target.tagName === "INPUT") {
                const a = e.target;
                if (a.type === "password") {
                  n.attributes.value = "*".repeat(a.value.length);
                  break;
                }
              }
              if (n.attributes[i] = cl(
                this.doc,
                at(t.tagName),
                at(i),
                r
              ), i === "style") {
                if (!this.unattachedDoc)
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (l) {
                    this.unattachedDoc = this.doc;
                  }
                const a = this.unattachedDoc.createElement("span");
                e.oldValue && a.setAttribute("style", e.oldValue);
                for (const l of Array.from(t.style)) {
                  const c = t.style.getPropertyValue(l), u = t.style.getPropertyPriority(l);
                  c !== a.style.getPropertyValue(l) || u !== a.style.getPropertyPriority(l) ? u === "" ? n.styleDiff[l] = c : n.styleDiff[l] = [c, u] : n._unchangedStyles[l] = [c, u];
                }
                for (const l of Array.from(a.style))
                  t.style.getPropertyValue(l) === "" && (n.styleDiff[l] = !1);
              } else i === "open" && t.tagName === "DIALOG" && (t.matches("dialog:modal") ? n.attributes.rr_open_mode = "modal" : n.attributes.rr_open_mode = "non-modal");
            }
            break;
          }
          case "childList": {
            if (le(e.target, this.blockClass, this.blockSelector, !0))
              return;
            if (e.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(e.target);
              return;
            }
            e.addedNodes.forEach((t) => this.genAdds(t, e.target)), e.removedNodes.forEach((t) => {
              const i = this.mirror.getId(t), r = xt(e.target) ? this.mirror.getId(K.host(e.target)) : this.mirror.getId(e.target);
              le(e.target, this.blockClass, this.blockSelector, !1) || Os(t, this.mirror, this.slimDOMOptions) || !ef(t, this.mirror) || (this.addedSet.has(t) ? (Nr(this.addedSet, t), this.droppedSet.add(t)) : this.addedSet.has(e.target) && i === -1 || Ja(e.target, this.mirror) || (this.movedSet.has(t) && this.movedMap[So(i, r)] ? Nr(this.movedSet, t) : (this.removes.push({
                parentId: r,
                id: i,
                isShadow: xt(e.target) && Lt(e.target) ? !0 : void 0
              }), af(t, this.removesSubTreeCache))), this.mapRemoves.push(t));
            });
            break;
          }
        }
    }), I(this, "genAdds", (e, t) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (Os(e, this.mirror, this.slimDOMOptions))
            return;
          this.movedSet.add(e);
          let i = null;
          t && this.mirror.hasNode(t) && (i = this.mirror.getId(t)), i && i !== -1 && (this.movedMap[So(this.mirror.getId(e), i)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        le(e, this.blockClass, this.blockSelector, !1) || (K.childNodes(e).forEach((i) => this.genAdds(i)), kr(e) && K.childNodes(K.shadowRoot(e)).forEach((i) => {
          this.processedNodeManager.add(i, this), this.genAdds(i, e);
        }));
      }
    });
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "inlineVideos",
      "privacySetting",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((t) => {
      this[t] = e[t];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Nr(s, e) {
  s.delete(e), K.childNodes(e).forEach((t) => Nr(s, t));
}
function af(s, e) {
  const t = [s];
  for (; t.length; ) {
    const i = t.pop();
    e.has(i) || (e.add(i), K.childNodes(i).forEach((r) => t.push(r)));
  }
}
function Vo(s, e, t) {
  return s.size === 0 ? !1 : cf(s, e);
}
function cf(s, e, t) {
  const i = K.parentNode(e);
  return i ? s.has(i) : !1;
}
function Xo(s, e) {
  return s.size === 0 ? !1 : za(s, e);
}
function za(s, e) {
  const t = K.parentNode(e);
  return t ? s.has(t) ? !0 : za(s, t) : !1;
}
let Yt;
function uf(s) {
  Yt = s;
}
function df() {
  Yt = void 0;
}
const M = (s) => Yt ? (...t) => {
  try {
    return s(...t);
  } catch (i) {
    if (Yt && Yt(i) === !0)
      return;
    throw i;
  }
} : s, Ee = [];
function Qt(s) {
  try {
    if ("composedPath" in s) {
      const e = s.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in s && s.path.length)
      return s.path[0];
  } catch (e) {
  }
  return s && s.target;
}
function Oa(s, e) {
  const t = new lf();
  Ee.push(t), t.init(s);
  const i = new (La())(
    M(t.processMutations.bind(t))
  );
  return i.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function hf({
  mousemoveCb: s,
  sampling: e,
  doc: t,
  mirror: i
}) {
  if (e.mousemove === !1)
    return () => {
    };
  const r = typeof e.mousemove == "number" ? e.mousemove : 50, n = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], a;
  const l = Pt(
    M(
      (d) => {
        const h = Date.now() - a;
        s(
          o.map((p) => (p.timeOffset -= h, p)),
          d
        ), o = [], a = null;
      }
    ),
    n
  ), c = M(
    Pt(
      M((d) => {
        const h = Qt(d), { clientX: p, clientY: b } = Yr(d) ? d.changedTouches[0] : d;
        a || (a = Ai()), o.push({
          x: p,
          y: b,
          id: i.getId(h),
          timeOffset: Ai() - a
        }), l(
          typeof DragEvent != "undefined" && d instanceof DragEvent ? H.Drag : d instanceof MouseEvent ? H.MouseMove : H.TouchMove
        );
      }),
      r,
      {
        trailing: !1
      }
    )
  ), u = [
    ue("mousemove", c, t),
    ue("touchmove", c, t),
    ue("drag", c, t)
  ];
  return M(() => {
    u.forEach((d) => d());
  });
}
function pf({
  mouseInteractionCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  sampling: n
}) {
  if (n.mouseInteraction === !1)
    return () => {
    };
  const o = n.mouseInteraction === !0 || n.mouseInteraction === void 0 ? {} : n.mouseInteraction, a = [];
  let l = null;
  const c = (u) => (d) => {
    const h = Qt(d);
    if (le(h, i, r, !0) || // We ignore canvas elements for rage click detection because we cannot infer what inside the canvas is getting interacted with.
    qm(h))
      return;
    let p = null, b = u;
    if ("pointerType" in d) {
      switch (d.pointerType) {
        case "mouse":
          p = Fe.Mouse;
          break;
        case "touch":
          p = Fe.Touch;
          break;
        case "pen":
          p = Fe.Pen;
          break;
      }
      p === Fe.Touch && (de[u] === de.MouseDown ? b = "TouchStart" : de[u] === de.MouseUp && (b = "TouchEnd"));
    } else Yr(d) && (p = Fe.Touch);
    p !== null ? (l = p, (b.startsWith("Touch") && p === Fe.Touch || b.startsWith("Mouse") && p === Fe.Mouse) && (p = null)) : de[u] === de.Click && (p = l, l = null);
    const f = Yr(d) ? d.changedTouches[0] : d;
    if (!f)
      return;
    const m = t.getId(h), { clientX: X, clientY: R } = f;
    M(s)(S({
      type: de[b],
      id: m,
      x: X,
      y: R
    }, p !== null && { pointerType: p }));
  };
  return Object.keys(de).filter(
    (u) => Number.isNaN(Number(u)) && !u.endsWith("_Departed") && o[u] !== !1
  ).forEach((u) => {
    let d = at(u);
    const h = c(u);
    if (window.PointerEvent)
      switch (de[u]) {
        case de.MouseDown:
        case de.MouseUp:
          d = d.replace(
            "mouse",
            "pointer"
          );
          break;
        case de.TouchStart:
        case de.TouchEnd:
          return;
      }
    a.push(ue(d, h, e));
  }), M(() => {
    a.forEach((u) => u());
  });
}
function Pa({
  scrollCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  sampling: n
}) {
  const o = M(
    Pt(
      M((a) => {
        const l = Qt(a);
        if (!l || le(l, i, r, !0))
          return;
        const c = t.getId(l);
        if (l === e && e.defaultView) {
          const u = Ya(e.defaultView);
          s({
            id: c,
            x: u.left,
            y: u.top
          });
        } else
          s({
            id: c,
            x: l.scrollLeft,
            y: l.scrollTop
          });
      }),
      n.scroll || 100
    )
  );
  return ue("scroll", o, e);
}
function mf({ viewportResizeCb: s }, { win: e }) {
  let t = -1, i = -1;
  const r = M(
    Pt(
      M(() => {
        const n = ka(), o = Na();
        (t !== n || i !== o) && (s({
          width: Number(o),
          height: Number(n)
        }), t = n, i = o);
      }),
      200
    )
  );
  return ue("resize", r, e);
}
const ff = ["INPUT", "TEXTAREA", "SELECT"], Wo = /* @__PURE__ */ new WeakMap();
function bf({
  inputCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  ignoreClass: n,
  ignoreSelector: o,
  maskInputOptions: a,
  maskInputFn: l,
  sampling: c,
  userTriggeredOnInput: u
}) {
  function d(R) {
    let Z = Qt(R);
    const W = R.isTrusted, G = Z && Z.tagName;
    if (Z && G === "OPTION" && (Z = K.parentElement(Z)), !Z || !G || ff.indexOf(G) < 0 || le(Z, i, r, !0) || Z.classList.contains(n) || o && Z.matches(o))
      return;
    let v = Z.value, k = !1;
    const L = Fi(Z) || "", V = Z.getAttribute("data-hl-record");
    L === "radio" || L === "checkbox" ? k = Z.checked : ll({
      maskInputOptions: a,
      type: L,
      tagName: G,
      overwriteRecord: V
    }) && (v = Ui({
      element: Z,
      maskInputOptions: a,
      tagName: G,
      type: L,
      value: v,
      overwriteRecord: V,
      maskInputFn: l
    })), h(
      Z,
      u ? { text: v, isChecked: k, userTriggered: W } : { text: v, isChecked: k }
    );
    const C = Z.name;
    L === "radio" && C && k && e.querySelectorAll(`input[type="radio"][name="${C}"]`).forEach((N) => {
      if (N !== Z) {
        const D = N.value;
        h(
          N,
          u ? { text: D, isChecked: !k, userTriggered: !1 } : { text: D, isChecked: !k }
        );
      }
    });
  }
  function h(R, Z) {
    const W = Wo.get(R);
    if (!W || W.text !== Z.text || W.isChecked !== Z.isChecked) {
      Wo.set(R, Z);
      const G = t.getId(R);
      M(s)($(S({}, Z), {
        id: G
      }));
    }
  }
  const b = (c.input === "last" ? ["change"] : ["input", "change"]).map(
    (R) => ue(R, M(d), e)
  ), f = e.defaultView;
  if (!f)
    return () => {
      b.forEach((R) => R());
    };
  const m = f.Object.getOwnPropertyDescriptor(
    f.HTMLInputElement.prototype,
    "value"
  ), X = [
    [f.HTMLInputElement.prototype, "value"],
    [f.HTMLInputElement.prototype, "checked"],
    [f.HTMLSelectElement.prototype, "value"],
    [f.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [f.HTMLSelectElement.prototype, "selectedIndex"],
    [f.HTMLOptionElement.prototype, "selected"]
  ];
  return m && m.set && b.push(
    ...X.map(
      (R) => ps(
        R[0],
        R[1],
        {
          set() {
            M(d)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        f
      )
    )
  ), M(() => {
    b.forEach((R) => R());
  });
}
function Qi(s) {
  const e = [];
  function t(i, r) {
    if (Si("CSSGroupingRule") && i.parentRule instanceof CSSGroupingRule || Si("CSSMediaRule") && i.parentRule instanceof CSSMediaRule || Si("CSSSupportsRule") && i.parentRule instanceof CSSSupportsRule || Si("CSSConditionRule") && i.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        i.parentRule.cssRules
      ).indexOf(i);
      r.unshift(o);
    } else if (i.parentStyleSheet) {
      const o = Array.from(i.parentStyleSheet.cssRules).indexOf(i);
      r.unshift(o);
    }
    return r;
  }
  return t(s, e);
}
function Ke(s, e, t) {
  let i, r;
  return s ? (s.ownerNode ? i = e.getId(s.ownerNode) : r = t.getId(s), {
    styleId: r,
    id: i
  }) : {};
}
function yf({ styleSheetRuleCb: s, mirror: e, stylesheetManager: t }, { win: i }) {
  if (!i.CSSStyleSheet || !i.CSSStyleSheet.prototype)
    return () => {
    };
  const r = i.CSSStyleSheet.prototype.insertRule;
  i.CSSStyleSheet.prototype.insertRule = new Proxy(r, {
    apply: M(
      (u, d, h) => {
        const [p, b] = h, { id: f, styleId: m } = Ke(
          d,
          e,
          t.styleMirror
        );
        return (f && f !== -1 || m && m !== -1) && s({
          id: f,
          styleId: m,
          adds: [{ rule: p, index: b }]
        }), u.apply(d, h);
      }
    )
  }), i.CSSStyleSheet.prototype.addRule = function(u, d, h = this.cssRules.length) {
    const p = `${u} { ${d} }`;
    return i.CSSStyleSheet.prototype.insertRule.apply(this, [p, h]);
  };
  const n = i.CSSStyleSheet.prototype.deleteRule;
  i.CSSStyleSheet.prototype.deleteRule = new Proxy(n, {
    apply: M(
      (u, d, h) => {
        const [p] = h, { id: b, styleId: f } = Ke(
          d,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || f && f !== -1) && s({
          id: b,
          styleId: f,
          removes: [{ index: p }]
        }), u.apply(d, h);
      }
    )
  }), i.CSSStyleSheet.prototype.removeRule = function(u) {
    return i.CSSStyleSheet.prototype.deleteRule.apply(this, [u]);
  };
  let o;
  i.CSSStyleSheet.prototype.replace && (o = i.CSSStyleSheet.prototype.replace, i.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: M(
      (u, d, h) => {
        const [p] = h, { id: b, styleId: f } = Ke(
          d,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || f && f !== -1) && s({
          id: b,
          styleId: f,
          replace: p
        }), u.apply(d, h);
      }
    )
  }));
  let a;
  i.CSSStyleSheet.prototype.replaceSync && (a = i.CSSStyleSheet.prototype.replaceSync, i.CSSStyleSheet.prototype.replaceSync = new Proxy(a, {
    apply: M(
      (u, d, h) => {
        const [p] = h, { id: b, styleId: f } = Ke(
          d,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || f && f !== -1) && s({
          id: b,
          styleId: f,
          replaceSync: p
        }), u.apply(d, h);
      }
    )
  }));
  const l = {};
  Vi("CSSGroupingRule") ? l.CSSGroupingRule = i.CSSGroupingRule : (Vi("CSSMediaRule") && (l.CSSMediaRule = i.CSSMediaRule), Vi("CSSConditionRule") && (l.CSSConditionRule = i.CSSConditionRule), Vi("CSSSupportsRule") && (l.CSSSupportsRule = i.CSSSupportsRule));
  const c = {};
  return Object.entries(l).forEach(([u, d]) => {
    c[u] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: d.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(
      c[u].insertRule,
      {
        apply: M(
          (h, p, b) => {
            const [f, m] = b, { id: X, styleId: R } = Ke(
              p.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (X && X !== -1 || R && R !== -1) && s({
              id: X,
              styleId: R,
              adds: [
                {
                  rule: f,
                  index: [
                    ...Qi(p),
                    m || 0
                    // defaults to 0
                  ]
                }
              ]
            }), h.apply(p, b);
          }
        )
      }
    ), d.prototype.deleteRule = new Proxy(
      c[u].deleteRule,
      {
        apply: M(
          (h, p, b) => {
            const [f] = b, { id: m, styleId: X } = Ke(
              p.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (m && m !== -1 || X && X !== -1) && s({
              id: m,
              styleId: X,
              removes: [
                { index: [...Qi(p), f] }
              ]
            }), h.apply(p, b);
          }
        )
      }
    );
  }), M(() => {
    i.CSSStyleSheet.prototype.insertRule = r, i.CSSStyleSheet.prototype.deleteRule = n, o && (i.CSSStyleSheet.prototype.replace = o), a && (i.CSSStyleSheet.prototype.replaceSync = a), Object.entries(l).forEach(([u, d]) => {
      d.prototype.insertRule = c[u].insertRule, d.prototype.deleteRule = c[u].deleteRule;
    });
  });
}
function Ea({
  mirror: s,
  stylesheetManager: e
}, t) {
  var i, r, n;
  let o = null;
  t.nodeName === "#document" ? o = s.getId(t) : o = s.getId(K.host(t));
  const a = t.nodeName === "#document" ? (i = t.defaultView) == null ? void 0 : i.Document : (n = (r = t.ownerDocument) == null ? void 0 : r.defaultView) == null ? void 0 : n.ShadowRoot, l = a != null && a.prototype ? Object.getOwnPropertyDescriptor(
    a == null ? void 0 : a.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return o === null || o === -1 || !a || !l ? () => {
  } : (Object.defineProperty(t, "adoptedStyleSheets", {
    configurable: l.configurable,
    enumerable: l.enumerable,
    get() {
      var c;
      return (c = l.get) == null ? void 0 : c.call(this);
    },
    set(c) {
      var u;
      const d = (u = l.set) == null ? void 0 : u.call(this, c);
      if (o !== null && o !== -1)
        try {
          e.adoptStyleSheets(c, o);
        } catch (h) {
        }
      return d;
    }
  }), M(() => {
    Object.defineProperty(t, "adoptedStyleSheets", {
      configurable: l.configurable,
      enumerable: l.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: l.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: l.set
    });
  }));
}
function gf({
  styleDeclarationCb: s,
  mirror: e,
  ignoreCSSAttributes: t,
  stylesheetManager: i
}, { win: r }) {
  const n = r.CSSStyleDeclaration.prototype.setProperty;
  r.CSSStyleDeclaration.prototype.setProperty = new Proxy(n, {
    apply: M(
      (a, l, c) => {
        var u;
        const [d, h, p] = c;
        if (t.has(d))
          return n.apply(l, [d, h, p]);
        const { id: b, styleId: f } = Ke(
          (u = l.parentRule) == null ? void 0 : u.parentStyleSheet,
          e,
          i.styleMirror
        );
        return (b && b !== -1 || f && f !== -1) && s({
          id: b,
          styleId: f,
          set: {
            property: d,
            value: h,
            priority: p
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Qi(l.parentRule)
        }), a.apply(l, c);
      }
    )
  });
  const o = r.CSSStyleDeclaration.prototype.removeProperty;
  return r.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: M(
      (a, l, c) => {
        var u;
        const [d] = c;
        if (t.has(d))
          return o.apply(l, [d]);
        const { id: h, styleId: p } = Ke(
          (u = l.parentRule) == null ? void 0 : u.parentStyleSheet,
          e,
          i.styleMirror
        );
        return (h && h !== -1 || p && p !== -1) && s({
          id: h,
          styleId: p,
          remove: {
            property: d
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Qi(l.parentRule)
        }), a.apply(l, c);
      }
    )
  }), M(() => {
    r.CSSStyleDeclaration.prototype.setProperty = n, r.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function Zf({
  mediaInteractionCb: s,
  blockClass: e,
  blockSelector: t,
  mirror: i,
  sampling: r,
  doc: n
}) {
  const o = M(
    (l) => Pt(
      M((c) => {
        const u = Qt(c);
        if (!u || le(u, e, t, !0))
          return;
        const { currentTime: d, volume: h, muted: p, playbackRate: b, loop: f } = u;
        s({
          type: l,
          id: i.getId(u),
          currentTime: d,
          volume: h,
          muted: p,
          playbackRate: b,
          loop: f
        });
      }),
      r.media || 500
    )
  ), a = [
    ue("play", o(st.Play), n),
    ue("pause", o(st.Pause), n),
    ue("seeked", o(st.Seeked), n),
    ue("volumechange", o(st.VolumeChange), n),
    ue("ratechange", o(st.RateChange), n)
  ];
  return M(() => {
    a.forEach((l) => l());
  });
}
function Gf({ fontCb: s, doc: e }) {
  const t = e.defaultView;
  if (!t)
    return () => {
    };
  const i = [], r = /* @__PURE__ */ new WeakMap(), n = t.FontFace;
  t.FontFace = function(l, c, u) {
    const d = new n(l, c, u);
    return r.set(d, {
      family: l,
      buffer: typeof c != "string",
      descriptors: u,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), d;
  };
  const o = Ae(
    e.fonts,
    "add",
    function(a) {
      return function(l) {
        return setTimeout(
          M(() => {
            const c = r.get(l);
            c && (s(c), r.delete(l));
          }),
          0
        ), a.apply(this, [l]);
      };
    }
  );
  return i.push(() => {
    t.FontFace = n;
  }), i.push(o), M(() => {
    i.forEach((a) => a());
  });
}
function If(s) {
  const { doc: e, mirror: t, blockClass: i, blockSelector: r, selectionCb: n } = s;
  let o = !0;
  const a = M(() => {
    const l = e.getSelection();
    if (!l || o && (l != null && l.isCollapsed)) return;
    o = l.isCollapsed || !1;
    const c = [], u = l.rangeCount || 0;
    for (let d = 0; d < u; d++) {
      const h = l.getRangeAt(d), { startContainer: p, startOffset: b, endContainer: f, endOffset: m } = h;
      le(p, i, r, !0) || le(f, i, r, !0) || c.push({
        start: t.getId(p),
        startOffset: b,
        end: t.getId(f),
        endOffset: m
      });
    }
    n({ ranges: c });
  });
  return a(), ue("selectionchange", a);
}
function Sf({
  doc: s,
  customElementCb: e
}) {
  const t = s.defaultView;
  return !t || !t.customElements ? () => {
  } : Ae(
    t.customElements,
    "define",
    function(r) {
      return function(n, o, a) {
        try {
          e({
            define: {
              name: n
            }
          });
        } catch (l) {
          console.warn(`Custom element callback failed for ${n}`);
        }
        return r.apply(this, [n, o, a]);
      };
    }
  );
}
function Vf(s, e) {
  const {
    mutationCb: t,
    mousemoveCb: i,
    mouseInteractionCb: r,
    scrollCb: n,
    viewportResizeCb: o,
    inputCb: a,
    mediaInteractionCb: l,
    styleSheetRuleCb: c,
    styleDeclarationCb: u,
    canvasMutationCb: d,
    fontCb: h,
    selectionCb: p,
    customElementCb: b
  } = s;
  s.mutationCb = (...f) => {
    e.mutation && e.mutation(...f), t(...f);
  }, s.mousemoveCb = (...f) => {
    e.mousemove && e.mousemove(...f), i(...f);
  }, s.mouseInteractionCb = (...f) => {
    e.mouseInteraction && e.mouseInteraction(...f), r(...f);
  }, s.scrollCb = (...f) => {
    e.scroll && e.scroll(...f), n(...f);
  }, s.viewportResizeCb = (...f) => {
    e.viewportResize && e.viewportResize(...f), o(...f);
  }, s.inputCb = (...f) => {
    e.input && e.input(...f), a(...f);
  }, s.mediaInteractionCb = (...f) => {
    e.mediaInteaction && e.mediaInteaction(...f), l(...f);
  }, s.styleSheetRuleCb = (...f) => {
    e.styleSheetRule && e.styleSheetRule(...f), c(...f);
  }, s.styleDeclarationCb = (...f) => {
    e.styleDeclaration && e.styleDeclaration(...f), u(...f);
  }, s.canvasMutationCb = (...f) => {
    e.canvasMutation && e.canvasMutation(...f), d(...f);
  }, s.fontCb = (...f) => {
    e.font && e.font(...f), h(...f);
  }, s.selectionCb = (...f) => {
    e.selection && e.selection(...f), p(...f);
  }, s.customElementCb = (...f) => {
    e.customElement && e.customElement(...f), b(...f);
  };
}
function Xf(s, e = {}) {
  const t = s.doc.defaultView;
  if (!t)
    return () => {
    };
  Vf(s, e);
  let i;
  s.recordDOM && (i = Oa(s, s.doc));
  const r = hf(s), n = pf(s), o = Pa(s), a = mf(s, {
    win: t
  }), l = bf(s), c = Zf(s);
  let u = () => {
  }, d = () => {
  }, h = () => {
  }, p = () => {
  };
  s.recordDOM && (u = yf(s, { win: t }), d = Ea(s, s.doc), h = gf(s, {
    win: t
  }), s.collectFonts && (p = Gf(s)));
  const b = If(s), f = Sf(s), m = [];
  for (const X of s.plugins)
    m.push(
      X.observer(X.callback, t, X.options)
    );
  return M(() => {
    Ee.forEach((X) => X.reset()), i == null || i.disconnect(), r(), n(), o(), a(), l(), c(), u(), d(), h(), p(), b(), f(), m.forEach((X) => X());
  });
}
function Si(s) {
  return typeof window[s] != "undefined";
}
function Vi(s) {
  return !!(typeof window[s] != "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[s].prototype && "insertRule" in window[s].prototype && "deleteRule" in window[s].prototype);
}
class Ro {
  constructor(e) {
    I(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), I(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = e;
  }
  getId(e, t, i, r) {
    const n = i || this.getIdToRemoteIdMap(e), o = r || this.getRemoteIdToIdMap(e);
    let a = n.get(t);
    return a || (a = this.generateIdFn(), n.set(t, a), o.set(a, t)), a;
  }
  getIds(e, t) {
    const i = this.getIdToRemoteIdMap(e), r = this.getRemoteIdToIdMap(e);
    return t.map(
      (n) => this.getId(e, n, i, r)
    );
  }
  getRemoteId(e, t, i) {
    const r = i || this.getRemoteIdToIdMap(e);
    if (typeof t != "number") return t;
    const n = r.get(t);
    return n || -1;
  }
  getRemoteIds(e, t) {
    const i = this.getRemoteIdToIdMap(e);
    return t.map((r) => this.getRemoteId(e, r, i));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let t = this.iframeIdToRemoteIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, t)), t;
  }
  getRemoteIdToIdMap(e) {
    let t = this.iframeRemoteIdToIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, t)), t;
  }
}
class Wf {
  constructor(e) {
    I(this, "iframes", /* @__PURE__ */ new WeakMap()), I(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), I(this, "crossOriginIframeMirror", new Ro(al)), I(this, "crossOriginIframeStyleMirror"), I(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), I(this, "mirror"), I(this, "mutationCb"), I(this, "wrappedEmit"), I(this, "loadListener"), I(this, "stylesheetManager"), I(this, "recordCrossOriginIframes"), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Ro(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, t) {
    var i, r;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: t
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((i = e.contentWindow) == null || i.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (r = this.loadListener) == null || r.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      e.contentDocument.adoptedStyleSheets,
      this.mirror.getId(e.contentDocument)
    );
  }
  handleMessage(e) {
    const t = e;
    if (t.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    t.origin !== t.data.origin)
      return;
    const i = e.source;
    if (!i) return;
    const r = this.crossOriginIframeMap.get(i);
    if (!r) return;
    const n = this.transformCrossOriginEvent(
      r,
      t.data.event
    );
    n && this.wrappedEmit(
      n,
      t.data.isCheckout
    );
  }
  transformCrossOriginEvent(e, t) {
    var i;
    switch (t.type) {
      case z.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(t.data.node, e);
        const r = t.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, r), this.patchRootIdOnNode(t.data.node, r), {
          timestamp: t.timestamp,
          type: z.IncrementalSnapshot,
          data: {
            source: H.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: t.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case z.Meta:
      case z.Load:
      case z.DomContentLoaded:
        return !1;
      case z.Plugin:
        return t;
      case z.Custom:
        return this.replaceIds(
          t.data.payload,
          e,
          ["id", "parentId", "previousId", "nextId"]
        ), t;
      case z.IncrementalSnapshot:
        switch (t.data.source) {
          case H.Mutation:
            return t.data.adds.forEach((r) => {
              this.replaceIds(r, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, e);
              const n = this.crossOriginIframeRootIdMap.get(e);
              n && this.patchRootIdOnNode(r.node, n);
            }), t.data.removes.forEach((r) => {
              this.replaceIds(r, e, ["parentId", "id"]);
            }), t.data.attributes.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t.data.texts.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t;
          case H.Drag:
          case H.TouchMove:
          case H.MouseMove:
            return t.data.positions.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t;
          case H.ViewportResize:
            return !1;
          case H.MediaInteraction:
          case H.MouseInteraction:
          case H.Scroll:
          case H.CanvasMutation:
          case H.Input:
            return this.replaceIds(t.data, e, ["id"]), t;
          case H.StyleSheetRule:
          case H.StyleDeclaration:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleId"]), t;
          case H.Font:
            return t;
          case H.Selection:
            return t.data.ranges.forEach((r) => {
              this.replaceIds(r, e, ["start", "end"]);
            }), t;
          case H.AdoptedStyleSheet:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleIds"]), (i = t.data.styles) == null || i.forEach((r) => {
              this.replaceStyleIds(r, e, ["styleId"]);
            }), t;
        }
    }
    return !1;
  }
  replace(e, t, i, r) {
    for (const n of r)
      !Array.isArray(t[n]) && typeof t[n] != "number" || (Array.isArray(t[n]) ? t[n] = e.getIds(
        i,
        t[n]
      ) : t[n] = e.getId(i, t[n]));
    return t;
  }
  replaceIds(e, t, i) {
    return this.replace(this.crossOriginIframeMirror, e, t, i);
  }
  replaceStyleIds(e, t, i) {
    return this.replace(this.crossOriginIframeStyleMirror, e, t, i);
  }
  replaceIdOnNode(e, t) {
    this.replaceIds(e, t, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((i) => {
      this.replaceIdOnNode(i, t);
    });
  }
  patchRootIdOnNode(e, t) {
    e.type !== Ma.Document && !e.rootId && (e.rootId = t), "childNodes" in e && e.childNodes.forEach((i) => {
      this.patchRootIdOnNode(i, t);
    });
  }
}
class Rf {
  constructor(e) {
    I(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), I(this, "mutationCb"), I(this, "scrollCb"), I(this, "bypassOptions"), I(this, "mirror"), I(this, "restoreHandlers", []), this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, t) {
    if (!Lt(e) || this.shadowDoms.has(e)) return;
    this.shadowDoms.add(e);
    const i = Oa(
      $(S({}, this.bypassOptions), {
        doc: t,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }),
      e
    );
    this.restoreHandlers.push(() => i.disconnect()), this.restoreHandlers.push(
      Pa($(S({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: e,
        mirror: this.mirror
      }))
    ), setTimeout(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        e.adoptedStyleSheets,
        this.mirror.getId(K.host(e))
      ), this.restoreHandlers.push(
        Ea(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          e
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(e) {
    !e.contentWindow || !e.contentDocument || this.patchAttachShadow(
      e.contentWindow.Element,
      e.contentDocument
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(e, t) {
    const i = this;
    this.restoreHandlers.push(
      Ae(
        e.prototype,
        "attachShadow",
        function(r) {
          return function(n) {
            const o = r.call(this, n), a = K.shadowRoot(this);
            return a && Ha(this) && i.addShadowRoot(a, t), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch (t) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
var ot = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", wf = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var Xi = 0; Xi < ot.length; Xi++)
  wf[ot.charCodeAt(Xi)] = Xi;
var Cf = function(s) {
  var e = new Uint8Array(s), t, i = e.length, r = "";
  for (t = 0; t < i; t += 3)
    r += ot[e[t] >> 2], r += ot[(e[t] & 3) << 4 | e[t + 1] >> 4], r += ot[(e[t + 1] & 15) << 2 | e[t + 2] >> 6], r += ot[e[t + 2] & 63];
  return i % 3 === 2 ? r = r.substring(0, r.length - 1) + "=" : i % 3 === 1 && (r = r.substring(0, r.length - 2) + "=="), r;
};
const wo = /* @__PURE__ */ new Map();
function vf(s, e) {
  let t = wo.get(s);
  return t || (t = /* @__PURE__ */ new Map(), wo.set(s, t)), t.has(e) || t.set(e, []), t.get(e);
}
const Ba = (s, e, t) => {
  if (!s || !(ja(s, e) || typeof s == "object"))
    return;
  const i = s.constructor.name, r = vf(t, i);
  let n = r.indexOf(s);
  return n === -1 && (n = r.length, r.push(s)), n;
};
function ki(s, e, t) {
  if (s instanceof Array)
    return s.map((i) => ki(i, e, t));
  if (s === null)
    return s;
  if (s instanceof Float32Array || s instanceof Float64Array || s instanceof Int32Array || s instanceof Uint32Array || s instanceof Uint8Array || s instanceof Uint16Array || s instanceof Int16Array || s instanceof Int8Array || s instanceof Uint8ClampedArray)
    return {
      rr_type: s.constructor.name,
      args: [Object.values(s)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    s instanceof ArrayBuffer
  ) {
    const i = s.constructor.name, r = Cf(s);
    return {
      rr_type: i,
      base64: r
    };
  } else {
    if (s instanceof DataView)
      return {
        rr_type: s.constructor.name,
        args: [
          ki(s.buffer, e, t),
          s.byteOffset,
          s.byteLength
        ]
      };
    if (s instanceof HTMLImageElement) {
      const i = s.constructor.name, { src: r } = s;
      return {
        rr_type: i,
        src: r
      };
    } else if (s instanceof HTMLCanvasElement) {
      const i = "HTMLImageElement", r = s.toDataURL();
      return {
        rr_type: i,
        src: r
      };
    } else {
      if (s instanceof ImageData)
        return {
          rr_type: s.constructor.name,
          args: [ki(s.data, e, t), s.width, s.height]
        };
      if (ja(s, e) || typeof s == "object") {
        const i = s.constructor.name, r = Ba(s, e, t);
        return {
          rr_type: i,
          index: r
        };
      }
    }
  }
  return s;
}
const Da = (s, e, t) => s.map((i) => ki(i, e, t)), ja = (s, e) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (r) => typeof e[r] == "function"
).find(
  (r) => s instanceof e[r]
);
function xf(s, e, t, i) {
  const r = [], n = Object.getOwnPropertyNames(
    e.CanvasRenderingContext2D.prototype
  );
  for (const o of n)
    try {
      if (typeof e.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const a = Ae(
        e.CanvasRenderingContext2D.prototype,
        o,
        function(l) {
          return function(...c) {
            return le(this.canvas, t, i, !0) || setTimeout(() => {
              const u = Da(c, e, this);
              s(this.canvas, {
                type: ft["2D"],
                property: o,
                args: u
              });
            }, 0), l.apply(this, c);
          };
        }
      );
      r.push(a);
    } catch (a) {
      const l = ps(
        e.CanvasRenderingContext2D.prototype,
        o,
        {
          set(c) {
            s(this.canvas, {
              type: ft["2D"],
              property: o,
              args: [c],
              setter: !0
            });
          }
        }
      );
      r.push(l);
    }
  return () => {
    r.forEach((o) => o());
  };
}
function Lf(s) {
  return s === "experimental-webgl" ? "webgl" : s;
}
function Co(s, e, t, i) {
  const r = [];
  try {
    const n = Ae(
      s.HTMLCanvasElement.prototype,
      "getContext",
      function(o) {
        return function(a, ...l) {
          if (!le(this, e, t, !0)) {
            const c = Lf(a);
            if ("__context" in this || (this.__context = c), i && ["webgl", "webgl2"].includes(c))
              if (l[0] && typeof l[0] == "object") {
                const u = l[0];
                u.preserveDrawingBuffer || (u.preserveDrawingBuffer = !0);
              } else
                l.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return o.apply(this, [a, ...l]);
        };
      }
    );
    r.push(n);
  } catch (n) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    r.forEach((n) => n());
  };
}
function vo(s, e, t, i, r, n) {
  const o = [], a = Object.getOwnPropertyNames(s);
  for (const l of a)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(l)
    )
      try {
        if (typeof s[l] != "function")
          continue;
        const c = Ae(
          s,
          l,
          function(u) {
            return function(...d) {
              const h = u.apply(this, d);
              if (Ba(h, n, this), "tagName" in this.canvas && !le(
                this.canvas,
                i,
                r,
                !0
              )) {
                const p = Da(d, n, this), b = {
                  type: e,
                  property: l,
                  args: p
                };
                t(this.canvas, b);
              }
              return h;
            };
          }
        );
        o.push(c);
      } catch (c) {
        const u = ps(s, l, {
          set(d) {
            t(this.canvas, {
              type: e,
              property: l,
              args: [d],
              setter: !0
            });
          }
        });
        o.push(u);
      }
  return o;
}
function Yf(s, e, t, i) {
  const r = [];
  return r.push(
    ...vo(
      e.WebGLRenderingContext.prototype,
      ft.WebGL,
      s,
      t,
      i,
      e
    )
  ), typeof e.WebGL2RenderingContext != "undefined" && r.push(
    ...vo(
      e.WebGL2RenderingContext.prototype,
      ft.WebGL2,
      s,
      t,
      i,
      e
    )
  ), () => {
    r.forEach((n) => n());
  };
}
const Aa = "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", kf = (s) => Uint8Array.from(atob(s), (e) => e.charCodeAt(0)), xo = typeof self != "undefined" && self.Blob && new Blob([kf(Aa)], { type: "text/javascript;charset=utf-8" });
function Nf(s) {
  let e;
  try {
    if (e = xo && (self.URL || self.webkitURL).createObjectURL(xo), !e) throw "";
    const t = new Worker(e, {
      name: s == null ? void 0 : s.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + Aa,
      {
        name: s == null ? void 0 : s.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
class Tf {
  constructor(e) {
    I(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), I(this, "rafStamps", { latestId: 0, invokeId: null }), I(this, "mirror"), I(this, "logger"), I(this, "worker"), I(this, "snapshotInProgressMap", /* @__PURE__ */ new Map()), I(this, "lastSnapshotTime", /* @__PURE__ */ new Map()), I(this, "options"), I(this, "mutationCb"), I(this, "resetObservers"), I(this, "frozen", !1), I(this, "locked", !1), I(this, "processMutation", (d, h) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(d) || this.pendingCanvasMutations.set(d, []), this.pendingCanvasMutations.get(d).push(h);
    });
    const {
      sampling: t,
      win: i,
      blockClass: r,
      blockSelector: n,
      recordCanvas: o,
      recordLocalVideos: a,
      recordRemoteVideos: l,
      initialSnapshotDelay: c,
      dataURLOptions: u
    } = e;
    this.mutationCb = e.mutationCb, this.mirror = e.mirror, this.logger = e.logger, this.worker = new Nf(), this.worker.onmessage = (d) => {
      const { id: h } = d.data;
      if (this.snapshotInProgressMap.set(h, !1), !("base64" in d.data)) {
        this.debug(null, "canvas worker received empty message", {
          id: h,
          data: d.data,
          status: d.data.status
        });
        return;
      }
      const { base64: p, type: b, dx: f, dy: m, dw: X, dh: R } = d.data, Z = {
        id: h,
        type: ft["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [f, m, X, R]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: p }],
                    type: b
                  }
                ]
              },
              f,
              m,
              X,
              R
            ]
          }
        ]
      };
      this.debug(null, "canvas worker recording mutation", Z), this.mutationCb(Z);
    }, this.options = e, o && t === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: t }), this.initCanvasMutationObserver(i, r, n)) : o && typeof t == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: t }), this.initCanvasFPSObserver(
      a,
      l,
      t,
      i,
      r,
      n,
      {
        initialSnapshotDelay: c,
        dataURLOptions: u
      },
      e.resizeFactor,
      e.maxSnapshotDimension
    ));
  }
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  debug(e, ...t) {
    if (!this.logger) return;
    const i = this.mirror.getId(e);
    let r = "[highlight-canvas-manager]";
    e && (r = `[highlight-canvas] [id:${i}]`, e.tagName.toLowerCase() === "canvas" && (r += ` [ctx:${e.__context}]`)), this.logger.debug(r, e, ...t);
  }
  snapshot(e) {
    return re(this, null, function* () {
      var t;
      const i = this.mirror.getId(e);
      if (this.snapshotInProgressMap.get(i)) {
        this.debug(e, "snapshotting already in progress for", i);
        return;
      }
      const r = 1e3 / (typeof this.options.samplingManual == "number" ? this.options.samplingManual : 1), n = this.lastSnapshotTime.get(i);
      if (!(n && (/* @__PURE__ */ new Date()).getTime() - n < r)) {
        if (this.debug(e, "starting snapshotting"), e.width === 0 || e.height === 0) {
          this.debug(e, "not yet ready", {
            width: e.width,
            height: e.height
          });
          return;
        }
        this.lastSnapshotTime.set(i, (/* @__PURE__ */ new Date()).getTime()), this.snapshotInProgressMap.set(i, !0);
        try {
          if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(e.__context)) {
            const u = e.getContext(e.__context);
            ((t = u == null ? void 0 : u.getContextAttributes()) == null ? void 0 : t.preserveDrawingBuffer) === !1 && (u.clear(u.COLOR_BUFFER_BIT), this.debug(e, "cleared webgl canvas to load it into memory", {
              attributes: u == null ? void 0 : u.getContextAttributes()
            }));
          }
          if (e.width === 0 || e.height === 0) {
            this.debug(e, "not yet ready", {
              width: e.width,
              height: e.height
            });
            return;
          }
          let o = this.options.resizeFactor || 1;
          if (this.options.maxSnapshotDimension) {
            const u = Math.max(e.width, e.height);
            o = Math.min(o, this.options.maxSnapshotDimension / u);
          }
          const a = e.width * o, l = e.height * o, c = yield createImageBitmap(e, {
            resizeWidth: a,
            resizeHeight: l
          });
          this.debug(e, "created image bitmap", {
            width: c.width,
            height: c.height
          }), this.worker.postMessage(
            {
              id: i,
              bitmap: c,
              width: a,
              height: l,
              dx: 0,
              dy: 0,
              dw: e.width,
              dh: e.height,
              dataURLOptions: this.options.dataURLOptions,
              logDebug: !!this.logger
            },
            [c]
          ), this.debug(e, "sent message");
        } catch (o) {
          this.debug(e, "failed to snapshot", o);
        } finally {
          this.snapshotInProgressMap.set(i, !1);
        }
      }
    });
  }
  initCanvasFPSObserver(e, t, i, r, n, o, a, l, c) {
    const u = Co(
      r,
      n,
      o,
      !0
    ), d = 1e3 / i;
    let h = 0, p;
    const b = /* @__PURE__ */ new Map(), f = (Z, W) => {
      const G = [];
      Z.querySelectorAll(W).forEach((L) => G.push(L));
      const v = document.createNodeIterator(Z, Node.ELEMENT_NODE);
      let k;
      for (; k = v.nextNode(); )
        k != null && k.shadowRoot && G.push(...f(k.shadowRoot, W));
      return G;
    }, m = (Z) => {
      const W = [];
      return f(r.document, "canvas").forEach((G) => {
        if (!le(G, n, o, !0)) {
          this.debug(G, "discovered canvas"), W.push(G);
          const v = this.mirror.getId(G);
          b.has(v) || b.set(v, Z);
        }
      }), W;
    }, X = (Z) => {
      const W = [];
      return (e || t) && f(r.document, "video").forEach((G) => {
        if (!(!t && G.src !== "" && G.src.indexOf("blob:") === -1) && !(!e && (G.src === "" || G.src.indexOf("blob:") !== -1)) && !le(G, n, o, !0)) {
          W.push(G);
          const v = this.mirror.getId(G);
          b.has(v) || b.set(v, Z);
        }
      }), W;
    }, R = (Z) => re(this, null, function* () {
      if (h && Z - h < d) {
        p = requestAnimationFrame(R);
        return;
      }
      h = Z;
      const W = (v) => {
        const k = this.mirror.getId(v), L = b.get(k), V = !a.initialSnapshotDelay || Z - L > a.initialSnapshotDelay;
        return this.debug(v, {
          delay: a.initialSnapshotDelay,
          delta: Z - L,
          hadLoadingTime: V
        }), V;
      }, G = [];
      G.push(
        ...m(Z).filter(W).map((v) => this.snapshot(v))
      ), G.push(
        ...X(Z).filter(W).map((v) => re(this, null, function* () {
          this.debug(v, "starting video snapshotting");
          const k = this.mirror.getId(v);
          if (this.snapshotInProgressMap.get(k)) {
            this.debug(
              v,
              "video snapshotting already in progress for",
              k
            );
            return;
          }
          this.snapshotInProgressMap.set(k, !0);
          try {
            const { width: L, height: V } = v.getBoundingClientRect(), { actualWidth: C, actualHeight: N } = {
              actualWidth: v.videoWidth,
              actualHeight: v.videoHeight
            }, D = Math.max(C, N);
            if (D === 0) {
              this.debug(v, "not yet ready", {
                width: v.width,
                height: v.height,
                actualWidth: C,
                actualHeight: N,
                boxWidth: L,
                boxHeight: V
              });
              return;
            }
            let q = l || 1;
            c && (q = Math.min(q, c / D));
            const y = C * q, g = N * q, Y = yield createImageBitmap(v, {
              resizeWidth: y,
              resizeHeight: g
            }), Q = Math.max(L, V) / D, O = C * Q, U = N * Q, j = (L - O) / 2, ee = (V - U) / 2;
            this.debug(v, "created image bitmap", {
              actualWidth: C,
              actualHeight: N,
              boxWidth: L,
              boxHeight: V,
              outputWidth: O,
              outputHeight: U,
              resizeWidth: y,
              resizeHeight: g,
              scale: q,
              outputScale: Q,
              offsetX: j,
              offsetY: ee
            }), this.worker.postMessage(
              {
                id: k,
                bitmap: Y,
                width: y,
                height: g,
                dx: j,
                dy: ee,
                dw: O,
                dh: U,
                dataURLOptions: a.dataURLOptions,
                logDebug: !!this.logger
              },
              [Y]
            ), this.debug(v, "send message");
          } catch (L) {
            this.debug(v, "failed to snapshot", L);
          } finally {
            this.snapshotInProgressMap.set(k, !1);
          }
        }))
      ), yield Promise.all(G).catch(console.error), p = requestAnimationFrame(R);
    });
    p = requestAnimationFrame(R), this.resetObservers = () => {
      u(), p && cancelAnimationFrame(p);
    };
  }
  initCanvasMutationObserver(e, t, i) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const r = Co(
      e,
      t,
      i,
      !1
    ), n = xf(
      this.processMutation.bind(this),
      e,
      t,
      i
    ), o = Yf(
      this.processMutation.bind(this),
      e,
      t,
      i
    );
    this.resetObservers = () => {
      r(), n(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const e = (t) => {
      this.rafStamps.latestId = t, requestAnimationFrame(e);
    };
    requestAnimationFrame(e);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (e, t) => {
        const i = this.mirror.getId(t);
        this.flushPendingCanvasMutationFor(t, i);
      }
    ), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(e, t) {
    if (this.frozen || this.locked)
      return;
    const i = this.pendingCanvasMutations.get(e);
    if (!i || t === -1) return;
    const r = i.map((o) => {
      const c = o, { type: a } = c;
      return pe(c, ["type"]);
    }), { type: n } = i[0];
    this.mutationCb({ id: t, type: n, commands: r }), this.pendingCanvasMutations.delete(e);
  }
}
class Jf {
  constructor(e) {
    I(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), I(this, "mutationCb"), I(this, "adoptedStyleSheetCb"), I(this, "styleMirror", new sf()), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, t) {
    "_cssText" in t.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: t.id,
          attributes: t.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, t) {
    if (e.length === 0) return;
    const i = {
      id: t,
      styleIds: []
    }, r = [];
    for (const n of e) {
      let o;
      this.styleMirror.has(n) ? o = this.styleMirror.getId(n) : (o = this.styleMirror.add(n), r.push({
        styleId: o,
        rules: Array.from(n.rules || CSSRule, (a, l) => ({
          rule: sl(a, n.href),
          index: l
        }))
      })), i.styleIds.push(o);
    }
    r.length > 0 && (i.styles = r), this.adoptedStyleSheetCb(i);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(e) {
  }
}
class Uf {
  constructor() {
    I(this, "nodeMap", /* @__PURE__ */ new WeakMap()), I(this, "active", !1);
  }
  inOtherBuffer(e, t) {
    const i = this.nodeMap.get(e);
    return i && Array.from(i).some((r) => r !== t);
  }
  add(e, t) {
    this.active || (this.active = !0, requestAnimationFrame(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(t));
  }
  destroy() {
  }
}
let se, Ni, kt, _i = !1;
try {
  if (Array.from([1], (s) => s * 2)[0] !== 2) {
    const s = document.createElement("iframe");
    document.body.appendChild(s), Array.from = ((Ln = s.contentWindow) == null ? void 0 : Ln.Array.from) || Array.from, document.body.removeChild(s);
  }
} catch (s) {
  console.debug("Unable to override Array.from", s);
}
const Ie = Tu();
function ke(s = {}) {
  var e, t, i, r, n, o, a, l;
  const {
    emit: c,
    checkoutEveryNms: u,
    checkoutEveryNth: d,
    blockClass: h = "highlight-block",
    blockSelector: p = null,
    ignoreClass: b = "highlight-ignore",
    ignoreSelector: f = null,
    maskTextClass: m = "highlight-mask",
    maskTextSelector: X = null,
    inlineStylesheet: R = !0,
    maskAllInputs: Z,
    maskInputOptions: W,
    slimDOMOptions: G,
    maskInputFn: v,
    maskTextFn: k = Hr,
    hooks: L,
    packFn: V,
    sampling: C = {},
    mousemoveWait: N,
    recordDOM: D = !0,
    recordCanvas: q = !1,
    recordCrossOriginIframes: y = !1,
    recordAfter: g = s.recordAfter === "DOMContentLoaded" ? s.recordAfter : "load",
    userTriggeredOnInput: Y = !1,
    collectFonts: Q = !1,
    inlineImages: O = !1,
    inlineVideos: U = !1,
    plugins: j,
    keepIframeSrcFn: ee = () => !1,
    privacySetting: ge = "default",
    ignoreCSSAttributes: Je = /* @__PURE__ */ new Set([]),
    errorHandler: bc,
    logger: yc
  } = s, $t = S(S({}, s.dataURLOptions), (t = (e = s.sampling) == null ? void 0 : e.canvas) == null ? void 0 : t.dataURLOptions);
  uf(bc);
  const qt = y ? window.parent === window : !0;
  let yt = !1;
  if (!qt)
    try {
      window.parent.document && (yt = !1);
    } catch (P) {
      yt = !0;
    }
  if (qt && !c)
    throw new Error("emit function is required");
  if (!qt && !yt)
    return () => {
    };
  N !== void 0 && C.mousemove === void 0 && (C.mousemove = N), Ie.reset();
  const ys = Z === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : W !== void 0 ? W : { password: !0 }, gs = G === !0 || G === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: G === "all",
    headMetaDescKeywords: G === "all",
    headTitleMutations: G === "all"
  } : G || {};
  tf();
  let bn, Zs = 0;
  const yn = (P) => {
    for (const Ze of j || [])
      Ze.eventProcessor && (P = Ze.eventProcessor(P));
    return V && // Disable packing events which will be emitted to parent frames.
    !yt && (P = V(P)), P;
  };
  se = (P, Ze) => {
    var te;
    const ie = P;
    if (ie.timestamp = Ai(), (te = Ee[0]) != null && te.isFrozen() && ie.type !== z.FullSnapshot && !(ie.type === z.IncrementalSnapshot && ie.data.source === H.Mutation) && Ee.forEach((Xe) => Xe.unfreeze()), qt)
      c == null || c(yn(ie), Ze);
    else if (yt) {
      const Xe = {
        type: "rrweb",
        event: yn(ie),
        origin: window.location.origin,
        isCheckout: Ze
      };
      window.parent.postMessage(Xe, "*");
    }
    if (ie.type === z.FullSnapshot)
      bn = ie, Zs = 0;
    else if (ie.type === z.IncrementalSnapshot) {
      if (ie.data.source === H.Mutation && ie.data.isAttachIframe)
        return;
      Zs++;
      const Xe = d && Zs >= d, A = u && ie.timestamp - bn.timestamp > u;
      (Xe || A) && Ni(!0);
    }
  };
  const ei = (P) => {
    se({
      type: z.IncrementalSnapshot,
      data: S({
        source: H.Mutation
      }, P)
    });
  }, gn = (P) => se({
    type: z.IncrementalSnapshot,
    data: S({
      source: H.Scroll
    }, P)
  }), Zn = (P) => se({
    type: z.IncrementalSnapshot,
    data: S({
      source: H.CanvasMutation
    }, P)
  }), gc = (P) => se({
    type: z.IncrementalSnapshot,
    data: S({
      source: H.AdoptedStyleSheet
    }, P)
  }), Oe = new Jf({
    mutationCb: ei,
    adoptedStyleSheetCb: gc
  }), Pe = new Wf({
    mirror: Ie,
    mutationCb: ei,
    stylesheetManager: Oe,
    recordCrossOriginIframes: y,
    wrappedEmit: se
  });
  for (const P of j || [])
    P.getMirror && P.getMirror({
      nodeMirror: Ie,
      crossOriginIframeMirror: Pe.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Pe.crossOriginIframeStyleMirror
    });
  const Gs = new Uf();
  kt = new Tf({
    recordCanvas: q,
    recordLocalVideos: O,
    recordRemoteVideos: U,
    mutationCb: Zn,
    win: window,
    blockClass: h,
    blockSelector: p,
    mirror: Ie,
    sampling: (i = C == null ? void 0 : C.canvas) == null ? void 0 : i.fps,
    samplingManual: (r = C == null ? void 0 : C.canvas) == null ? void 0 : r.fpsManual,
    clearWebGLBuffer: (n = C == null ? void 0 : C.canvas) == null ? void 0 : n.clearWebGLBuffer,
    initialSnapshotDelay: (o = C == null ? void 0 : C.canvas) == null ? void 0 : o.initialSnapshotDelay,
    dataURLOptions: $t,
    resizeFactor: (a = C == null ? void 0 : C.canvas) == null ? void 0 : a.resizeFactor,
    maxSnapshotDimension: (l = C == null ? void 0 : C.canvas) == null ? void 0 : l.maxSnapshotDimension,
    logger: yc
  });
  const ti = new Rf({
    mutationCb: ei,
    scrollCb: gn,
    bypassOptions: {
      blockClass: h,
      blockSelector: p,
      maskTextClass: m,
      maskTextSelector: X,
      inlineStylesheet: R,
      maskInputOptions: ys,
      dataURLOptions: $t,
      maskTextFn: k,
      maskInputFn: v,
      recordCanvas: q,
      inlineImages: O,
      inlineVideos: U,
      privacySetting: ge,
      sampling: C,
      slimDOMOptions: gs,
      iframeManager: Pe,
      stylesheetManager: Oe,
      canvasManager: kt,
      keepIframeSrcFn: ee,
      processedNodeManager: Gs
    },
    mirror: Ie
  });
  Ni = (P = !1) => {
    if (!D)
      return;
    se(
      {
        type: z.Meta,
        data: {
          href: window.location.href,
          width: Na(),
          height: ka()
        }
      },
      P
    ), Oe.reset(), ti.init(), Ee.forEach((te) => te.lock());
    const Ze = hd(document, {
      mirror: Ie,
      blockClass: h,
      blockSelector: p,
      maskTextClass: m,
      maskTextSelector: X,
      inlineStylesheet: R,
      maskAllInputs: ys,
      maskTextFn: k,
      maskInputFn: v,
      slimDOM: gs,
      dataURLOptions: $t,
      recordCanvas: q,
      inlineImages: O,
      inlineVideos: U,
      privacySetting: ge,
      onSerialize: (te) => {
        Ua(te, Ie) && Pe.addIframe(te), Fa(te, Ie) && Oe.trackLinkElement(te), kr(te) && ti.addShadowRoot(K.shadowRoot(te), document);
      },
      onIframeLoad: (te, ie) => {
        Pe.attachIframe(te, ie), ti.observeAttachShadow(te);
      },
      onStylesheetLoad: (te, ie) => {
        Oe.attachLinkElement(te, ie);
      },
      keepIframeSrcFn: ee
    });
    if (!Ze)
      return console.warn("Failed to snapshot the document");
    se(
      {
        type: z.FullSnapshot,
        data: {
          node: Ze,
          initialOffset: Ya(window)
        }
      },
      P
    ), Ee.forEach((te) => te.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Oe.adoptStyleSheets(
      document.adoptedStyleSheets,
      Ie.getId(document)
    );
  };
  try {
    const P = [], Ze = (ie) => {
      var Xe;
      return M(Xf)(
        {
          mutationCb: ei,
          mousemoveCb: (A, Is) => se({
            type: z.IncrementalSnapshot,
            data: {
              source: Is,
              positions: A
            }
          }),
          mouseInteractionCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.MouseInteraction
            }, A)
          }),
          scrollCb: gn,
          viewportResizeCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.ViewportResize
            }, A)
          }),
          inputCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.Input
            }, A)
          }),
          mediaInteractionCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.MediaInteraction
            }, A)
          }),
          styleSheetRuleCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.StyleSheetRule
            }, A)
          }),
          styleDeclarationCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.StyleDeclaration
            }, A)
          }),
          canvasMutationCb: Zn,
          fontCb: (A) => se({
            type: z.IncrementalSnapshot,
            data: S({
              source: H.Font
            }, A)
          }),
          selectionCb: (A) => {
            se({
              type: z.IncrementalSnapshot,
              data: S({
                source: H.Selection
              }, A)
            });
          },
          customElementCb: (A) => {
            se({
              type: z.IncrementalSnapshot,
              data: S({
                source: H.CustomElement
              }, A)
            });
          },
          blockClass: h,
          ignoreClass: b,
          ignoreSelector: f,
          maskTextClass: m,
          maskTextSelector: X,
          maskInputOptions: ys,
          inlineStylesheet: R,
          sampling: C,
          recordDOM: D,
          recordCanvas: q,
          inlineImages: O,
          inlineVideos: U,
          userTriggeredOnInput: Y,
          collectFonts: Q,
          doc: ie,
          maskInputFn: v,
          maskTextFn: k,
          keepIframeSrcFn: ee,
          blockSelector: p,
          slimDOMOptions: gs,
          dataURLOptions: $t,
          mirror: Ie,
          iframeManager: Pe,
          stylesheetManager: Oe,
          shadowDomManager: ti,
          processedNodeManager: Gs,
          canvasManager: kt,
          ignoreCSSAttributes: Je,
          privacySetting: ge,
          plugins: ((Xe = j == null ? void 0 : j.filter((A) => A.observer)) == null ? void 0 : Xe.map((A) => ({
            observer: A.observer,
            options: A.options,
            callback: (Is) => se({
              type: z.Plugin,
              data: {
                plugin: A.name,
                payload: Is
              }
            })
          }))) || []
        },
        L
      );
    };
    Pe.addLoadListener((ie) => {
      try {
        P.push(Ze(ie.contentDocument));
      } catch (Xe) {
        console.warn(Xe);
      }
    });
    const te = () => {
      Ni(), P.push(Ze(document)), _i = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? te() : (P.push(
      ue("DOMContentLoaded", () => {
        se({
          type: z.DomContentLoaded,
          data: {}
        }), g === "DOMContentLoaded" && te();
      })
    ), P.push(
      ue(
        "load",
        () => {
          se({
            type: z.Load,
            data: {}
          }), g === "load" && te();
        },
        window
      )
    )), () => {
      P.forEach((ie) => ie()), Gs.destroy(), _i = !1, df();
    };
  } catch (P) {
    console.warn(P);
  }
}
ke.addCustomEvent = (s, e) => {
  _i && se({
    type: z.Custom,
    data: {
      tag: s,
      payload: e
    }
  });
};
ke.freezePage = () => {
  Ee.forEach((s) => s.freeze());
};
ke.takeFullSnapshot = (s) => {
  if (!_i)
    throw new Error("please take full snapshot after start recording");
  Ni(s);
};
ke.snapshotCanvas = (s) => re(void 0, null, function* () {
  if (!kt)
    throw new Error("canvas manager is not initialized");
  yield kt.snapshot(s);
});
ke.mirror = Ie;
var Lo;
(function(s) {
  s[s.NotStarted = 0] = "NotStarted", s[s.Running = 1] = "Running", s[s.Stopped = 2] = "Stopped";
})(Lo || (Lo = {}));
const { addCustomEvent: Yo } = ke;
var $i = function() {
  return $i = Object.assign || function(e) {
    for (var t, i = 1, r = arguments.length; i < r; i++) {
      t = arguments[i];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, $i.apply(this, arguments);
}, Ti = /* @__PURE__ */ new Map(), Tr = /* @__PURE__ */ new Map(), Qa = !0, qi = !1;
function _a(s) {
  return s.replace(/[\s,]+/g, " ").trim();
}
function Ff(s) {
  return _a(s.source.body.substring(s.start, s.end));
}
function Kf(s) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return s.definitions.forEach(function(i) {
    if (i.kind === "FragmentDefinition") {
      var r = i.name.value, n = Ff(i.loc), o = Tr.get(r);
      o && !o.has(n) ? Qa && console.warn("Warning: fragment with name " + r + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Tr.set(r, o = /* @__PURE__ */ new Set()), o.add(n), e.has(n) || (e.add(n), t.push(i));
    } else
      t.push(i);
  }), $i($i({}, s), { definitions: t });
}
function Hf(s) {
  var e = new Set(s.definitions);
  e.forEach(function(i) {
    i.loc && delete i.loc, Object.keys(i).forEach(function(r) {
      var n = i[r];
      n && typeof n == "object" && e.add(n);
    });
  });
  var t = s.loc;
  return t && (delete t.startToken, delete t.endToken), s;
}
function Mf(s) {
  var e = _a(s);
  if (!Ti.has(e)) {
    var t = qo(s, {
      experimentalFragmentVariables: qi,
      allowLegacyFragmentVariables: qi
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Ti.set(e, Hf(Kf(t)));
  }
  return Ti.get(e);
}
function he(s) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof s == "string" && (s = [s]);
  var i = s[0];
  return e.forEach(function(r, n) {
    r && r.kind === "Document" ? i += r.loc.source.body : i += r, i += s[n + 1];
  }), Mf(i);
}
function zf() {
  Ti.clear(), Tr.clear();
}
function Of() {
  Qa = !1;
}
function Pf() {
  qi = !0;
}
function Ef() {
  qi = !1;
}
var wt = {
  gql: he,
  resetCaches: zf,
  disableFragmentWarnings: Of,
  enableExperimentalFragmentVariables: Pf,
  disableExperimentalFragmentVariables: Ef
};
(function(s) {
  s.gql = wt.gql, s.resetCaches = wt.resetCaches, s.disableFragmentWarnings = wt.disableFragmentWarnings, s.enableExperimentalFragmentVariables = wt.enableExperimentalFragmentVariables, s.disableExperimentalFragmentVariables = wt.disableExperimentalFragmentVariables;
})(he || (he = {}));
he.default = he;
const $a = he`
	mutation PushPayload(
		$session_secure_id: String!
		$payload_id: ID!
		$events: ReplayEventsInput!
		$messages: String!
		$resources: String!
		$web_socket_events: String!
		$errors: [ErrorObjectInput]!
		$is_beacon: Boolean
		$has_session_unloaded: Boolean
		$highlight_logs: String
	) {
		pushPayload(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			events: $events
			messages: $messages
			resources: $resources
			web_socket_events: $web_socket_events
			errors: $errors
			is_beacon: $is_beacon
			has_session_unloaded: $has_session_unloaded
			highlight_logs: $highlight_logs
		)
	}
`, Bf = he`
	mutation PushPayloadCompressed(
		$session_secure_id: String!
		$payload_id: ID!
		$data: String!
	) {
		pushPayloadCompressed(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			data: $data
		)
	}
`, Df = he`
	mutation identifySession(
		$session_secure_id: String!
		$user_identifier: String!
		$user_object: Any
	) {
		identifySession(
			session_secure_id: $session_secure_id
			user_identifier: $user_identifier
			user_object: $user_object
		)
	}
`, jf = he`
	mutation addSessionProperties(
		$session_secure_id: String!
		$properties_object: Any
	) {
		addSessionProperties(
			session_secure_id: $session_secure_id
			properties_object: $properties_object
		)
	}
`, Af = he`
	mutation pushMetrics($metrics: [MetricInput]!) {
		pushMetrics(metrics: $metrics)
	}
`, Qf = he`
	mutation addSessionFeedback(
		$session_secure_id: String!
		$user_name: String
		$user_email: String
		$verbatim: String!
		$timestamp: Timestamp!
	) {
		addSessionFeedback(
			session_secure_id: $session_secure_id
			user_name: $user_name
			user_email: $user_email
			verbatim: $verbatim
			timestamp: $timestamp
		)
	}
`, _f = he`
	mutation initializeSession(
		$session_secure_id: String!
		$organization_verbose_id: String!
		$enable_strict_privacy: Boolean!
		$privacy_setting: String!
		$enable_recording_network_contents: Boolean!
		$clientVersion: String!
		$firstloadVersion: String!
		$clientConfig: String!
		$environment: String!
		$id: String!
		$appVersion: String
		$serviceName: String!
		$client_id: String!
		$network_recording_domains: [String!]
		$disable_session_recording: Boolean
	) {
		initializeSession(
			session_secure_id: $session_secure_id
			organization_verbose_id: $organization_verbose_id
			enable_strict_privacy: $enable_strict_privacy
			enable_recording_network_contents: $enable_recording_network_contents
			clientVersion: $clientVersion
			firstloadVersion: $firstloadVersion
			clientConfig: $clientConfig
			environment: $environment
			appVersion: $appVersion
			serviceName: $serviceName
			fingerprint: $id
			client_id: $client_id
			network_recording_domains: $network_recording_domains
			disable_session_recording: $disable_session_recording
			privacy_setting: $privacy_setting
		) {
			secure_id
			project_id
		}
	}
`, $f = he`
	query Ignore($id: ID!) {
		ignore(id: $id)
	}
`, qf = (s, e, t, i) => s();
function eb(s, e = qf) {
  return {
    PushPayload(t, i) {
      return e(
        (r) => s.request(
          $a,
          t,
          S(S({}, i), r)
        ),
        "PushPayload",
        "mutation",
        t
      );
    },
    PushPayloadCompressed(t, i) {
      return e(
        (r) => s.request(
          Bf,
          t,
          S(S({}, i), r)
        ),
        "PushPayloadCompressed",
        "mutation",
        t
      );
    },
    identifySession(t, i) {
      return e(
        (r) => s.request(
          Df,
          t,
          S(S({}, i), r)
        ),
        "identifySession",
        "mutation",
        t
      );
    },
    addSessionProperties(t, i) {
      return e(
        (r) => s.request(
          jf,
          t,
          S(S({}, i), r)
        ),
        "addSessionProperties",
        "mutation",
        t
      );
    },
    pushMetrics(t, i) {
      return e(
        (r) => s.request(
          Af,
          t,
          S(S({}, i), r)
        ),
        "pushMetrics",
        "mutation",
        t
      );
    },
    addSessionFeedback(t, i) {
      return e(
        (r) => s.request(
          Qf,
          t,
          S(S({}, i), r)
        ),
        "addSessionFeedback",
        "mutation",
        t
      );
    },
    initializeSession(t, i) {
      return e(
        (r) => s.request(
          _f,
          t,
          S(S({}, i), r)
        ),
        "initializeSession",
        "mutation",
        t
      );
    },
    Ignore(t, i) {
      return e(
        (r) => s.request($f, t, S(S({}, i), r)),
        "Ignore",
        "query",
        t
      );
    }
  };
}
const tb = (s) => {
  s(window.location.href);
  const e = history.pushState;
  history.pushState = /* @__PURE__ */ ((n) => function() {
    var a = n.apply(this, arguments);
    return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), a;
  })(history.pushState);
  const t = history.replaceState;
  history.replaceState = /* @__PURE__ */ ((n) => function() {
    var a = n.apply(this, arguments);
    return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), a;
  })(history.replaceState);
  const i = () => {
    window.dispatchEvent(new Event("locationchange"));
  };
  window.addEventListener("popstate", i);
  const r = function() {
    s(window.location.href);
  };
  return window.addEventListener("locationchange", r), () => {
    window.removeEventListener("popstate", i), window.removeEventListener("locationchange", r), history.pushState = e, history.replaceState = t;
  };
}, ib = (s) => {
  switch (s) {
    case "strict":
      return [!0, void 0];
    case "default":
      return [!0, void 0];
    case "none":
      return [!1, { password: !0 }];
  }
};
let fe, dn;
function qa(s, e) {
  return s.nodeType, Node.ELEMENT_NODE, Jr(s);
  return sb(s, e);
}
function ec(s) {
  if (s.id.length)
    return `#${s.id}`;
  if (s.classList.length) {
    let e = [];
    for (const t of s.classList)
      e.push(`.${t}`);
    return `${s.nodeName.toLowerCase()}${e.join(",")}`;
  }
  return s.nodeName.toLowerCase();
}
function sb(s, e) {
  if (s.tagName.toLowerCase() === "html")
    return "html";
  try {
    const t = {
      root: document.body,
      idName: (r) => !0,
      className: (r) => !0,
      tagName: (r) => !0,
      attr: (r, n) => !1,
      seedMinLength: 1,
      optimizedMinLength: 2,
      threshold: 50,
      maxNumberOfTries: 1e3,
      optimized: !0
    };
    fe = S(S({}, t), e), dn = rb(fe.root, t);
    let i = Ps(
      s,
      0,
      () => Ps(
        s,
        1,
        () => Ps(
          s,
          2
          /* One */
        )
      )
    );
    if (i) {
      if (fe.optimized) {
        const r = sc(rc(i, s));
        r.length > 0 && (i = r[0]);
      }
      return ms(i);
    } else
      return Jr(s);
  } catch (t) {
    return Jr(s);
  }
}
function rb(s, e) {
  return s.nodeType === Node.DOCUMENT_NODE ? s : s === e.root ? s.ownerDocument : s;
}
function Ps(s, e, t) {
  let i = null, r = [], n = s, o = 0;
  for (; n && n !== fe.root.parentElement; ) {
    let a = Wi(nb(n)) || Wi(...ob(n)) || Wi(...lb(n)) || Wi(ab(n)) || [cb()];
    const l = ub(n);
    if (e === 0)
      l && (a = a.concat(
        a.filter(Bs).map((c) => Es(c, l))
      ));
    else if (e === 1)
      a = a.slice(0, 1), l && (a = a.concat(
        a.filter(Bs).map((c) => Es(c, l))
      ));
    else if (e === 2) {
      const [c] = a = a.slice(0, 1);
      l && Bs(c) && (a = [Es(c, l)]);
    }
    for (let c of a)
      c.level = o;
    if (r.push(a), r.length >= fe.seedMinLength && (i = ko(r, t), i))
      break;
    n = n.parentElement, o++;
  }
  return i || (i = ko(r, t)), i;
}
function ko(s, e) {
  const t = sc(ic(s));
  if (t.length > fe.threshold)
    return e ? e() : null;
  for (let i of t)
    if (tc(i))
      return i;
  return null;
}
function ms(s) {
  let e = s[0], t = e.name;
  for (let i = 1; i < s.length; i++) {
    const r = s[i].level || 0;
    e.level === r - 1 ? t = `${s[i].name} > ${t}` : t = `${s[i].name} ${t}`, e = s[i];
  }
  return t;
}
function No(s) {
  return s.map((e) => e.penalty).reduce((e, t) => e + t, 0);
}
function tc(s) {
  switch (dn.querySelectorAll(ms(s)).length) {
    case 0:
      return !0;
    case 1:
      return !0;
    default:
      return !1;
  }
}
function nb(s) {
  const e = s.getAttribute("id");
  return e && fe.idName(e) ? {
    name: "#" + es(e, { isIdentifier: !0 }),
    penalty: 0
  } : null;
}
function ob(s) {
  return Array.from(s.attributes).filter(
    (t) => fe.attr(t.name, t.value)
  ).map(
    (t) => ({
      name: "[" + es(t.name, { isIdentifier: !0 }) + '="' + es(t.value) + '"]',
      penalty: 0.5
    })
  );
}
function lb(s) {
  return Array.from(s.classList).filter(fe.className).map(
    (t) => ({
      name: "." + es(t, { isIdentifier: !0 }),
      penalty: 1
    })
  );
}
function ab(s) {
  const e = s.tagName.toLowerCase();
  return fe.tagName(e) ? {
    name: e,
    penalty: 2
  } : null;
}
function cb() {
  return {
    name: "*",
    penalty: 3
  };
}
function ub(s) {
  const e = s.parentNode;
  if (!e)
    return null;
  let t = e.firstChild;
  if (!t)
    return null;
  let i = 0;
  for (; t && (t.nodeType === Node.ELEMENT_NODE && i++, t !== s); )
    t = t.nextSibling;
  return i;
}
function Es(s, e) {
  return {
    name: s.name + `:nth-child(${e})`,
    penalty: s.penalty + 1
  };
}
function Bs(s) {
  return s.name !== "html" && !s.name.startsWith("#");
}
function Wi(...s) {
  const e = s.filter(db);
  return e.length > 0 ? e : null;
}
function db(s) {
  return s != null;
}
function* ic(s, e = []) {
  if (s.length > 0)
    for (let t of s[0])
      yield* Xs(ic(s.slice(1, s.length), e.concat(t)));
  else
    yield e;
}
function sc(s) {
  return Array.from(s).sort((e, t) => No(e) - No(t));
}
function* rc(s, e, t = {
  counter: 0,
  visited: /* @__PURE__ */ new Map()
}) {
  if (s.length > 2 && s.length > fe.optimizedMinLength)
    for (let i = 1; i < s.length - 1; i++) {
      if (t.counter > fe.maxNumberOfTries)
        return;
      t.counter += 1;
      const r = [...s];
      r.splice(i, 1);
      const n = ms(r);
      if (t.visited.has(n))
        return;
      tc(r) && hb(r, e) && (yield r, t.visited.set(n, !0), yield* Xs(rc(r, e, t)));
    }
}
function hb(s, e) {
  return dn.querySelector(ms(s)) === e;
}
const pb = /[ -,\.\/:-@\[-\^`\{-~]/, mb = /[ -,\.\/:-@\[\]\^`\{-~]/, fb = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, bb = {
  escapeEverything: !1,
  isIdentifier: !1,
  quotes: "single",
  wrap: !1
};
function es(s, e = {}) {
  const t = S(S({}, bb), e);
  t.quotes != "single" && t.quotes != "double" && (t.quotes = "single");
  const i = t.quotes == "double" ? '"' : "'", r = t.isIdentifier, n = s.charAt(0);
  let o = "", a = 0;
  const l = s.length;
  for (; a < l; ) {
    const c = s.charAt(a++);
    let u = c.charCodeAt(0), d;
    if (u < 32 || u > 126) {
      if (u >= 55296 && u <= 56319 && a < l) {
        const h = s.charCodeAt(a++);
        (h & 64512) == 56320 ? u = ((u & 1023) << 10) + (h & 1023) + 65536 : a--;
      }
      d = "\\" + u.toString(16).toUpperCase() + " ";
    } else
      t.escapeEverything ? pb.test(c) ? d = "\\" + c : d = "\\" + u.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(c) ? d = "\\" + u.toString(16).toUpperCase() + " " : c == "\\" || !r && (c == '"' && i == c || c == "'" && i == c) || r && mb.test(c) ? d = "\\" + c : d = c;
    o += d;
  }
  return r && (/^-[-\d]/.test(o) ? o = "\\-" + o.slice(1) : /\d/.test(n) && (o = "\\3" + n + " " + o.slice(1))), o = o.replace(fb, function(c, u, d) {
    return u && u.length % 2 ? c : (u || "") + d;
  }), !r && t.wrap ? i + o + i : o;
}
const Jr = (s) => {
  let e = "";
  const t = s.getAttribute("class"), i = s.getAttribute("id");
  return i && (e = e.concat(To(i, "#"))), t && (e = e.concat(To(t, "."))), e === "" && (e = e.concat(s.tagName.toLowerCase())), e;
}, To = (s, e) => `${e}${s.trim().split(" ").join(e)}`, yb = (s) => {
  const e = (t) => {
    if (t.target) {
      const i = t.target, r = qa(i);
      s(r, t);
    }
  };
  return window.addEventListener("click", e), () => window.removeEventListener("click", e);
}, gb = (s) => {
  const e = (t) => {
    if (t.target) {
      const i = qa(t.target);
      s(i);
    }
  };
  return window.addEventListener("focusin", e), () => window.removeEventListener("focusin", e);
}, Zb = 30, Gb = () => new Promise(
  (s) => requestAnimationFrame(
    (e) => requestAnimationFrame((t) => s(t - e))
  )
), Ib = () => re(void 0, null, function* () {
  const s = [];
  for (let e = 0; e < Zb; e++)
    s.push(yield Gb());
  return s.reduce((e, t) => e + t, 0) / s.length;
}), Sb = (s, e) => {
  let t = {}, i = 16.666666666666668;
  Ib().then((l) => i = l);
  const r = (l) => {
    var c;
    t != null && t.event || (t = {
      event: l,
      location: window.location.href,
      timerStart: (c = window.performance) == null ? void 0 : c.now()
    }, window.requestAnimationFrame(n));
  }, n = () => {
    if (!(t != null && t.timerStart)) return;
    const l = window.performance.now() - t.timerStart - i;
    o(l), t = {};
  }, o = (l) => {
    const c = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3;
    s({
      relativeTimestamp: c,
      jankAmount: l,
      querySelector: a(),
      newLocation: window.location.href != t.location ? window.location.href : void 0
    });
  }, a = () => {
    var l;
    return (l = t == null ? void 0 : t.event) != null && l.target ? ec(t.event.target) : "";
  };
  return window.addEventListener("click", r, !0), window.addEventListener("keydown", r, !0), () => {
    window.removeEventListener("keydown", r, !0), window.removeEventListener("click", r, !0);
  };
}, Vb = (s) => {
  let e, t;
  if (typeof document.hidden != "undefined" ? (e = "hidden", t = "visibilitychange") : typeof document.msHidden != "undefined" ? (e = "msHidden", t = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (e = "webkitHidden", t = "webkitvisibilitychange"), t === void 0)
    return () => {
    };
  if (e === void 0)
    return () => {
    };
  const i = e, r = () => {
    const o = document[i];
    s(!!o);
  };
  document.addEventListener(t, r);
  const n = t;
  return () => document.removeEventListener(n, r);
}, Xb = typeof window != "undefined", Jo = Xb && "performance" in window && "memory" in performance ? performance : { memory: {} }, Wb = (s, e) => {
  let t = 0, i = 0;
  const r = () => {
    const u = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3, d = Jo.memory.jsHeapSizeLimit || 0, h = Jo.memory.usedJSHeapSize || 0;
    s({
      jsHeapSizeLimit: d,
      usedJSHeapSize: h,
      relativeTimestamp: u,
      fps: t
    });
  };
  r();
  let n;
  n = setInterval(() => {
    r();
  }, 1e3);
  let o = 0, a = Date.now();
  const l = function() {
    var c = Date.now();
    o++, c > 1e3 + a && (t = Math.round(o * 1e3 / (c - a)), o = 0, a = c), i = requestAnimationFrame(l);
  };
  return l(), () => {
    clearInterval(n), cancelAnimationFrame(i);
  };
}, Rb = (s) => {
  s(window.location.href);
  var e = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(n) {
    setTimeout(() => {
      var a;
      var o;
      try {
        o = JSON.parse((a = n == null ? void 0 : n.toString()) != null ? a : "");
      } catch (l) {
        return;
      }
      (o.type === "track" || o.type === "identify") && Ds(o) && s(o);
    }, 100), e.call(this, n);
  };
  const t = (n) => {
    if (n.key === "ajs_user_id" || n.key === "ajs_anonymous_id" || n.key === "ajs_user_traits") {
      const { userId: o, userTraits: a } = Uo();
      if (o) {
        let l = {};
        a && (l = JSON.parse(a));
        const c = {
          type: "identify",
          userId: o.toString(),
          traits: l
        };
        Ds(c) && s(c);
      }
    }
  }, { userId: i, userTraits: r } = Uo();
  if (i) {
    let n = {};
    r && (n = JSON.parse(r));
    const o = {
      type: "identify",
      userId: i.toString(),
      traits: n
    };
    Ds(o) && s(o);
  }
  return window.addEventListener("storage", t), Yc(({ keyName: n }) => {
    t({
      key: n
    });
  }), () => {
    window.removeEventListener("storage", t), XMLHttpRequest.prototype.send = e;
  };
}, Uo = () => {
  const s = xe(
    "ajs_user_id"
    /* USER_ID */
  ), e = xe(
    "ajs_user_traits"
    /* USER_TRAITS */
  ), t = xe(
    "ajs_anonymous_id"
    /* ANONYMOUS_ID */
  );
  return {
    userId: s,
    userTraits: e,
    anonymousId: t
  };
}, Ds = (s) => {
  if (!s)
    return !1;
  let e = "";
  try {
    e = JSON.stringify(s);
  } catch (r) {
    return !1;
  }
  const t = wb(e), i = xe(
    Ye.SEGMENT_LAST_SENT_HASH_KEY
  );
  return i === void 0 ? (Be(Ye.SEGMENT_LAST_SENT_HASH_KEY, t), !0) : t !== i ? (Be(Ye.SEGMENT_LAST_SENT_HASH_KEY, t), !0) : !1;
}, wb = (s) => {
  var e = 0, t = s.length, i = 0;
  if (t > 0) for (; i < t; ) e = (e << 5) - e + s.charCodeAt(i++) | 0;
  return e.toString();
}, Cb = (s, e) => {
  const t = vb(s);
  let i = [];
  const r = !1, n = !0;
  for (let o = 0; o < t.length; o++) {
    let a = t[o].split("+");
    i = [], a.length > 1 && (i = Yb(nc, a)), a = a[a.length - 1], a = a === "*" ? "*" : Lb(a), a in Ce || (Ce[a] = []), Ce[a].push({
      mods: i,
      shortcut: t[o],
      key: t[o],
      method: e,
      keyup: r,
      keydown: n,
      scope: "all",
      splitKey: "+"
    });
  }
  kb(document, "keydown", (o) => {
    Tb(o);
  });
};
let ae = [];
function vb(s) {
  typeof s != "string" && (s = ""), s = s.replace(/\s/g, "");
  const e = s.split(",");
  let t = e.lastIndexOf("");
  for (; t >= 0; )
    e[t - 1] += ",", e.splice(t, 1), t = e.lastIndexOf("");
  return e;
}
const Ce = {}, js = typeof navigator != "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1, xb = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": js ? 173 : 189,
  "=": js ? 61 : 187,
  ";": js ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, Fo = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, ce = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, nc = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, Lb = (s) => (
  // @ts-expect-error
  xb[s.toLowerCase()] || // @ts-expect-error
  nc[s.toLowerCase()] || s.toUpperCase().charCodeAt(0)
);
function Yb(s, e) {
  const t = e.slice(0, e.length - 1);
  for (let i = 0; i < t.length; i++)
    t[i] = s[t[i].toLowerCase()];
  return t;
}
function kb(s, e, t) {
  s.addEventListener ? s.addEventListener(e, t, !1) : s.attachEvent && s.attachEvent(`on${e}`, () => {
    t(window.event);
  });
}
function Nb(s, e, t) {
  let i;
  if (e.scope === t || e.scope === "all") {
    i = e.mods.length > 0;
    for (const r in ce)
      Object.prototype.hasOwnProperty.call(ce, r) && // @ts-expect-error
      (!ce[r] && e.mods.indexOf(+r) > -1 || // @ts-expect-error
      ce[r] && e.mods.indexOf(+r) === -1) && (i = !1);
    (e.mods.length === 0 && !ce[16] && !ce[18] && !ce[17] && !ce[91] || i || e.shortcut === "*") && e.method(s, e) === !1 && (s.preventDefault ? s.preventDefault() : s.returnValue = !1, s.stopPropagation && s.stopPropagation(), s.cancelBubble && (s.cancelBubble = !0));
  }
}
function Tb(s) {
  const e = Ce["*"];
  let t = s.keyCode || s.which || s.charCode;
  if ((t === 93 || t === 224) && (t = 91), ae.indexOf(t) === -1 && t !== 229 && ae.push(t), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((i) => {
    const r = Fo[i];
    s[i] && ae.indexOf(r) === -1 ? ae.push(r) : !s[i] && ae.indexOf(r) > -1 ? ae.splice(ae.indexOf(r), 1) : i === "metaKey" && s[i] && ae.length === 3 && (s.ctrlKey || s.shiftKey || s.altKey || (ae = ae.slice(ae.indexOf(r))));
  }), !(t in ce && (ce[t] = !0, !e))) {
    for (const i in ce)
      Object.prototype.hasOwnProperty.call(ce, i) && (ce[i] = s[Fo[i]]);
    if (s.getModifierState && !(s.altKey && !s.ctrlKey) && s.getModifierState("AltGraph") && (ae.indexOf(17) === -1 && ae.push(17), ae.indexOf(18) === -1 && ae.push(18), ce[17] = !0, ce[18] = !0), t in Ce) {
      for (let i = 0; i < Ce[t].length; i++)
        if (
          // @ts-expect-error
          (s.type === "keydown" && Ce[t][i].keydown || // @ts-expect-error
          s.type === "keyup" && Ce[t][i].keyup) && Ce[t][i].key
        ) {
          const r = Ce[t][i];
          Nb(s, r, "all");
        }
    }
  }
}
const Jb = (s) => {
  let e;
  const i = () => {
    clearTimeout(e), e = setTimeout(() => {
      var r, n;
      s({
        height: window.innerHeight,
        width: window.innerWidth,
        availHeight: window.screen.availHeight,
        availWidth: window.screen.availWidth,
        colorDepth: window.screen.colorDepth,
        pixelDepth: window.screen.pixelDepth,
        orientation: (n = (r = window.screen.orientation) == null ? void 0 : r.angle) != null ? n : 0
      });
    }, 500);
  };
  return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
};
var He, Nt, oc, ts, Ur, lc = -1, Qe = function(s) {
  addEventListener("pageshow", function(e) {
    e.persisted && (lc = e.timeStamp, s(e));
  }, !0);
}, hn = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, fs = function() {
  var s = hn();
  return s && s.activationStart || 0;
}, be = function(s, e) {
  var t = hn(), i = "navigate";
  return lc >= 0 ? i = "back-forward-cache" : t && (document.prerendering || fs() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : t.type && (i = t.type.replace(/_/g, "-"))), { name: s, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: i };
}, bt = function(s, e, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(s)) {
      var i = new PerformanceObserver(function(r) {
        Promise.resolve().then(function() {
          e(r.getEntries());
        });
      });
      return i.observe(Object.assign({ type: s, buffered: !0 }, t || {})), i;
    }
  } catch (r) {
  }
}, ye = function(s, e, t, i) {
  var r, n;
  return function(o) {
    e.value >= 0 && (o || i) && ((n = e.value - (r || 0)) || r === void 0) && (r = e.value, e.delta = n, e.rating = function(a, l) {
      return a > l[1] ? "poor" : a > l[0] ? "needs-improvement" : "good";
    }(e.value, t), s(e));
  };
}, pn = function(s) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return s();
    });
  });
}, bs = function(s) {
  var e = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || s(t);
  };
  addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
}, mn = function(s) {
  var e = !1;
  return function(t) {
    e || (s(t), e = !0);
  };
}, lt = -1, Ko = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, is = function(s) {
  document.visibilityState === "hidden" && lt > -1 && (lt = s.type === "visibilitychange" ? s.timeStamp : 0, Ub());
}, Ho = function() {
  addEventListener("visibilitychange", is, !0), addEventListener("prerenderingchange", is, !0);
}, Ub = function() {
  removeEventListener("visibilitychange", is, !0), removeEventListener("prerenderingchange", is, !0);
}, fn = function() {
  return lt < 0 && (lt = Ko(), Ho(), Qe(function() {
    setTimeout(function() {
      lt = Ko(), Ho();
    }, 0);
  })), { get firstHiddenTime() {
    return lt;
  } };
}, _t = function(s) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return s();
  }, !0) : s();
}, Mo = [1800, 3e3], ac = function(s, e) {
  e = e || {}, _t(function() {
    var t, i = fn(), r = be("FCP"), n = bt("paint", function(o) {
      o.forEach(function(a) {
        a.name === "first-contentful-paint" && (n.disconnect(), a.startTime < i.firstHiddenTime && (r.value = Math.max(a.startTime - fs(), 0), r.entries.push(a), t(!0)));
      });
    });
    n && (t = ye(s, r, Mo, e.reportAllChanges), Qe(function(o) {
      r = be("FCP"), t = ye(s, r, Mo, e.reportAllChanges), pn(function() {
        r.value = performance.now() - o.timeStamp, t(!0);
      });
    }));
  });
}, zo = [0.1, 0.25], Fb = function(s, e) {
  e = e || {}, ac(mn(function() {
    var t, i = be("CLS", 0), r = 0, n = [], o = function(l) {
      l.forEach(function(c) {
        if (!c.hadRecentInput) {
          var u = n[0], d = n[n.length - 1];
          r && c.startTime - d.startTime < 1e3 && c.startTime - u.startTime < 5e3 ? (r += c.value, n.push(c)) : (r = c.value, n = [c]);
        }
      }), r > i.value && (i.value = r, i.entries = n, t());
    }, a = bt("layout-shift", o);
    a && (t = ye(s, i, zo, e.reportAllChanges), bs(function() {
      o(a.takeRecords()), t(!0);
    }), Qe(function() {
      r = 0, i = be("CLS", 0), t = ye(s, i, zo, e.reportAllChanges), pn(function() {
        return t();
      });
    }), setTimeout(t, 0));
  }));
}, vt = { passive: !0, capture: !0 }, Kb = /* @__PURE__ */ new Date(), Oo = function(s, e) {
  He || (He = e, Nt = s, oc = /* @__PURE__ */ new Date(), uc(removeEventListener), cc());
}, cc = function() {
  if (Nt >= 0 && Nt < oc - Kb) {
    var s = { entryType: "first-input", name: He.type, target: He.target, cancelable: He.cancelable, startTime: He.timeStamp, processingStart: He.timeStamp + Nt };
    ts.forEach(function(e) {
      e(s);
    }), ts = [];
  }
}, Hb = function(s) {
  if (s.cancelable) {
    var e = (s.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - s.timeStamp;
    s.type == "pointerdown" ? function(t, i) {
      var r = function() {
        Oo(t, i), o();
      }, n = function() {
        o();
      }, o = function() {
        removeEventListener("pointerup", r, vt), removeEventListener("pointercancel", n, vt);
      };
      addEventListener("pointerup", r, vt), addEventListener("pointercancel", n, vt);
    }(e, s) : Oo(e, s);
  }
}, uc = function(s) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(e) {
    return s(e, Hb, vt);
  });
}, Po = [100, 300], Mb = function(s, e) {
  e = e || {}, _t(function() {
    var t, i = fn(), r = be("FID"), n = function(l) {
      l.startTime < i.firstHiddenTime && (r.value = l.processingStart - l.startTime, r.entries.push(l), t(!0));
    }, o = function(l) {
      l.forEach(n);
    }, a = bt("first-input", o);
    t = ye(s, r, Po, e.reportAllChanges), a && bs(mn(function() {
      o(a.takeRecords()), a.disconnect();
    })), a && Qe(function() {
      var l;
      r = be("FID"), t = ye(s, r, Po, e.reportAllChanges), ts = [], Nt = -1, He = null, uc(addEventListener), l = n, ts.push(l), cc();
    });
  });
}, dc = 0, As = 1 / 0, Ri = 0, zb = function(s) {
  s.forEach(function(e) {
    e.interactionId && (As = Math.min(As, e.interactionId), Ri = Math.max(Ri, e.interactionId), dc = Ri ? (Ri - As) / 7 + 1 : 0);
  });
}, hc = function() {
  return Ur ? dc : performance.interactionCount || 0;
}, Ob = function() {
  "interactionCount" in performance || Ur || (Ur = bt("event", zb, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Eo = [200, 500], pc = 0, Bo = function() {
  return hc() - pc;
}, ve = [], Qs = {}, Do = function(s) {
  var e = ve[ve.length - 1], t = Qs[s.interactionId];
  if (t || ve.length < 10 || s.duration > e.latency) {
    if (t) t.entries.push(s), t.latency = Math.max(t.latency, s.duration);
    else {
      var i = { id: s.interactionId, latency: s.duration, entries: [s] };
      Qs[i.id] = i, ve.push(i);
    }
    ve.sort(function(r, n) {
      return n.latency - r.latency;
    }), ve.splice(10).forEach(function(r) {
      delete Qs[r.id];
    });
  }
}, Pb = function(s, e) {
  e = e || {}, _t(function() {
    var t;
    Ob();
    var i, r = be("INP"), n = function(a) {
      a.forEach(function(u) {
        u.interactionId && Do(u), u.entryType === "first-input" && !ve.some(function(d) {
          return d.entries.some(function(h) {
            return u.duration === h.duration && u.startTime === h.startTime;
          });
        }) && Do(u);
      });
      var l, c = (l = Math.min(ve.length - 1, Math.floor(Bo() / 50)), ve[l]);
      c && c.latency !== r.value && (r.value = c.latency, r.entries = c.entries, i());
    }, o = bt("event", n, { durationThreshold: (t = e.durationThreshold) !== null && t !== void 0 ? t : 40 });
    i = ye(s, r, Eo, e.reportAllChanges), o && ("interactionId" in PerformanceEventTiming.prototype && o.observe({ type: "first-input", buffered: !0 }), bs(function() {
      n(o.takeRecords()), r.value < 0 && Bo() > 0 && (r.value = 0, r.entries = []), i(!0);
    }), Qe(function() {
      ve = [], pc = hc(), r = be("INP"), i = ye(s, r, Eo, e.reportAllChanges);
    }));
  });
}, jo = [2500, 4e3], _s = {}, Eb = function(s, e) {
  e = e || {}, _t(function() {
    var t, i = fn(), r = be("LCP"), n = function(l) {
      var c = l[l.length - 1];
      c && c.startTime < i.firstHiddenTime && (r.value = Math.max(c.startTime - fs(), 0), r.entries = [c], t());
    }, o = bt("largest-contentful-paint", n);
    if (o) {
      t = ye(s, r, jo, e.reportAllChanges);
      var a = mn(function() {
        _s[r.id] || (n(o.takeRecords()), o.disconnect(), _s[r.id] = !0, t(!0));
      });
      ["keydown", "click"].forEach(function(l) {
        addEventListener(l, function() {
          return setTimeout(a, 0);
        }, !0);
      }), bs(a), Qe(function(l) {
        r = be("LCP"), t = ye(s, r, jo, e.reportAllChanges), pn(function() {
          r.value = performance.now() - l.timeStamp, _s[r.id] = !0, t(!0);
        });
      });
    }
  });
}, Ao = [800, 1800], Bb = function s(e) {
  document.prerendering ? _t(function() {
    return s(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return s(e);
  }, !0) : setTimeout(e, 0);
}, Db = function(s, e) {
  e = e || {};
  var t = be("TTFB"), i = ye(s, t, Ao, e.reportAllChanges);
  Bb(function() {
    var r = hn();
    if (r) {
      var n = r.responseStart;
      if (n <= 0 || n > performance.now()) return;
      t.value = Math.max(n - fs(), 0), t.entries = [r], i(!0), Qe(function() {
        t = be("TTFB", 0), (i = ye(s, t, Ao, e.reportAllChanges))(!0);
      });
    }
  });
};
const jb = (s) => (Fb(s), ac(s), Mb(s), Eb(s), Db(s), Pb(s), () => {
}), tt = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, Ab = (s, e) => {
  const t = () => {
    const n = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3;
    s({
      relativeTimestamp: n,
      downlink: tt.downlink,
      downlinkMax: tt.downlinkMax,
      effectiveType: tt.effectiveType,
      rtt: tt.rtt,
      saveData: tt.saveData,
      type: tt.type
    });
  };
  t();
  let i;
  return i = setInterval(() => {
    t();
  }, 1e3), () => {
    clearInterval(i);
  };
};
class Qb {
  constructor(e, t) {
    x(this, "debug");
    x(this, "name");
    this.debug = e, this.name = t;
  }
  log(...e) {
    if (this.debug) {
      let t = `[${Date.now()}]`;
      this.name && (t += ` - ${this.name}`), console.log.apply(console, [t, ...e]);
    }
  }
}
const Qo = "iframe parent ready", _o = "iframe ok", Et = "highlightLogs", _b = (s) => {
  let e = xe(Et) || "";
  e = e + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + s + `
`, Be(Et, e);
}, $b = () => xe(Et) || "", qb = (s) => {
  if (!s)
    return;
  let e = xe(Et) || "";
  e && (e.startsWith(s) ? (e = e.slice(s.length), Be(Et, e)) : _b(
    "Unable to clear logs " + s.replace(`
`, " ") + " from " + e.replace(`
`, " ")
  ));
}, ey = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const s = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: ty(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const i = $s(
        s.memory.jsHeapSizeLimit
      ), r = $s(
        s.memory.totalJSHeapSize
      ), n = $s(
        s.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: i,
        totalJSHeapSize: r,
        usedJSHeapSize: n
      };
    }
  };
}, $s = (s) => s / Math.pow(1e3, 2), ty = (s) => 1024 * s, mc = "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", iy = (s) => Uint8Array.from(atob(s), (e) => e.charCodeAt(0)), $o = typeof self != "undefined" && self.Blob && new Blob([iy(mc)], { type: "text/javascript;charset=utf-8" });
function sy(s) {
  let e;
  try {
    if (e = $o && (self.URL || self.webkitURL).createObjectURL($o), !e) throw "";
    const t = new Worker(e, {
      name: s == null ? void 0 : s.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + mc,
      {
        name: s == null ? void 0 : s.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
var Le = /* @__PURE__ */ ((s) => (s[s.Initialize = 0] = "Initialize", s[s.AsyncEvents = 1] = "AsyncEvents", s[s.Identify = 2] = "Identify", s[s.Properties = 3] = "Properties", s[s.Metrics = 4] = "Metrics", s[s.Feedback = 5] = "Feedback", s[s.CustomEvent = 6] = "CustomEvent", s[s.Stop = 7] = "Stop", s))(Le || {});
const Ct = (s, e) => {
  console.warn(`Highlight Warning: (${s}): `, { output: e });
};
class fc {
  constructor(e, t) {
    x(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    x(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    x(this, "organizationID");
    x(this, "graphqlSDK");
    x(this, "events");
    x(this, "sessionData");
    x(this, "ready");
    x(this, "manualStopped");
    x(this, "state");
    x(this, "logger");
    x(this, "enableSegmentIntegration");
    x(this, "privacySetting");
    x(this, "enableCanvasRecording");
    x(this, "enablePerformanceRecording");
    x(this, "samplingStrategy");
    x(this, "inlineImages");
    x(this, "inlineVideos");
    x(this, "inlineStylesheet");
    x(this, "debugOptions");
    x(this, "listeners");
    x(this, "firstloadVersion");
    x(this, "environment");
    x(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    x(this, "appVersion");
    x(this, "serviceName");
    x(this, "_worker");
    x(this, "_optionsInternal");
    x(this, "_backendUrl");
    x(this, "_recordingStartTime");
    x(this, "_isOnLocalHost");
    x(this, "_onToggleFeedbackFormVisibility");
    x(this, "_firstLoadListeners");
    x(this, "_isCrossOriginIframe");
    x(this, "_eventBytesSinceSnapshot");
    x(this, "_lastSnapshotTime");
    x(this, "_lastVisibilityChangeTime");
    x(this, "pushPayloadTimerId");
    x(this, "hasSessionUnloaded");
    x(this, "hasPushedData");
    x(this, "reloaded");
    x(this, "_hasPreviouslyInitialized");
    x(this, "_recordStop");
    x(this, "_gauges", /* @__PURE__ */ new Map());
    x(this, "_counters", /* @__PURE__ */ new Map());
    x(this, "_histograms", /* @__PURE__ */ new Map());
    x(this, "_up_down_counters", /* @__PURE__ */ new Map());
    x(this, "_integrations", []);
    var r, n, o, a, l;
    e.sessionSecureID || (e.sessionSecureID = Ws()), this.options = e, typeof ((r = this.options) == null ? void 0 : r.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (o = (n = this.options) == null ? void 0 : n.debug) != null ? o : {}, this.logger = new Qb(this.debugOptions.clientInteractions), e.storageMode && (this.logger.log(
      `initializing in ${e.storageMode} session mode`
    ), Hc(e.storageMode)), Kc(!!(e != null && e.sessionCookie)), this._worker = new sy(), this._worker.onmessage = (c) => {
      var u, d, h;
      ((u = c.data.response) == null ? void 0 : u.type) === Le.AsyncEvents ? (this._eventBytesSinceSnapshot += c.data.response.eventsSize, this.logger.log(
        `Web worker sent payloadID ${c.data.response.id} size ${c.data.response.eventsSize} bytes, compression ratio ${c.data.response.eventsSize / c.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`
      )) : ((d = c.data.response) == null ? void 0 : d.type) === Le.CustomEvent ? this.addCustomEvent(
        c.data.response.tag,
        c.data.response.payload
      ) : ((h = c.data.response) == null ? void 0 : h.type) === Le.Stop && (Ct(
        "Stopping recording due to worker failure",
        c.data.response
      ), this.stopRecording(!1));
    };
    let i = Vn();
    if (this.reloaded = !1, !((a = this.sessionData) != null && a.sessionSecureID) && (i != null && i.sessionSecureID))
      this.sessionData = i, this.options.sessionSecureID = i.sessionSecureID, this.reloaded = !0, this.logger.log(
        `Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`
      );
    else {
      for (const c of Object.values(Ye))
        Xn(c);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        payloadID: 1,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1, this._firstLoadListeners = t || new _e(this.options);
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (c) {
      this._isCrossOriginIframe = (l = this.options.recordCrossOriginIframe) != null ? l : !0;
    }
    this._initMembers(this.options);
  }
  static create(e) {
    return new fc(e);
  }
  // Start a new session
  _reset(t) {
    return re(this, arguments, function* ({ forceNew: e }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let i, r;
      if (!e)
        try {
          i = xe(Ye.USER_IDENTIFIER);
          const n = xe(
            Ye.USER_OBJECT
          );
          n && (r = JSON.parse(n));
        } catch (n) {
        }
      for (const n of Object.values(Ye))
        Xn(n);
      this.sessionData.sessionSecureID = Ws(), this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stopRecording(), this._firstLoadListeners = new _e(this.options), yield this.initialize(), i && r && this.identify(i, r);
    });
  }
  _initMembers(e) {
    var n, o, a, l, c, u, d, h, p, b, f, m;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (n = e.privacySetting) != null ? n : "default", this.enableCanvasRecording = (o = e.enableCanvasRecording) != null ? o : !1, this.enablePerformanceRecording = (a = e.enablePerformanceRecording) != null ? a : !0, this.inlineImages = (l = e.inlineImages) != null ? l : this._isOnLocalHost, this.inlineVideos = (c = e.inlineVideos) != null ? c : this._isOnLocalHost, this.inlineStylesheet = (u = e.inlineStylesheet) != null ? u : this._isOnLocalHost, this.samplingStrategy = S({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: kc()
    }, (d = e.samplingStrategy) != null ? d : {
      canvas: 2
    }), this._backendUrl = (h = e == null ? void 0 : e.backendUrl) != null ? h : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const t = new ou(`${this._backendUrl}`, {
      headers: {}
    });
    this.graphqlSDK = eb(
      t,
      Mc(
        ((p = this.sessionData) == null ? void 0 : p.sessionSecureID) || ((b = this.options) == null ? void 0 : b.sessionSecureID)
      )
    ), this.environment = (f = e.environment) != null ? f : "production", this.appVersion = e.appVersion, this.serviceName = (m = e.serviceName) != null ? m : "", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const X = e, { firstloadVersion: i } = X, r = pe(X, ["firstloadVersion"]);
    this._optionsInternal = r, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(e, t = {}, i) {
    if (!e || e === "") {
      console.warn(
        "Highlight's identify() call was passed an empty identifier.",
        { user_identifier: e, user_object: t }
      );
      return;
    }
    this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = t, Be(
      Ye.USER_IDENTIFIER,
      e.toString()
    ), Be(Ye.USER_OBJECT, JSON.stringify(t)), this._worker.postMessage({
      message: {
        type: Le.Identify,
        userIdentifier: e,
        userObject: t,
        source: i
      }
    });
    for (const r of this._integrations)
      r.identify(
        this.sessionData.sessionSecureID,
        e,
        t,
        i
      );
  }
  pushCustomError(e, t) {
    return this.consumeCustomError(new Error(e), void 0, t);
  }
  consumeCustomError(e, t, i) {
    let r = {};
    if (i)
      try {
        r = S(S({}, JSON.parse(i)), r);
      } catch (n) {
      }
    return this.consumeError(e, {
      message: t,
      payload: r
    });
  }
  consumeError(e, {
    message: t,
    payload: i,
    source: r,
    type: n
  }) {
    var c, u, d, h;
    e.cause && (i = $(S({}, i), { "exception.cause": e.cause }));
    let o = t ? t + ":" + e.message : e.message;
    n === "React.ErrorBoundary" && (o = "ErrorBoundary: " + o);
    const a = Nc(e), l = {
      event: o,
      type: n != null ? n : "custom",
      url: window.location.href,
      source: r != null ? r : "",
      lineNumber: (c = a[0]) != null && c.lineNumber ? (u = a[0]) == null ? void 0 : u.lineNumber : 0,
      columnNumber: (d = a[0]) != null && d.columnNumber ? (h = a[0]) == null ? void 0 : h.columnNumber : 0,
      stackTrace: a,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: JSON.stringify(i)
    };
    this._firstLoadListeners.errors.push(l);
    for (const p of this._integrations)
      p.error(this.sessionData.sessionSecureID, l);
  }
  addProperties(e = {}, t) {
    const i = S({}, e);
    Object.entries(i).forEach(([r, n]) => {
      try {
        structuredClone(n);
      } catch (o) {
        delete i[r];
      }
    });
    for (const r of this._integrations)
      r.track(this.sessionData.sessionSecureID, S({
        sessionSecureID: this.sessionData.sessionSecureID,
        propertyType: t
      }, e));
    this._worker.postMessage({
      message: {
        type: Le.Properties,
        propertiesObject: i,
        propertyType: t
      }
    });
  }
  initialize(e) {
    return re(this, null, function* () {
      var t, i, r, n, o, a, l, c, u;
      if (navigator != null && navigator.webdriver && !window.Cypress || (t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Googlebot") || (i = navigator == null ? void 0 : navigator.userAgent) != null && i.includes("AdsBot")) {
        (r = this._firstLoadListeners) == null || r.stopListening();
        return;
      }
      try {
        if (e != null && e.forceNew) {
          yield this._reset(e);
          return;
        }
        this.logger.log(
          "Initializing...",
          e,
          this.sessionData,
          this.options
        ), this.sessionData = (n = Vn(this.sessionData.sessionSecureID)) != null ? n : this.sessionData, (o = this.sessionData) != null && o.sessionStartTime ? this._recordingStartTime = (a = this.sessionData) == null ? void 0 : a.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime), Rs(""), gt(this.sessionData);
        let d = xe(
          "highlightClientID"
          /* CLIENT_ID */
        );
        d || (d = Ws(), Be("highlightClientID", d));
        let h;
        this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? h = !1 : h = ((l = this.options.networkRecording) == null ? void 0 : l.recordHeadersAndBody) || !1;
        let p = [];
        if (typeof this.options.networkRecording == "object" && ((c = this.options.networkRecording.destinationDomains) != null && c.length) && (p = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
          yield this._setupCrossOriginIframe();
        else {
          const Z = yield this.graphqlSDK.initializeSession({
            organization_verbose_id: this.organizationID,
            enable_strict_privacy: this.privacySetting === "strict",
            privacy_setting: this.privacySetting,
            enable_recording_network_contents: h,
            clientVersion: this.firstloadVersion,
            firstloadVersion: this.firstloadVersion,
            clientConfig: JSON.stringify(this._optionsInternal),
            environment: this.environment,
            id: d,
            appVersion: this.appVersion,
            serviceName: this.serviceName,
            session_secure_id: this.sessionData.sessionSecureID,
            client_id: d,
            network_recording_domains: p,
            disable_session_recording: this.options.disableSessionRecording
          });
          if (Z.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(
            `Unexpected secure id returned by initializeSession: ${Z.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`
          ), this.sessionData.sessionSecureID = Z.initializeSession.secure_id, this.sessionData.projectID = parseInt(
            ((u = Z == null ? void 0 : Z.initializeSession) == null ? void 0 : u.project_id) || "0"
          ), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
            console.error(
              "Failed to initialize Highlight; an error occurred on our end.",
              this.sessionData
            );
            return;
          }
        }
        if (this.logger.log(
          `Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
        ), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
          message: {
            type: Le.Initialize,
            sessionSecureID: this.sessionData.sessionSecureID,
            backend: this._backendUrl,
            debug: !!this.debugOptions.clientInteractions,
            recordingStartTime: this._recordingStartTime
          }
        }), this.sessionData.userIdentifier && this.identify(
          this.sessionData.userIdentifier,
          this.sessionData.userObject
        ), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || _e.setupNetworkListener(
          this._firstLoadListeners,
          this.options
        ) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
          this._save();
        }, Wn)), this.options.disableSessionRecording) {
          this.logger.log(
            "Highlight is NOT RECORDING a session replay per H.init setting."
          ), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
          return;
        }
        const { getDeviceDetails: b } = ey();
        b && this.recordGauge({
          name: $e.DeviceMemory,
          value: b().deviceMemory,
          category: We.Device,
          group: window.location.href
        });
        const f = (Z, W) => {
          W && this.logger.log("received isCheckout emit", { event: Z }), this.events.push(Z);
        };
        f.bind(this);
        const m = !!this._recordStop;
        this._recordStop && (this._recordStop(), this._recordStop = void 0);
        const [X, R] = ib(
          this.privacySetting
        );
        this._recordStop = ke({
          ignoreClass: "highlight-ignore",
          blockClass: "highlight-block",
          emit: f,
          recordCrossOriginIframes: this.options.recordCrossOriginIframe,
          privacySetting: this.privacySetting,
          maskAllInputs: X,
          maskInputOptions: R,
          recordCanvas: this.enableCanvasRecording,
          sampling: {
            canvas: {
              fps: this.samplingStrategy.canvas,
              fpsManual: this.samplingStrategy.canvasManualSnapshot,
              resizeFactor: this.samplingStrategy.canvasFactor,
              clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
              initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
              dataURLOptions: this.samplingStrategy.dataUrlOptions,
              maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
            }
          },
          keepIframeSrcFn: (Z) => !this.options.recordCrossOriginIframe,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          collectFonts: this.inlineImages,
          inlineStylesheet: this.inlineStylesheet,
          plugins: [du()],
          logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
            debug: this.logger.log,
            warn: Ct
          } : void 0
        }), m || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties(
          { referrer: document.referrer },
          { type: "session" }
        ))), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
        for (const Z of this._integrations)
          Z.init(this.sessionData.sessionSecureID);
      } catch (d) {
        this._isOnLocalHost && (console.error(d), Ct("initializeSession", d));
      }
    });
  }
  _visibilityHandler(e) {
    return re(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < Tc || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return re(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
        const t = (i) => {
          if (i.data.highlight === Qo) {
            const r = i.data;
            this.logger.log("highlight got window message ", r), this.sessionData.projectID = r.projectID, this.sessionData.sessionSecureID = r.sessionSecureID, window.parent.postMessage(
              {
                highlight: _o
              },
              "*"
            ), window.removeEventListener("message", t), e();
          }
        };
        window.addEventListener("message", t);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log(
      "highlight setting up cross origin iframe parent notification"
    ), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((e) => {
        var t;
        (t = e.contentWindow) == null || t.postMessage(
          {
            highlight: Qo,
            projectID: this.sessionData.projectID,
            sessionSecureID: this.sessionData.sessionSecureID
          },
          "*"
        );
      });
    }, Wn), window.addEventListener("message", (e) => {
      e.data.highlight === _o && this.logger.log(
        "highlight got response from initialized iframe"
      );
    });
  }
  _setupWindowListeners() {
    var i;
    try {
      const r = this;
      this.enableSegmentIntegration && this.listeners.push(
        Rb((o) => {
          if (o.type === "track") {
            const a = {};
            a["segment-event"] = o.event, r.addProperties(a, {
              type: "track",
              source: "segment"
            });
          } else if (o.type === "identify") {
            const a = o.userId.replace(
              /^"(.*)"$/,
              "$1"
            );
            r.identify(
              a,
              o.traits,
              "segment"
            );
          }
        })
      ), this.listeners.push(
        tb((o) => {
          this.reloaded ? (this.addCustomEvent("Reload", o), this.reloaded = !1, r.addProperties(
            { reload: !0 },
            { type: "session" }
          )) : this.addCustomEvent("Navigate", o);
        })
      ), this.listeners.push(
        Jb(
          (o) => {
            this.addCustomEvent("Viewport", o), this.submitViewportMetrics(o);
          }
        )
      ), this.listeners.push(
        yb((o, a) => {
          let l = null, c = null;
          if (a && a.target) {
            const u = a.target;
            l = ec(u), c = u.textContent, c && c.length > 2e3 && (c = c.substring(0, 2e3));
          }
          this.addCustomEvent("Click", {
            clickTarget: o,
            clickTextContent: c,
            clickSelector: l
          });
        })
      ), this.listeners.push(
        gb((o) => {
          o && this.addCustomEvent("Focus", o);
        })
      ), this.listeners.push(
        jb((o) => {
          const { name: a, value: l } = o;
          this.recordGauge({
            name: a,
            value: l,
            group: window.location.href,
            category: We.WebVital
          });
        })
      ), this.listeners.push(
        Ab(
          (o) => {
            const a = [];
            o.saveData !== void 0 && a.push({
              name: "saveData",
              value: o.saveData.toString()
            }), o.effectiveType !== void 0 && a.push({
              name: "effectiveType",
              value: o.effectiveType.toString()
            }), o.type !== void 0 && a.push({
              name: "type",
              value: o.type.toString()
            }), Object.entries(o).forEach(
              ([l, c]) => c && typeof c == "number" && this.recordGauge({
                name: l,
                value: c,
                category: We.Performance,
                group: window.location.href,
                tags: a
              })
            );
          },
          this._recordingStartTime
        )
      ), this.sessionShortcut && Cb(this.sessionShortcut, () => {
        window.open(
          this.getCurrentSessionURLWithTimestamp(),
          "_blank"
        );
      }), this.enablePerformanceRecording && (this.listeners.push(
        Wb((o) => {
          this.addCustomEvent("Performance", ws(o)), Object.entries(o).filter(([a]) => a !== "relativeTimestamp").forEach(
            ([a, l]) => l && this.recordGauge({
              name: a,
              value: l,
              category: We.Performance,
              group: window.location.href
            })
          );
        }, this._recordingStartTime)
      ), this.listeners.push(
        Sb((o) => {
          this.addCustomEvent("Jank", ws(o)), this.recordGauge({
            name: "Jank",
            value: o.jankAmount,
            category: We.WebVital,
            group: o.querySelector
          });
        }, this._recordingStartTime)
      )), this._hasPreviouslyInitialized || ((i = window.electron) != null && i.ipcRenderer ? (window.electron.ipcRenderer.on(
        "highlight.run",
        ({ visible: o }) => {
          this._visibilityHandler(!o);
        }
      ), this.logger.log("Set up Electron highlight.run events.")) : (Vb(
        (o) => this._visibilityHandler(o)
      ), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const n = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", n), this.listeners.push(
        () => window.removeEventListener("beforeunload", n)
      );
    } catch (r) {
      this._isOnLocalHost && (console.error(r), Ct("initializeSession _setupWindowListeners", r));
    }
    const e = () => {
      this.addCustomEvent("Page Unload", ""), Rs(this.sessionData.sessionSecureID), gt(this.sessionData);
    };
    if (window.addEventListener("beforeunload", e), this.listeners.push(
      () => window.removeEventListener("beforeunload", e)
    ), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const r = () => {
        this.addCustomEvent("Page Unload", ""), Rs(this.sessionData.sessionSecureID), gt(this.sessionData);
      };
      window.addEventListener("pagehide", r), this.listeners.push(
        () => window.removeEventListener("beforeunload", r)
      );
    }
  }
  submitViewportMetrics({
    height: e,
    width: t,
    availHeight: i,
    availWidth: r
  }) {
    this.recordGauge({
      name: $e.ViewportHeight,
      value: e,
      category: We.Device,
      group: window.location.href
    }), this.recordGauge({
      name: $e.ViewportWidth,
      value: t,
      category: We.Device,
      group: window.location.href
    }), this.recordGauge({
      name: $e.ScreenHeight,
      value: i,
      category: We.Device,
      group: window.location.href
    }), this.recordGauge({
      name: $e.ScreenWidth,
      value: r,
      category: We.Device,
      group: window.location.href
    }), this.recordGauge({
      name: $e.ViewportArea,
      value: e * t,
      category: We.Device,
      group: window.location.href
    });
  }
  recordGauge(e) {
    var r;
    const t = typeof Ue == "function" ? Ue() : void 0;
    if (!t) return;
    let i = this._gauges.get(e.name);
    i || (i = t.createGauge(e.name), this._gauges.set(e.name, i)), i.record(e.value, $(S({}, (r = e.tags) == null ? void 0 : r.reduce((n, o) => $(S({}, n), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
    for (const n of this._integrations)
      n.recordMetric(this.sessionData.sessionSecureID, e);
  }
  recordCount(e) {
    var r;
    const t = typeof Ue == "function" ? Ue() : void 0;
    if (!t) return;
    let i = this._counters.get(e.name);
    i || (i = t.createCounter(e.name), this._counters.set(e.name, i)), i.add(e.value, $(S({}, (r = e.tags) == null ? void 0 : r.reduce((n, o) => $(S({}, n), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordIncr(e) {
    this.recordCount($(S({}, e), { value: 1 }));
  }
  recordHistogram(e) {
    var r;
    const t = typeof Ue == "function" ? Ue() : void 0;
    if (!t) return;
    let i = this._histograms.get(e.name);
    i || (i = t.createHistogram(e.name), this._histograms.set(e.name, i)), i.record(e.value, $(S({}, (r = e.tags) == null ? void 0 : r.reduce((n, o) => $(S({}, n), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordUpDownCounter(e) {
    var r;
    const t = typeof Ue == "function" ? Ue() : void 0;
    if (!t) return;
    let i = this._up_down_counters.get(e.name);
    i || (i = t.createUpDownCounter(e.name), this._up_down_counters.set(e.name, i)), i.add(e.value, $(S({}, (r = e.tags) == null ? void 0 : r.reduce((n, o) => $(S({}, n), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stopRecording(e) {
    this.manualStopped = !!e, this.manualStopped && this.addCustomEvent(
      "Stop",
      "H.stop() was called which stops Highlight from recording."
    ), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((t) => t()), this.listeners = [];
  }
  getCurrentSessionTimestamp() {
    return this._recordingStartTime;
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: t, sessionSecureID: i } = this.sessionData, r = (e - this._recordingStartTime) / 1e3;
    return `https://${Rn}/${t}/sessions/${i}?ts=${r}`;
  }
  getCurrentSessionURL() {
    const e = this.sessionData.projectID, t = this.sessionData.sessionSecureID;
    return e && t ? `https://${Rn}/${e}/sessions/${t}` : null;
  }
  snapshot(e) {
    return re(this, null, function* () {
      yield ke.snapshotCanvas(e);
    });
  }
  addSessionFeedback({
    timestamp: e,
    verbatim: t,
    user_email: i,
    user_name: r
  }) {
    var n;
    this._worker.postMessage({
      message: {
        type: Le.Feedback,
        verbatim: t,
        timestamp: e,
        userName: r || this.sessionData.userIdentifier,
        userEmail: i || ((n = this.sessionData.userObject) == null ? void 0 : n.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return re(this, null, function* () {
      var e;
      try {
        this.state === "Recording" && this.listeners && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > Jc && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let t;
        ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (t = (i) => re(this, null, function* () {
          let r = new Blob(
            [
              JSON.stringify({
                query: el($a),
                variables: i
              })
            ],
            {
              type: "application/json"
            }
          );
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: r
          }), 0;
        })), yield this._sendPayload({ sendFn: t }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), gt(this.sessionData);
      } catch (t) {
        this._isOnLocalHost && (console.error(t), Ct("_save", t));
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, Uc));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(e, t) {
    if (this.state === "NotRecording") {
      let i;
      const r = () => {
        clearInterval(i), this.state === "Recording" && this.events.length > 0 ? Yo(e, t) : i = setTimeout(r, 500);
      };
      i = setTimeout(r, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && Yo(e, t);
  }
  _sendPayload(t) {
    return re(this, arguments, function* ({
      sendFn: e
    }) {
      const i = _e.getRecordedNetworkResources(
        this._firstLoadListeners,
        this._recordingStartTime
      ), r = _e.getRecordedWebSocketEvents(
        this._firstLoadListeners
      ), n = [...this.events], o = [...this._firstLoadListeners.messages], a = [...this._firstLoadListeners.errors], { bytes: l, time: c } = this.enableCanvasRecording ? wn.canvas : wn.normal;
      this._eventBytesSinceSnapshot >= l && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= c && this.takeFullSnapshot(), this.logger.log(
        `Sending: ${n.length} events, ${o.length} messages, ${i.length} network resources, ${a.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
      );
      const u = $b();
      e ? yield e({
        session_secure_id: this.sessionData.sessionSecureID,
        payload_id: (this.sessionData.payloadID++).toString(),
        events: { events: n },
        messages: ws({ messages: o }),
        resources: JSON.stringify({ resources: i }),
        web_socket_events: JSON.stringify({
          webSocketEvents: r
        }),
        errors: a,
        is_beacon: !1,
        has_session_unloaded: this.hasSessionUnloaded,
        highlight_logs: u || void 0
      }) : this._worker.postMessage({
        message: {
          type: Le.AsyncEvents,
          id: this.sessionData.payloadID++,
          events: n,
          messages: o,
          errors: a,
          resourcesString: JSON.stringify({ resources: i }),
          webSocketEventsString: JSON.stringify({
            webSocketEvents: r
          }),
          hasSessionUnloaded: this.hasSessionUnloaded,
          highlightLogs: u
        }
      }), gt(this.sessionData), _e.clearRecordedNetworkResources(
        this._firstLoadListeners
      ), this.events = this.events.slice(n.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(o.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(
        a.length
      ), qb(u);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), ke.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  registerLD(e) {
    this._integrations.push(new Fc(e));
  }
}
export {
  _e as FirstLoadListeners,
  Ws as GenerateSecureID,
  fc as Highlight,
  Ct as HighlightWarning,
  We as MetricCategory,
  Ue as getMeter,
  Vn as getPreviousSessionData,
  Hy as getTracer,
  My as setupBrowserTracing
};
//# sourceMappingURL=index-e88gjnpL.js.map
